import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SelectOption } from '../teiasoft-select/teiasoft-select.component';
import { TranslateService } from '@ngx-translate/core';
import { ItemParametersValues, MarketFamily, Mill, Sql, SurfaceTypes, TubeExecution, UomsType } from '../../models/data/itemParametersValues.model';
import * as _ from 'lodash';
import { TTButton } from '../teiasoft-toolbar/teiasoft-toolbar.component';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { BackendService } from '../../services/backend/backend.service';
import { NpsAndSchedule } from '../../models/data/npsAndSchedules.model';
import { Enquiry, EnquiryHeaderItem, EnquiryNpsSchedule } from '../../models/data/enquiry.model';
import { Autocomplete } from '../teiasoft-input/teiasoft-input.component';
import { NormGrade } from '../../models/data/normGrades.model';
import { RawMaterialGrade } from '../../models/data/rawMaterialGrades.model';
import { ItemsFromXlsx } from '../../models/data/itemsFromXlsx.model';
import { UtilsService } from '../../services/utils/utils.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { ItemSms } from '../../models/data/itemsByEnquiryNo.model';
import { Globals } from '../../globals/globals';
import { LimitationsForNormGrades } from '../../models/data/limitationsForNormGrades.model';
import { ItemLimitation } from '../../models/data/itemToUpdate.model';
import { firstValueFrom, from, Observable, of, Subject, Subscription } from 'rxjs';
import { TeiasoftModalService } from '../../services/teiasoft-bucket/teiasoft-modal.service';
import { RoundDigit } from '../../models/data/roundDigit.model';
import { GridColumn, GridConfiguration, ODataGridFilterMap } from '../teiasoft-grid-odata/teiasoft-grid-odata.component';
import { Uom } from '../../models/data/headerParametersValues.model';
import { ResizableColumnsService } from '../../services/resize-columns/resizable-columns.service';
import { RawMaterialGradesService } from '../../services/backend/raw-material-grades.service';
import { Material } from '../../models/data/materials.model';
import { DimType, ItemAttributesByMaterialCode } from '../../models/data/itemAttributesByMaterialCode.model';
import { de } from 'date-fns/locale';
import { getDateOnlyDisplayDate, getDateOnlyKey } from '../../utils/date-only.utils';
declare var $: any;

export class DataSheet {
  colName?: string;
  colValue?: any[];
  colWidth?: number;
  colType?: string;
  colEditable?: boolean;
  isRequired?: boolean = false;
  isHidden?: boolean = false;
}

export class MapSelected {
  row?: number;
  col?: number | null;
  inEdit?: boolean;
}

export class CellInError {
  row?: number;
  col?: number;
  errorCode?: number;
}

export class CellXlxsInError {
  row?: number;
  colName?: string;
  message?: string;
}

export class LogOperation {
  type?: string;
  message?: string;
  code?: number;
}

@Component({
  selector: 'teiasoft-datasheet',
  templateUrl: './teiasoft-datasheet.component.html',
  styleUrls: ['./teiasoft-datasheet.component.scss']
})

export class TeiasoftDatasheetComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private static readonly CLOSE_FLOATING_DROPDOWNS_EVENT = 'teiasoft-close-floating-dropdowns';

  @Input() isMobile: boolean = false;
  @Input() showSettingsInput: boolean = false;
  @Input() theme: string = 'silver';
  @Input() dataSet: any[] = new Array();
  @Input() columnsToHide: string[] = new Array();
  @Input() columnsNotEditable: string[] = new Array();
  @Input() columnsRequired: string[] = new Array();
  @Input() columnsSelect: string[] = new Array();
  @Input() columnsBoolean: string[] = new Array();
  @Input() dateFormat: string = "";
  @Input() dateTimeFormat: string = "";
  @Input() itemParameterValues: ItemParametersValues = new ItemParametersValues();
  @Input() orderBy: string = "itemNo";
  @Input() itemsFromXlsx?: ItemsFromXlsx = new ItemsFromXlsx();
  @Input() roundDigitsForEditInPlace: RoundDigit[] = new Array();
  @Input() columnsToShow: string[] = new Array();
  @Input() enquiry!: Enquiry;
  @Input() materials: Material[] = new Array();
  @Output() changedDataset: EventEmitter<any[]> = new EventEmitter();
  @Output() validForm: EventEmitter<boolean> = new EventEmitter();
  @Output() itemsToDelete: EventEmitter<string[]> = new EventEmitter();
  @Output() setIsInEdit: EventEmitter<boolean> = new EventEmitter();
  @Output() gridReady: EventEmitter<void> = new EventEmitter();

  @ViewChildren('checkboxContainer') checkboxContainers!: QueryList<ElementRef>;


  gridConfiguration: GridConfiguration = new GridConfiguration();
  title: string = 'edit-in-place';
  resizingFlag = { isResizing: false };
  recalculateColumnsWidth: boolean = false;
  gridFilterable: boolean = false;
  activeFilters: { [key: string]: any } = {};
  filterMaps: ODataGridFilterMap[] = new Array();
  filtersValues: any;
  booleanColumnsOptions: SelectOption[] = [];

  DEFAULT_COL_WIDTH: number = 250;
  dataSheet: DataSheet[] = new Array();
  oldDataSheet: DataSheet[] = new Array();
  filteredDataSheet: DataSheet[] = new Array();
  col: number = -1;
  rowWidth: number = 0;
  mapSelected: MapSelected[] = new Array();
  lastSelectedIndex: number | null = null;
  selectedCol: number = -1;
  selectedRow: number = -1;
  booleanList: SelectOption[] = new Array();
  unitSystemOptionList: SelectOption[] = new Array();
  quantityUomsList: SelectOption[] = new Array();
  odUomsList: SelectOption[] = new Array();
  idUomsList: SelectOption[] = new Array();
  wtUomsList: SelectOption[] = new Array();
  toleranceUomsList: SelectOption[] = new Array();
  lengthUomsList: SelectOption[] = new Array();
  totalWeightUomsList: SelectOption[] = new Array();
  marketingRouteOptionList: SelectOption[] = new Array();
  smsOptionList: SelectOption[] = new Array();
  typeOfToleranceOptionList: SelectOption[] = new Array();
  marketFamilyOptionList: SelectOption[] = new Array();
  htOptionList: SelectOption[] = new Array();
  htAdditionalOptionList: SelectOption[] = new Array();
  testConditionOptionList: SelectOption[] = new Array();
  sqlOptionList: SelectOption[] = new Array();
  defaultSqlOptionList: SelectOption[] = new Array();
  offerSchemeOptionList: SelectOption[] = new Array();
  inspectionType3Dot2OptionList: SelectOption[] = new Array();
  multipleCuttingOptionList: SelectOption[] = new Array();
  surfaceTypeOptionList: SelectOption[] = new Array();
  utOptionList: SelectOption[] = new Array();
  hydroTesttOptionList: SelectOption[] = new Array();
  endsConditionOptionList: SelectOption[] = new Array();
  lengthTypeOptionList: SelectOption[] = new Array();
  toolbarButtonsList: TTButton[] = new Array();
  millDataset: any[] = new Array();
  columnsMill: string[] = ['name', 'shortName', 'city', 'country'];
  columnsToHideMill: string[] = ['millId'];
  normGradesDataset: NormGrade[] = new Array();
  normGradesMaterialDataset?: NormGrade[] = new Array();
  normGradesDataset_Cache: NormGrade[] = new Array();

  columnsNormGrades: string[] = ['normGradeCode'];
  columnsToHideNormGrades: string[] = ['normGradeId'];
  rawMaterialGradeDataset: any[] = new Array();
  columnsRawMaterialGrades: string[] = ['rawMaterialGradeCode'];
  columnsToHideRawMaterialGrades: string[] = ['rawMaterialGradeId', 'isDefault'];
  materialDataset: Material[] = new Array();
  materialAttributesByRow: Map<number, ItemAttributesByMaterialCode> = new Map();
  materialAttributesByRequest: Map<string, ItemAttributesByMaterialCode> = new Map();
  materialAttributesRequestsByRequest: Map<string, Promise<ItemAttributesByMaterialCode>> = new Map();
  columnsMaterial: string[] = ['materialCode'];
  columnsToHideMaterial: string[] = [];
  cellsInError: CellInError[] = new Array();

  subscriptions: Subscription = new Subscription();
  checkedStatus: boolean[] = [];
  disabledStatus: boolean[] = [];
  showSettingsDialog: boolean = false;

  valueChanged: boolean = false;
  originalValue: any; // To store the original value for undo operation
  isFormValidValue: boolean = true;

  // nps undo
  orignalOdValue: any;
  orignalIdValue: any;
  orignalWtValue: any;
  orignalOdUom?: string;
  orignalIdUom?: string;
  orignalWtUom?: string;


  // Limitations
  limitationForNormGrade: LimitationsForNormGrades = new LimitationsForNormGrades();
  analysisLimitationOptionList: SelectOption[] = new Array();
  otherLimitationOptionList: SelectOption[] = new Array();

  // TubeExecution
  tubeExecutionOptionList: SelectOption[] = new Array();

  /* INFOS */
  logOperations: LogOperation[] = new Array();

  /* NPS */
  dataSetNps: any[] = new Array();
  columnsNps: string[] = ["npsScheduleId", "npsDescription", "nps", "schedule", "odMetric", "wtMetric", "odImperial", "wtImperial"];
  columnsToHideNps: string[] = ["npsScheduleId", "schedule", 'nps'];
  columnsToFilterNps: string[] = ["npsDescription"];
  showSelectNps: boolean = false;
  selectedNpsRow: NpsAndSchedule = new NpsAndSchedule();

  /* Delivery Extra Properties */
  deliveryExtraProperties: string[] = ["ut", "hydroTest", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting'];
  private readonly materialDependentCtsProperties: string[] = ['ut', 'hydroTest', 'ht', 'htAdditional', 'endsCondition', 'testCondition', 'uBent'];


  /* ERRORS VALIDATION START*/
  unitSystemError: number = 1;
  odWtIdError: number = 2;
  uomsDifferentUnitSystemError: number = 3;
  npsError: number = 4;
  mandatoryFieldsError: number = 5;
  noRawMaterialError: number = 6;
  differentNormGradesError: number = 7;
  millRuleActiveError: number = 8;
  //fromXlsxError: number = 9;
  greaterThanZeroError: number = 10;
  decimalValuesError: number = 11;
  tolerancesError: number = 12;
  lengthMinMaxError: number = 13;
  lengthMinMaxFixedError: number = 14;
  lengthShouldBeFixedError: number = 15;
  itemNoError: number = 16;
  differentLimitationsError: number = 17;
  differentTubeExecution: number = 18;
  differentUomsQty: number = 19;
  differentUomsOd: number = 20;
  differentUomsWt: number = 21;
  differentUomsId: number = 22;
  differentLengthUom: number = 23;
  differentMarketingRoute: number = 28;
  differentCts: number = 29;
  uBentShouldBeFixedLengthError: number = 24;
  multipleLengthNotAllowedError: number = 25;
  nominalLengthError: number = 26;
  odWtIdNotConsistenError: number = 27;
  uBentCtsError: number = 30;
  testConditionCtsError: number = 31;
  htError: number = 32;
  differentMaterialCodesError: number = 33;
  odIdWtOnlyTwoError: number = 34;
  customerItemNoFormatError: number = 35;
  customerItemNoDuplicateError: number = 36;
  differentHydroTestEditabilityError: number = 37;
  differentWtDependentEditabilityError: number = 38;
  differentOdDependentEditabilityError: number = 39;
  differentIdDependentEditabilityError: number = 40;





  /* ERRORS VALIDATION END*/
  filteredRowIndices: any[] = [];


  buttonsList: TTButton[] = new Array();
  itemsNoToDelete: string[] = new Array();
  imCallingApi: boolean = false;
  defaultW: number = 120;
  millChangedByUser: boolean = false;
  newItemNoPlaceholder: number = 1;
  cellsXlxsInError: CellXlxsInError[] = new Array();

  selectedNps: NpsAndSchedule = new NpsAndSchedule();
  retCallApi = new Subject<number>();
  imScrolling: boolean = false;
  scrollingDebounceTimeout: any;
  keydownHandler: any;
  mouseupHandler: any;
  isLoaded: boolean = false;
  showLoaderUntilGridRendered: boolean = false;

  /* MQF-436 MODAL DISCARD */
  showModalDiscardApply: boolean = false;
  discardParameter: number = 0;
  applyChange: boolean = false;
  showSelectNpsSourceRow?: number;

  checkboxColumnContainerWidth: number = 0;

  constructor(private datePipe: DatePipe, private translate: TranslateService, private teiasoftLoader: TeiasoftLoaderService,
    private backendService: BackendService, private utils: UtilsService, private teiasoftToaster: TeiasoftToasterService, public globals: Globals, private teiasoftModalService: TeiasoftModalService, private resizableColumnsService: ResizableColumnsService, private rawMaterialGradeService: RawMaterialGradesService) {


    this.mouseupHandler = (event: any) => {
      // Defer the execution to allow focusout event to occur first
      setTimeout(() => {
        let _c: string = event.target.className;
        let inEditIndex = this.mapSelected.findIndex(slc => slc.inEdit == true);
        if (_c == 'td-cnt-body' || _c == 'tt-cnt-ext' || _c == 'cnt-info' || _c == 'td-cnt-title' || _c == 'td-cnt-btn' || _c == 'tds-cnt' || _c == 'tds-checkbox' || _c.indexOf('tds-grid') != -1) {
          this.showPendingChangesDialog(1);
          if (!this.valueChanged && this.mapSelected && this.mapSelected.length > 0 && !this.imScrolling) this.closeEditLight();
        }
      }, 0);
    };

    // $(document).on('mouseup', this.mouseupHandler);

    this.buildButtonsList();
    this.getBooleanList();
    this.getUnitSystems();
    this.getNormGrades('');
    this.logOperations = new Array();

    // Discard Changes
    this.subscriptions.add(this.globals.discardEditInPlace?.subscribe(res => {
      if (parseInt(res.toString()) > 0) {
        let inEditIndex = this.mapSelected.findIndex(slc => slc.inEdit == true);
        if (this.dataSheet[this.mapSelected[inEditIndex].col!].colName?.toLowerCase() == 'npsschedule') {
          this.undoChangeNps(null, this.mapSelected[inEditIndex].row!, this.mapSelected[inEditIndex].col!);
        }
        else {
          this.undoChange(this.mapSelected[inEditIndex].row!, this.mapSelected[inEditIndex].col!);
        }
        if (parseInt(res.toString()) == 1) {
          this.closeEditLight();
        } else if (parseInt(res.toString()) == 5) {
          this.closeEdit();
          const checkbox = document.getElementById('chkAll') as HTMLInputElement;
          checkbox.checked = false;
        } else {
          // this.closeEditLight();
          this.closeEditLight();
        }

      }
    }));

    // Apply Changes
    this.subscriptions.add(this.globals.applyEditInPlace!.subscribe(res => {
      if (parseInt(res.toString()) > 0) {


      }
    }));
  }


  ngOnInit(): void {
    this.updateSelectionStatus();

    const resizeSub = this.resizableColumnsService.complete$.subscribe(() => {
      setTimeout(() => {
        this.teiasoftLoader.stop();
      }, 250);

      setTimeout(() => {
        if (this.checkboxContainers.first) {
          this.checkboxColumnContainerWidth = this.checkboxContainers.first.nativeElement.offsetWidth;
        }
      });
    });

    this.subscriptions.add(resizeSub);

    this.initFilterOptions();
  }

  ngAfterViewInit(): void {
    this.materialDataset = this.materials.slice(0, 100); // init materials dataset
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["itemParameterValues"]) {
      this.itemParameterValues = changes["itemParameterValues"].currentValue;
      this.fillOptionLists();
    }

    if (changes && changes["columnsToHide"]) {
      this.columnsToHide = new Array();
      this.columnsToHide = changes["columnsToHide"].currentValue;
    }

    if (changes && changes["columnsSelect"]) {
      this.columnsSelect = new Array();
      this.columnsSelect = changes["columnsSelect"].currentValue;
    }

    if (changes && changes["columnsRequired"]) {
      this.columnsRequired = new Array();
      this.columnsRequired = changes["columnsRequired"].currentValue;
    }

    if (changes && changes["roundDigitsForEditInPlace"]) {
      this.roundDigitsForEditInPlace = new Array();
      this.roundDigitsForEditInPlace = changes["roundDigitsForEditInPlace"].currentValue;
      this.setRoundDigits();
    }

    if (changes && changes["columnsNotEditable"]) {
      this.columnsNotEditable = new Array();
      this.columnsNotEditable = changes["columnsNotEditable"].currentValue;
    }

    if (changes && changes["dateFormat"]) {
      this.dateFormat = changes["dateFormat"].currentValue;
    }

    if (changes && changes["dateTimeFormat"]) {
      this.dateTimeFormat = changes["dateTimeFormat"].currentValue;
    }

    if (changes && changes["dataSet"] && changes["dataSet"].currentValue.length > 0) {
      this.startGridLoading();
      this.newItemNoPlaceholder = 1; // reset newItemNo counter
      this.dataSet = new Array();

      this.dataSet = JSON.parse(JSON.stringify(changes["dataSet"].currentValue));
      this.ensureItemNumbers();
      this.normalizeDeliveryExtraPropertiesDefaults();

      if (this.dataSet.every(ds => ds[this.orderBy]))
        this.dataSet = this.dataSet.sort(
          (a, b) => {
            return a[this.orderBy]! - b[this.orderBy]!; //  "itemNo"
          }
        );

      this.processData();
    }

    if (changes && changes["itemsFromXlsx"] && changes["itemsFromXlsx"].currentValue != undefined) {
      this.startGridLoading();
      this.itemsFromXlsx = new ItemsFromXlsx();
      this.itemsFromXlsx = JSON.parse(JSON.stringify(changes["itemsFromXlsx"].currentValue));

      // fill empty ItemNO TODO: maybe this shuold be done by the api!
      for (let i = 0; i < this.itemsFromXlsx!.items!.length!; i++) {
        if (this.itemsFromXlsx!.items![i].itemNo == null || this.itemsFromXlsx!.items![i].itemNo == '') {
          this.itemsFromXlsx!.items![i].itemNo = "New(" + this.newItemNoPlaceholder + ")";
          this.newItemNoPlaceholder++;
        }
      }

      if (this.itemsFromXlsx && this.itemsFromXlsx.items!.length > 0)
        this.processDataFromXlsx();
    }

    if (changes && changes["showSettingsInput"] && changes["showSettingsInput"].currentValue != undefined) {
      this.showSettingsInput = changes["showSettingsInput"].currentValue;
      this.showSettingsDialog = this.showSettingsInput;
    }

    this.updateSelectionStatus();
  }

  ngOnDestroy(): void {
    this.dataSet = new Array();
    this.dataSheet = new Array();
    this.oldDataSheet = new Array()
    this.valueChanged = false;
    this.subscriptions.unsubscribe();
    $(document).off('keydown', this.keydownHandler);
    $(document).off('mouseup', this.mouseupHandler);
  }

  initFilterOptions(): void {
    this.booleanColumnsOptions = ['', 'Yes', 'No'].map(opt => {
      const sc = new SelectOption();
      sc.text = opt;
      sc.value = opt;
      return sc;
    })
  }

  initGridConfiguration() {
    // this.teiasoftLoader.start();

    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfig = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === this.title);
    const currentColumns = this.dataSheet.filter(ds => ds.colName?.toLowerCase() !== 'itemno');

    if (savedConfig) {
      this.gridConfiguration = savedConfig;

      const existingColumnNames = new Set(this.gridConfiguration.gridColumns!.map(c => c.name));

      // Add missing columns
      const nextId = this.gridConfiguration.gridColumns!.length;
      currentColumns.forEach((col, idx) => {
        if (!existingColumnNames.has(col.colName)) {
          let gc = new GridColumn();
          gc.id = nextId + idx;
          gc.name = col.colName;
          gc.visible = !col.isHidden;
          gc.width = col.colType === 'object' ? this.DEFAULT_COL_WIDTH : col.colWidth;
          this.gridConfiguration.gridColumns!.push(gc);
        }
      });

      // Remove obsolete columns
      this.gridConfiguration.gridColumns = this.gridConfiguration.gridColumns!.filter(c =>
        currentColumns.find(ds => ds.colName === c.name)
      );

    } else {
      this.gridConfiguration = new GridConfiguration();
      this.gridConfiguration.name = this.title;
      this.gridConfiguration.gridColumns = currentColumns.map((col, idx) => {
        let gc = new GridColumn();
        gc.id = idx;
        gc.name = col.colName;
        gc.visible = !col.isHidden;
        gc.width = col.colType === 'object' ? this.DEFAULT_COL_WIDTH : col.colWidth;
        return gc;
      });

      this.onUpdateConfiguration(this.gridConfiguration);
    }

    this.syncHiddenColumnsFromConfiguration();
  }

  viewportToPixels(vw: number): number {
    let viewportWidth = window.innerWidth;
    return (viewportWidth / 100) * vw;
  }


  updateSelectionStatus() {
    this.checkedStatus = this.dataSet.map((p, index) => this.getIfImChecked(index));
    this.disabledStatus = this.dataSet.map((p, index) => this.isSelectionCheckboxDisabled(index));
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  showPendingChangesDialog(paramClosing: number): void {
    if (this.imScrolling) return; // MQF-357 while scrolling ignore the click event


    let _istoDiscard: boolean = true;
    if (this.valueChanged == false) _istoDiscard = false;
    //if (!this.mapSelected.some(slc => slc.inEdit == true)) _istoDiscard = false;
    /* let _i: number = this.mapSelected.findIndex(x => x.inEdit == true);
    let _value: any = this.dataSheet[this.mapSelected[_i].col!].colValue![this.mapSelected[_i].row!];
    if (JSON.stringify(_value) == JSON.stringify(this.originalValue)) _istoDiscard = false;
 */
    if (!_istoDiscard) {
      // if (paramClosing == 1) 
      //   this.closeEdit();
      // else
      this.closeEditLight()
    } else {
      const inEdit = this.mapSelected.find(slc => slc.inEdit == true);

      // norm grade,rawmaterialgrade and mill are an exceptional column we should handle the confirm here
      if (inEdit && inEdit.col == this.dataSheet.findIndex(col => col.colName?.toLowerCase() == 'normgrades')) {
        this.handleConfirmForNotConfirmableInputs('normgrades', inEdit.row!, inEdit.col, new KeyboardEvent('Enter'));
      }
      if (inEdit && inEdit.col == this.dataSheet.findIndex(col => col.colName?.toLowerCase() == 'rawmaterialgrade')) {
        this.handleConfirmForNotConfirmableInputs('rawmaterialgrade', inEdit.row!, inEdit.col, new KeyboardEvent('Enter'));
      }
      if (inEdit && inEdit.col == this.dataSheet.findIndex(col => col.colName?.toLowerCase() == 'mill')) {
        this.handleConfirmForNotConfirmableInputs('mill', inEdit.row!, inEdit.col, new KeyboardEvent('Enter'));
      }
      if (inEdit && inEdit.col == this.dataSheet.findIndex(col => col.colName?.toLowerCase() == 'customerdeliverydate')) {
        this.handleConfirmForNotConfirmableInputs('customerdeliverydate', inEdit.row!, inEdit.col, new KeyboardEvent('Enter'));
      }
      if (inEdit && inEdit.col == this.dataSheet.findIndex(col => col.colName?.toLowerCase() == 'material')) {
        this.handleConfirmForNotConfirmableInputs('material', inEdit.row!, inEdit.col, new KeyboardEvent('Enter'));
      }

      this.closeEditLight()
    }
  }

  onScrolling() {
    document.dispatchEvent(new CustomEvent(TeiasoftDatasheetComponent.CLOSE_FLOATING_DROPDOWNS_EVENT));
    this.imScrolling = true;
    if (this.scrollingDebounceTimeout) {
      clearTimeout(this.scrollingDebounceTimeout);
    }
    this.scrollingDebounceTimeout = setTimeout(() => {
      this.imScrolling = false;
    }, 2000);
  }
  /**
   * FROM DATASET TO DATASHEET 
   */
  processData() {
    // MQF-370 - Obsolete Values - GBR 12/07/2024
    this.checkDataObsolete();
    // END 
  }


  // MQF-370 - Sposto qui per gestire il check degli obsoleti a valle delle chiamate BE
  afterAllProcessData() {
    this.dataSheet = new Array();
    this.oldDataSheet = new Array();

    // GBR 23/02/2034 - Attenzione: gli elementi del DataSet potrebbero essere diversi. Ad esmpio, un oggetto alla riga 0 potrebbe essere null
    // mentre alla riga 1 potrebbe essere valorizzato. Questo fà sì che il dato non venga valorizzato. Occorre trovare quindi quell'elemento
    //dell'array che ha il maggior numero di proprietà e usare quello per costruire le colonne
    let _num: number[] = new Array();
    for (var x = 0; x < this.dataSet.length; x++) {
      _num.push(Object.keys(this.dataSet[x]).length);
    }
    const max = Math.max(..._num);
    let _i: number = _num.indexOf(max);

    let currentItemPros = Object.keys(this.dataSet[_i]);
    const wasImportedFromAI = this.dataSet.find(i => i['isImportedFromAI'] == true);

    let extraProps = [];
    if (wasImportedFromAI)
      extraProps.push('remarks')
    else {
      currentItemPros = currentItemPros.filter(x => x != 'remarks');
    }


    const allProps = [...new Set([...this.columnsToShow, ...currentItemPros, ...extraProps, 'isImportedFromAI'])];


    allProps.forEach((prop) => {
      if (this.columnsToShow.findIndex(x => x.toLowerCase() == prop.toLowerCase()) != -1 || prop === 'remarks' || prop === 'itemNo') {
        let _item: DataSheet = new DataSheet();
        let _colname: string = prop.substring(0, 1).toUpperCase() + prop.substring(1, prop.length);
        _item.colName = _colname;
        _item.colValue = new Array();
        _item.colValue = this.dataSet.map(x => x[prop]); //prop != 'normGrades'  ? this.dataSet.map(x => x[prop]) : this.dataSet.map(x => x[prop])[0]; //typeof this.dataSet[_i][prop] != 'object' ?  this.dataSet[_i][prop] : null; //this.dataSet[_i].map((x: { [x: string]: any; }) => x[prop]);
        _item.colWidth = this.getColWidth(_item.colValue!);
        _item.colEditable = this.columnsNotEditable.findIndex(x => x.toLowerCase() == _item.colName?.toLowerCase()) == -1 ? true : false;
        _item.isRequired = this.columnsRequired.findIndex(x => x.toLowerCase() == _item.colName?.toLowerCase()) != -1 ? true : false;
        _item.colType = this.columnsSelect.findIndex(x => x.toLowerCase() == _item.colName?.toLowerCase()) != -1 ? 'select' : '';
        _item.colType = this.columnsBoolean.findIndex(x => x.toLowerCase() == _item.colName?.toLowerCase()) != -1 ? 'boolean' : _item.colType;
        _item.isHidden = _colname.toLowerCase() == 'itemno' || _colname.toLowerCase() == 'isimportedfromai';
        let _temp: any[] = _item.colValue!.filter(x => x != null);
        _item.colType = _item.colType != '' ? _item.colType : typeof _temp[0];
        // HardCoded
        if (_item.colName!.toLowerCase() == 'optiondate' || _item.colName!.toLowerCase() == 'customerdeliverydate') _item.colType = 'date';
        if (_item.colName!.toLowerCase() == 'normgrades') _item.colType = 'object';
        if (_item.colName!.toLowerCase() == 'rawmaterialgrade') _item.colType = 'object';
        if (_item.colName!.toLowerCase() == 'material') _item.colType = 'object';
        if (_item.colName!.toLowerCase() == 'mill') _item.colType = 'object';
        if (_item.colName!.toLowerCase() == 'remarks') _item.colType = 'string';
        // End 
        _item.colType = (_item.colType != '' && _item.colType != 'undefined') ? _item.colType : 'string'; // Se qui non è ancora valorizzato allora decido che è stringa
        // Se è un number devo verificare che non sia una data
        if (_item.colType == 'number') {
          const _date = new Date(_item.colValue![0]);
          const _refDate = new Date('2000-01-01')
          if (!isNaN(_date.getTime()) && _date.getTime() > _refDate.getTime()) {
            _item.colType = 'date';
          } else {
            // Arrotondo
            for (var r = 0; r < _item.colValue!.length; r++) {
              if (_item.colValue[r] != null && _item.colValue[r] != undefined && _item.colValue[r] != '')
                _item.colValue[r] = parseFloat(_item.colValue![r].toFixed(this.getRoundDigits(r, _item.colName!)));
            }
          }
        }
        this.dataSheet.push(_item);
      }
    });

    this.enforceHydroTestRulesOnLoad();
    // this.filteredDataSheet = [...this.dataSheet];
    this.applyFilters();
    this.resizableColumnsService.initialize(this.dataSheet.length - 1);
    this.initGridConfiguration();
    this.setDimensions();
    this.applyGridConfiguration();
    this.isFormValid();
    this.buildFilters();
    //this.setRoundDigits();
    this.mapSelected = new Array();
    this.oldDataSheet = JSON.parse(JSON.stringify(this.dataSheet));
    this.isLoaded = true;
    this.stopGridLoadingAfterRender();
  }

  private startGridLoading(): void {
    this.isLoaded = false;
    this.showLoaderUntilGridRendered = true;
  }

  private stopGridLoadingAfterRender(): void {
    if (!this.showLoaderUntilGridRendered) {
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.showLoaderUntilGridRendered = false;
        this.gridReady.emit();
      });
    });
  }


  /**
   * FROM XLSX TO DATASHEET
   */
  async processDataFromXlsx() {
    // MQF-278 
    await this.preProcessDataFromXlsx();
    // END MQF-278
    this.dataSet = new Array();
    for (var x = 0; x < this.itemsFromXlsx!.items!.length; x++) {
      let _item: any = {};
      let _obj: any = this.itemsFromXlsx!.items![x];
      for (const prop in _obj) {
        let _name: string = prop.replace("Field", "");
        if (typeof _obj[prop] != 'object') {
          _item[_name] = _obj[prop];
        } else {
          if (_obj[prop] && _obj[prop]["isValid"] == false) {
            this.setcellsXlxsAsError(x, prop, _obj[prop]["message"]);
            //this.writeLog("error", _obj[prop]["message"] + " (" + _name + ")", this.fromXlsxError);
          }
          _item[_name] = _obj[prop] ? _obj[prop]["value"] : null;
        }
      }
      this.dataSet.push(_item);
    }

    // MQF-261 - Check in caso di Limitations vuote - Se sono vuote ne creo due custom per non sballare il layout
    let _empty: ItemLimitation = new ItemLimitation();
    _empty.isCustom = true;
    _empty.limitation = '';
    for (var x = 0; x < this.dataSet.length; x++) {
      if (this.dataSet[x]["gradeCustomerAnalysisLimitation"] == null) {
        this.dataSet[x]["gradeCustomerAnalysisLimitation"] = new ItemLimitation();
        this.dataSet[x]["gradeCustomerAnalysisLimitation"] = JSON.parse(JSON.stringify(_empty));
      }
      if (this.dataSet[x]["gradeCustomerOtherLimitation"] == null) {
        this.dataSet[x]["gradeCustomerOtherLimitation"] = new ItemLimitation();
        this.dataSet[x]["gradeCustomerOtherLimitation"] = JSON.parse(JSON.stringify(_empty));
      }
    }
    // END MQF-261

    this.normalizeDeliveryExtraPropertiesDefaults();
    this.processData();

    this.changedDataset.emit(this.dataSet);

  }

  private normalizeDeliveryExtraPropertiesDefaults(): void {
    if (!this.dataSet || this.dataSet.length === 0) {
      return;
    }

    const configuredColumns = new Set(
      [...(this.columnsToShow || []), ...(this.columnsBoolean || [])]
        .map(col => col?.toLowerCase())
        .filter(Boolean) as string[]
    );

    const propsToNormalize = this.deliveryExtraProperties
      .filter(prop => configuredColumns.has(prop.toLowerCase()));

    if (propsToNormalize.length > 0) {
      for (const row of this.dataSet) {
        if (!row || typeof row !== 'object') continue;

        for (const prop of propsToNormalize) {
          const existingKey = Object.keys(row).find(k => k.toLowerCase() === prop.toLowerCase()) || prop;
          const currentValue = row[existingKey];

          if (currentValue === 'true') {
            row[existingKey] = true;
            continue;
          }

          if (currentValue === 'false') {
            row[existingKey] = false;
            continue;
          }

          if (currentValue === undefined || currentValue === null || currentValue === '') {
            row[existingKey] = false;
          }
        }
      }
    }

    this.applyFirstNewItemHeaderHexuUbentDefault();
  }

  private async preProcessDataFromXlsx() {
    const materialRulesTasks: Promise<void>[] = [];

    for (let x = 0; x < this.itemsFromXlsx!.items!.length; x++) {
      const item = this.itemsFromXlsx!.items![x] as any;
      this.applyDefaultValuesToImportedItem(item);

      // If TubeExecution is valid and non custom, force tolerances from TubeExecution.
      if (item.tubeExecutionField?.isValid === true && item.tubeExecutionField?.value?.isCustom === false) {
        item.wtToleranceMinusField.isValid = true;
        item.wtTolerancePlusField.isValid = true;
        if (item.typeOfToleranceField?.value == 'AW') {
          item.wtToleranceMinusField.value = item.tubeExecutionField.value.toleranceMinusAw!;
          item.wtTolerancePlusField.value = item.tubeExecutionField.value.tolerancePlusAw!;
        } else {
          item.wtToleranceMinusField.value = item.tubeExecutionField.value.toleranceMinusMw!;
          item.wtTolerancePlusField.value = item.tubeExecutionField.value.tolerancePlusMw!;
        }
      }

      // If Nps is valid, force OD/WT from NPS.
      if (item.npsScheduleField?.isValid === true && item.npsScheduleField?.value) {
        item.odField.isValid = true;
        item.wtField.isValid = true;
        const itemUnitSystem = ((item.unitSystemField?.value || this.enquiry.header?.unitSystem || '') as string).toLowerCase();
        if (itemUnitSystem == 'metric') {
          item.odField.value = item.npsScheduleField.value.odMetric!;
          item.wtField.value = item.npsScheduleField.value.wtMetric!;
        } else {
          item.odField.value = item.npsScheduleField.value.odImperial!;
          item.wtField.value = item.npsScheduleField.value.wtImperial!;
        }
      }

      // Material code rules apply only when material is valid.
      if (item.materialField?.isValid !== true || !item.materialField?.value?.materialCode) {
        continue;
      }

      materialRulesTasks.push(this.applyMaterialRulesToImportedItem(item, x));
    }

    await Promise.all(materialRulesTasks);
  }

  private async applyMaterialRulesToImportedItem(item: any, rowIndex: number): Promise<void> {
    const materialCode = item.materialField?.value?.materialCode;
    if (!materialCode) {
      return;
    }

    try {
      const res = await this.getItemAttributesByMaterialCodeCached(
        materialCode,
        item.unitSystemField?.value || this.enquiry.header?.unitSystem!
      );

      const {
        marketingRoute,
        lengthType,
        lengthMax,
        lengthMin,
        millsId: materialMillsIds,
        uBent,
        endsCondition,
        ht,
        htAdditional,
        hydroTest,
        ut,
        rawMaterialGrade,
        testCondition,
        typeOfTolerance
      } = res;
      const sqlFromMaterial = (res as any).sqlId != null
        ? this.itemParameterValues.sqls?.find(s => s.sqlId == (res as any).sqlId) ?? null
        : ((res as any).sql?.sqlId != null
          ? this.itemParameterValues.sqls?.find(s => s.sqlId == (res as any).sql.sqlId) ?? null
          : null);
      const offerSchemeFromMaterial = (res as any).offerSchemeCode != null
        ? this.itemParameterValues.offerSchemes?.find(s => s.offerSchemeCode == (res as any).offerSchemeCode) ?? null
        : ((res as any).offerScheme?.offerSchemeCode != null
          ? this.itemParameterValues.offerSchemes?.find(s => s.offerSchemeCode == (res as any).offerScheme.offerSchemeCode) ?? null
          : null);

      const materialDimensions = this.getMaterialDimensionsByType(res);
      this.materialAttributesByRow.set(rowIndex, res);

      // Material code values have absolute priority over imported/default values.
      this.upsertImportFieldValue(item, 'marketingRoute', marketingRoute, true);
      const currentSms = item.smsField?.value as ItemSms | undefined;
      const compliantSms = this.itemParameterValues.sms?.find(s => s.marketingRoute == marketingRoute && s.smsId == currentSms?.smsId) || new ItemSms();
      this.upsertImportFieldValue(item, 'sms', compliantSms, true);
      this.upsertImportFieldValue(item, 'od', materialDimensions.od, true);
      this.upsertImportFieldValue(item, 'wt', materialDimensions.wt, true);
      this.upsertImportFieldValue(item, 'id', materialDimensions.id, true);
      this.upsertImportFieldValue(item, 'odUom', materialDimensions.odUom, true);
      this.upsertImportFieldValue(item, 'wtUom', materialDimensions.wtUom, true);
      this.upsertImportFieldValue(item, 'idUom', materialDimensions.idUom, true);

      this.upsertImportFieldValue(item, 'lengthType', lengthType, true);
      this.upsertImportFieldValue(item, 'multipleLength', false, true);
      if (lengthType == 'FL') {
        this.upsertImportFieldValue(item, 'lengthNominal', lengthMax ?? lengthMin ?? null, true);
        this.upsertImportFieldValue(item, 'lengthMax', null, true);
        this.upsertImportFieldValue(item, 'lengthMin', null, true);
      } else {
        this.upsertImportFieldValue(item, 'lengthNominal', null, true);
        this.upsertImportFieldValue(item, 'lengthMax', lengthMax ?? null, true);
        this.upsertImportFieldValue(item, 'lengthMin', lengthMin ?? null, true);
      }

      if (materialMillsIds && materialMillsIds.length > 0) {
        const currentMillId = item.millField?.value?.millId;
        const compliantMill = this.itemParameterValues.mills?.find(m => materialMillsIds.includes(m.millId!) && m.millId == currentMillId);
        const defaultMill = this.resolveDefaultMillForImportedItem(item);
        const defaultCompliantMill = defaultMill?.millId != null && materialMillsIds.includes(defaultMill.millId)
          ? defaultMill
          : undefined;
        const selectedMill = compliantMill || defaultCompliantMill || this.itemParameterValues.mills?.find(m => materialMillsIds.includes(m.millId!)) || null;
        this.upsertImportFieldValue(item, 'mill', selectedMill, true);
      }

      if (this.materialDimTypeHasWt(res) && typeOfTolerance) {
        this.upsertImportFieldValue(item, 'typeOfTolerance', typeOfTolerance, true);
      } else {
        this.clearImportedWtToleranceFields(item);
      }

      this.upsertImportFieldValue(item, 'uBent', uBent, true);
      this.upsertImportFieldValue(item, 'endsCondition', endsCondition, true);
      this.upsertImportFieldValue(item, 'ht', ht, true);
      this.upsertImportFieldValue(item, 'htAdditional', htAdditional, true);
      this.upsertImportFieldValue(item, 'hydroTest', hydroTest, true);
      this.upsertImportFieldValue(item, 'ut', ut, true);
      this.upsertImportFieldValue(item, 'testCondition', testCondition, true);
      if (!this.applySqlRulesForImportedItem(item, res, item.millField?.value)) {
        this.upsertImportFieldValue(item, 'sql', sqlFromMaterial, true);
      }
      if (offerSchemeFromMaterial) {
        this.upsertImportFieldValue(item, 'offerScheme', offerSchemeFromMaterial, true);
      }
      if (rawMaterialGrade?.isDummy !== true) {
        this.upsertImportFieldValue(item, 'rawMaterialGrade', rawMaterialGrade, true);
      }
      this.upsertImportFieldValue(item, 'npsSchedule', undefined, true); // ignore nps value when material code is provided
      this.applyImportedCtsRulesAfterMaterial(item, rowIndex);

      const apiNormGrades = res?.normGrades;
      if (Array.isArray(apiNormGrades) && apiNormGrades.length > 0) {
        const currentNorms = item.normGradesField?.value as Array<{ normGradeId: number }> | undefined;
        if (Array.isArray(currentNorms) && currentNorms.length > 0) {
          const allowedIds = new Set(apiNormGrades.map(ng => ng.normGradeId));
          const allValid = currentNorms.every(n => allowedIds.has(n.normGradeId));
          if (!allValid) {
            this.resetGradeFields(item);
          }
        }
      }
    } catch {
      // If material lookup fails, keep imported/default values and continue.
    }
  }

  private buildMaterialAttributesRequestKey(materialCode: string, unitSystem: string | undefined | null): string {
    return `${(unitSystem || '').toString().trim().toLowerCase()}|${materialCode.toString().trim().toLowerCase()}`;
  }

  private async getItemAttributesByMaterialCodeCached(materialCode: string, unitSystem: string | undefined | null): Promise<ItemAttributesByMaterialCode> {
    const requestKey = this.buildMaterialAttributesRequestKey(materialCode, unitSystem);
    const cachedAttributes = this.materialAttributesByRequest.get(requestKey);
    if (cachedAttributes) {
      return _.cloneDeep(cachedAttributes);
    }

    const pendingRequest = this.materialAttributesRequestsByRequest.get(requestKey);
    if (pendingRequest) {
      return _.cloneDeep(await pendingRequest);
    }

    const request = firstValueFrom(this.backendService.getItemAttributesByMaterialCode(materialCode, unitSystem || this.enquiry.header?.unitSystem!))
      .then(res => {
        this.materialAttributesByRequest.set(requestKey, _.cloneDeep(res));
        return res;
      })
      .finally(() => {
        this.materialAttributesRequestsByRequest.delete(requestKey);
      });

    this.materialAttributesRequestsByRequest.set(requestKey, request);
    return _.cloneDeep(await request);
  }

  private applyDefaultValuesToImportedItem(item: any): void {
    if (!item) {
      return;
    }

    const importedOfferScheme = this.getImportFieldValue<any>(item, 'offerScheme');
    if (typeof importedOfferScheme === 'string') {
      const mapped = this.itemParameterValues.offerSchemes?.find(s => s.offerSchemeCode == importedOfferScheme) ?? null;
      this.upsertImportFieldValue(item, 'offerScheme', mapped, mapped != null);
    } else if (importedOfferScheme?.offerSchemeCode) {
      const mapped = this.itemParameterValues.offerSchemes?.find(s => s.offerSchemeCode == importedOfferScheme.offerSchemeCode) ?? null;
      if (mapped) {
        this.upsertImportFieldValue(item, 'offerScheme', mapped, true);
      }
    }

    this.setDefaultImportFieldValue(item, 'alloySurcharge', true);
    this.setDefaultImportFieldValue(item, 'energySurcharge', false);
    this.setDefaultImportFieldValue(item, 'unitSystem', this.enquiry.header?.unitSystem ?? '');
    this.setDefaultImportFieldValue(item, 'marketFamily', this.enquiry.header?.marketFamily ?? null);
    this.setDefaultImportFieldValue(item, 'applicableNorms', this.enquiry.header?.applicableNorms ?? '');
    this.setDefaultImportFieldValue(item, 'sms', this.enquiry.header?.sms ?? null);

    const unitSystem = (this.getImportFieldValue<string>(item, 'unitSystem') || this.enquiry.header?.unitSystem || '') as string;
    const sms = this.getImportFieldValue<ItemSms>(item, 'sms');
    this.setDefaultImportFieldValue(item, 'marketingRoute', sms?.marketingRoute || this.enquiry.header?.sms?.marketingRoute || '');
    this.setDefaultImportFieldValue(item, 'lengthType', 'RL');

    const lengthType = (this.getImportFieldValue<string>(item, 'lengthType') || 'RL') as string;
    this.setDefaultImportFieldValue(item, 'lengthUom', this.getDefaultLengthUomForImport(unitSystem));
    this.setDefaultImportFieldValue(item, 'multipleLength', false);
    this.setDefaultImportFieldValue(item, 'uBent', false);
    this.setDefaultImportFieldValue(item, 'quantityUom', this.getDefaultItemQtyUomForImport(unitSystem, sms?.description, lengthType));

    this.setDefaultImportFieldValue(item, 'totalWeight', this.enquiry.header?.totalWeight);
    this.setDefaultImportFieldValue(item, 'totalWeightUom', this.enquiry.header?.totalWeightUom || this.getDefaultUomBySystem(this.itemParameterValues.totalWeightUoms, unitSystem));
    this.setDefaultImportFieldValue(item, 'odUom', this.enquiry.header?.odUom || this.getDefaultUomBySystem(this.itemParameterValues.odUoms, unitSystem));
    this.setDefaultImportFieldValue(item, 'idUom', this.enquiry.header?.idUom || this.getDefaultUomBySystem(this.itemParameterValues.idUoms, unitSystem));
    this.setDefaultImportFieldValue(item, 'wtUom', this.enquiry.header?.wtUom || this.getDefaultUomBySystem(this.itemParameterValues.wtUoms, unitSystem));

    const defaultMill = this.resolveDefaultMillForImportedItem(item);
    if (defaultMill) {
      this.setDefaultImportFieldValue(item, 'mill', defaultMill);
    }

    const defaultSurfaceType = this.resolveDefaultSurfaceTypeForImportedItem(item);
    if (defaultSurfaceType) {
      this.setDefaultImportFieldValue(item, 'surfaceType', defaultSurfaceType);
    }

    this.setDefaultImportFieldValue(item, 'endsCondition', this.itemParameterValues.endsCondition?.find(i => i.isDefault)?.value);
    this.setDefaultImportFieldValue(item, 'sql', this.itemParameterValues.sqls?.find(i => i.isDefault));
    this.setDefaultImportFieldValue(item, 'offerScheme', this.itemParameterValues.offerSchemes?.find(i => i.isDefault));
    this.setDefaultImportFieldValue(item, 'ut', this.itemParameterValues.ut?.find(i => i.isDefault)?.value);
    this.setDefaultImportFieldValue(item, 'hydroTest', this.itemParameterValues.hydroTest?.find(i => i.isDefault)?.value);
    this.setDefaultImportFieldValue(item, 'ht', this.itemParameterValues.ht?.find(i => i.isDefault)?.value);
    this.setDefaultImportFieldValue(item, 'htAdditional', this.itemParameterValues.htAdditional?.find(i => i.isDefault)?.value);
    this.setDefaultImportFieldValue(item, 'inspectionType3dot2', this.itemParameterValues.inspectionType3dot2?.find(i => i.isDefault)?.value);
    this.setDefaultImportFieldValue(item, 'multipleCutting', this.itemParameterValues.multipleCutting?.find(i => i.isDefault)?.value);

    if (lengthType == 'FL') {
      this.setDefaultImportFieldValue(item, 'lengthNominal', this.getImportFieldValue<number>(item, 'lengthMax') ?? this.getImportFieldValue<number>(item, 'lengthMin') ?? null);
    }
  }

  private getImportField(item: any, fieldName: string): any {
    return item?.[`${fieldName}Field`];
  }

  private clearImportedWtToleranceFields(item: any): void {
    this.upsertImportFieldValue(item, 'typeOfTolerance', null, true);
    this.upsertImportFieldValue(item, 'tubeExecution', null, true);
    this.upsertImportFieldValue(item, 'wtTolerancePlus', null, true);
    this.upsertImportFieldValue(item, 'wtToleranceMinus', null, true);
    this.upsertImportFieldValue(item, 'wtToleranceUom', null, true);
  }

  private getImportFieldValue<T = any>(item: any, fieldName: string): T | undefined {
    return this.getImportField(item, fieldName)?.value as T | undefined;
  }

  private getMaterialDependentCtsValuesFromImportedItem(item: any): Record<string, any> {
    return this.materialDependentCtsProperties.reduce((values, property) => {
      const field = this.getImportField(item, property);
      if (field) {
        values[property] = _.cloneDeep(field.value);
      }
      return values;
    }, {} as Record<string, any>);
  }

  private applyImportedCtsRulesAfterMaterial(item: any, rowIndex: number): void {
    const ctsField = this.getImportField(item, 'cts');
    if (!ctsField) {
      this.upsertImportFieldValue(item, 'cts', false, true);
      return;
    }

    // Preserve invalid values and their validation messages instead of masking them as CTS = No.
    if (ctsField.isValid !== true) {
      return;
    }

    const normalizedCts = ctsField.value === true
      || ['true', 'yes', '1'].includes((ctsField.value ?? '').toString().trim().toLowerCase());
    this.upsertImportFieldValue(item, 'cts', normalizedCts, true);

    if (!normalizedCts) {
      return;
    }

    const materialValuesBeforeCts = this.getMaterialDependentCtsValuesFromImportedItem(item);

    this.deliveryExtraProperties
      .filter(property => property.toLowerCase() != 'hydrotest')
      .forEach(property => {
        if (this.getImportField(item, property)) {
          this.upsertImportFieldValue(item, property, false, true);
        }
      });

    const endsConditionValue = this.endsConditionOptionList.find(option => option.text == 'SquareCutDeburred')?.value;
    this.upsertImportFieldValue(item, 'endsCondition', endsConditionValue, true);

    const testConditionValue = this.testConditionOptionList.find(option => option.text == 'TC1')?.value;
    this.upsertImportFieldValue(item, 'testCondition', testConditionValue, true);

    const marketingRoute = (this.getImportFieldValue<string>(item, 'marketingRoute') || '').toString();
    this.upsertImportFieldValue(item, 'ht', marketingRoute == 'Cold', true);

    const mill = this.getImportFieldValue<Mill>(item, 'mill');
    const sms = this.getImportFieldValue<ItemSms>(item, 'sms');
    const odMm = this.getImportedItemOdInMm(item);
    const hydroTest = this.isHydroEditableMillCode(mill?.shortName)
      && (this.isHollowBarsSms(sms) || (odMm !== null && odMm > 168.3));
    this.upsertImportFieldValue(item, 'hydroTest', hydroTest, true);

    const materialValuesAfterCts = this.getMaterialDependentCtsValuesFromImportedItem(item);
    if (!_.isEqual(materialValuesBeforeCts, materialValuesAfterCts)) {
      this.upsertImportFieldValue(item, 'material', null, true);
      this.materialAttributesByRow.delete(rowIndex);
    }
  }

  private setDefaultImportFieldValue(item: any, fieldName: string, defaultValue: any): void {
    const field = this.getImportField(item, fieldName);
    if (!field || field.isValid !== true || !this.isImportValueEmpty(field.value) || defaultValue === undefined) {
      return;
    }
    field.value = defaultValue;
  }

  private upsertImportFieldValue(item: any, fieldName: string, value: any, forceValid: boolean = false): void {
    const fieldKey = `${fieldName}Field`;
    if (!item[fieldKey]) {
      item[fieldKey] = {
        value: value,
        message: '',
        isValid: forceValid ? true : undefined
      };
      return;
    }

    item[fieldKey].value = value;
    if (forceValid) {
      item[fieldKey].isValid = true;
      if (item[fieldKey].message) {
        item[fieldKey].message = '';
      }
    }
  }

  private isImportValueEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    return false;
  }

  private getDefaultUomBySystem(uoms: UomsType | undefined, unitSystem: string): string | undefined {
    if (!uoms) {
      return undefined;
    }
    const isMetric = unitSystem == 'Metric';
    return isMetric ? uoms.metricUoms?.find(u => u.isDefault)?.uomCode : uoms.imperialUoms?.find(u => u.isDefault)?.uomCode;
  }

  private getDefaultLengthUomForImport(unitSystem: string): string | undefined {
    return this.getDefaultUomBySystem(this.itemParameterValues.lengthUoms, unitSystem);
  }

  private getDefaultItemQtyUomForImport(unitSystem: string, smsDescr?: string, lengthType?: string): string | undefined {
    const isMetric = unitSystem == 'Metric';
    const uoms = this.itemParameterValues.quantityUoms;
    const findUom = (list: Uom[] | undefined, code: string) => list?.find(qu => qu.uomCode == code)?.uomCode;

    if ((smsDescr || '').toLowerCase() == 'hollow bars') {
      return isMetric ? findUom(uoms?.metricUoms, 'kg') : findUom(uoms?.imperialUoms, 'lb');
    }
    if (lengthType == 'FL') {
      return findUom(uoms?.metricUoms, 'pcs');
    }
    if (lengthType == 'RL') {
      return isMetric ? findUom(uoms?.metricUoms, 'm') : findUom(uoms?.imperialUoms, 'ft');
    }
    return undefined;
  }

  private resolveDefaultMillForImportedItem(item: any): Mill | undefined {
    if (!item) {
      return undefined;
    }

    if (this.enquiry.header?.salesOffice == 'DUS' || this.enquiry.header?.salesOffice == 'EU1') {
      return this.itemParameterValues.mills?.find(m => m.shortName == 'HO');
    }

    const sms = this.getImportFieldValue<ItemSms>(item, 'sms');
    const route = (this.getImportFieldValue<string>(item, 'marketingRoute') || sms?.marketingRoute || '').toString();
    const odMm = this.getImportedItemOdInMm(item);

    if (route == 'Hot') {
      return this.itemParameterValues.mills?.find(m => m.shortName == 'MB');
    }

    if (route == 'Cold') {
      if (odMm !== null && odMm >= 6 && odMm <= 88.99) {
        return this.itemParameterValues.mills?.find(m => m.shortName == 'CV');
      }
      if (odMm !== null && odMm > 88.99) {
        return this.itemParameterValues.mills?.find(m => m.shortName == 'RS');
      }
    }

    return undefined;
  }

  private resolveDefaultSurfaceTypeForImportedItem(item: any): SurfaceTypes | undefined {
    const pickled = this.findSurfaceTypeByNames(['PICKLED / PASSIVATED']);
    const freeFromScale = this.findSurfaceTypeByNames(['FREE FROM SCALE']);
    const brightAnnealed = this.findSurfaceTypeByNames(['BRIGHT ANNEALED', 'IN BRIGHT CONDITION']);

    const marketingRoute = (this.getImportFieldValue<string>(item, 'marketingRoute') || this.getImportFieldValue<ItemSms>(item, 'sms')?.marketingRoute || '').toLowerCase();
    if (marketingRoute != 'cold') {
      return pickled;
    }

    const millShortName = (this.getImportFieldValue<Mill>(item, 'mill')?.shortName || '').toUpperCase();
    const odMm = this.getImportedItemOdInMm(item);

    if (millShortName == 'CV' && odMm !== null && odMm >= 6 && odMm <= 15) {
      return brightAnnealed || pickled;
    }
    if (millShortName == 'CV' && odMm !== null && odMm > 15) {
      return freeFromScale || pickled;
    }
    if (millShortName == 'RS') {
      return freeFromScale || pickled;
    }

    return pickled;
  }

  private getImportedItemOdInMm(item: any): number | null {
    const odValue = Number(this.getImportFieldValue<number>(item, 'od'));
    if (!Number.isFinite(odValue)) {
      return null;
    }

    const unitSystem = (this.getImportFieldValue<string>(item, 'unitSystem') || this.enquiry.header?.unitSystem || '').toLowerCase();
    if (unitSystem == 'imperial') {
      return odValue * 25.4;
    }
    return odValue;
  }

  resetGradeFields(item: {
    normGradesField?: { value?: any };
    gradeCustomerAnalysisLimitationField?: { value?: any };
    gradeCustomerOtherLimitationField?: { value?: any };
  }) {
    if (item.normGradesField) item.normGradesField.value = undefined;
    if (item.gradeCustomerAnalysisLimitationField) item.gradeCustomerAnalysisLimitationField.value = undefined;
    if (item.gradeCustomerOtherLimitationField) item.gradeCustomerOtherLimitationField.value = undefined;
  }

  setRoundDigits() {
    // ROUND DIGITS
    if (!this.roundDigitsForEditInPlace || this.roundDigitsForEditInPlace.length == 0) return;
    if (!this.dataSheet || this.dataSheet.length == 0) return;
    if (!this.oldDataSheet || this.oldDataSheet.length == 0) return;

    let _iUS: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'unitsystem');
    for (var k = 0; k < this.dataSheet[0].colValue!.length; k++) {
      let _unitSystem: string = this.dataSheet[_iUS].colValue![k];
      for (var p = 0; p < this.roundDigitsForEditInPlace.length; p++) {
        let _i: number = this.dataSheet.findIndex(i => i.colName!.toLowerCase() == this.roundDigitsForEditInPlace[p].fieldName!.toLowerCase());
        if (_i != -1) {
          if (_unitSystem == 'Metric' && this.dataSheet[_i].colValue![k] != null && this.dataSheet[_i].colValue![k] != '') {
            this.dataSheet[_i].colValue![k] = Number.parseFloat(this.oldDataSheet[_i].colValue![k]).toFixed(this.roundDigitsForEditInPlace[p].metricDigits!); // parseFloat(this.dataSheet[_i].colValue![k]).toFixed(this.roundDigitsForEditInPlace[p].metricDigits!);
            this.dataSheet[_i].colType = 'number';
          }

          if (_unitSystem == 'Imperial' && this.dataSheet[_i].colValue![k] != null && this.dataSheet[_i].colValue![k] != '') {
            this.dataSheet[_i].colValue![k] = Number.parseFloat(this.oldDataSheet[_i].colValue![k]).toFixed(this.roundDigitsForEditInPlace[p].imperialDigits!); // parseFloat(this.dataSheet[_i].colValue![k]).toFixed(this.roundDigitsForEditInPlace[p].imperialDigits!);
            this.dataSheet[_i].colType = 'number';
          }
        }
      }
    }
  }

  getRoundDigits(row: number, colName: string): number {
    let _i: number = this.roundDigitsForEditInPlace.findIndex(x => x.fieldName?.toLowerCase() == colName.toLowerCase());
    if (_i == -1) return 2;
    let _iUS: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'unitsystem');
    let _unitSystem = this.dataSheet[_iUS].colValue![row];
    if (_unitSystem == 'Metric')
      return this.roundDigitsForEditInPlace[_i].metricDigits!;

    if (_unitSystem == 'Imperial')
      return this.roundDigitsForEditInPlace[_i].imperialDigits!;

    return 2;
  }

  // MQF-370 - Obsolete values - GBR 12/04/2024
  checkDataObsolete() {
    // I campi da verificare sono: SMS, NormGrades, Nps, RawMaterialGrade, MarketFamily e SurfaceType
    // Inizio con NPS, perchè NormGrade e Raw sono dipendenti
    // this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getNpsAndSchedules().subscribe(res => {
      let _dataSetNps: any[] = new Array();
      if (res) {
        _dataSetNps = res.npsSchedules!;
        for (var x = 0; x < this.dataSet.length; x++) {
          if (this.dataSet[x].npsSchedule) {
            if (_dataSetNps.findIndex(n => n.npsScheduleId == this.dataSet[x].npsSchedule.npsScheduleId) == -1) {
              this.dataSet[x].npsSchedule = undefined;
              this.dataSet[x].od = "";
              this.dataSet[x].odUom = "";
              this.dataSet[x].wt = "";
              this.dataSet[x].wtUom = "";
            }
          }
        }
      }
      // NORMGRADES
      this.subscriptions.add(this.backendService.getNormGrades([]).subscribe(res => {
        if (res && res.normGrades) {
          let _normGradesDataset: NormGrade[] = new Array();
          let _idToRemove: number[] = new Array();
          if (res) {
            _normGradesDataset = res.normGrades!;
            for (var x = 0; x < this.dataSet.length; x++) {
              for (var k = 0; k < this.dataSet[x]?.normGrades?.length; k++) {
                let _p: number = _normGradesDataset.findIndex(n => n.normGradeId == this.dataSet[x].normGrades[k].normGradeId);
                if (_p == -1) {
                  _idToRemove.push(this.dataSet[x].normGrades[k].normGradeId);
                }
              }
              for (var k = 0; k < _idToRemove.length; k++) {
                this.dataSet[x].normGrades = this.dataSet[x].normGrades.filter((i: { normGradeId: number; }) => i.normGradeId != _idToRemove[k]);
              }

              // Se devo rimuovere NormGrades devo anche rimuovere Limitations e RawMaterialGrades
              if (_idToRemove.length > 0) {
                let _emptyLim = new ItemLimitation();
                _emptyLim.isCustom = true;
                _emptyLim.limitation = "";
                this.dataSet[x].gradeCustomerAnalysisLimitation = _emptyLim;
                this.dataSet[x].gradeCustomerOtherLimitation = _emptyLim;
                this.dataSet[x].rawMaterialGrade = null;
              }
            }
          }

          this.checkOtherDataObsolete();
          this.validateMaterialCodesOnLoad().then(materialCodesCleared => {
            this.afterAllProcessData();
            if (materialCodesCleared) {
              this.changedDataset.emit(this.dataSet);
            }
          });

          // commento sotto perchè la validazione calcola ed eventualmente rimuove le rm

          // // RAW MATERIAL GRADES (solo se non ho rimosso NormGrades)
          // if (_idToRemove.length === 0) {
          //   const rawMaterialPromises = this.dataSet.map(async (item) => {
          //     let _ids = item?.normGrades?.map((normGrade: any) => normGrade.normGradeId);
          //     let _analysisLim = typeof item.gradeCustomerAnalysisLimitation === 'object' ? item.gradeCustomerAnalysisLimitation.limitation! : item.gradeCustomerAnalysisLimitation;
          //     let _otherLim = typeof item.gradeCustomerOtherLimitation === 'object' ? item.gradeCustomerOtherLimitation.limitation! : item.gradeCustomerOtherLimitation;

          //     if (_analysisLim && _otherLim)
          //       return this.backendService.getRawMaterialGradesFromNormGradesAndLimitationsAsync(_ids, _analysisLim, _otherLim).then(res => {
          //         if (res && res.rawMaterialGrades) {
          //           if (!item.rawMaterialGrade || res.rawMaterialGrades.findIndex(m => m.rawMaterialGradeId == item.rawMaterialGrade.rawMaterialGradeId) === -1) {
          //             item.rawMaterialGrade = undefined;
          //           }
          //         }
          //       });
          //   });
          //   this.teiasoftLoader.start();
          //   // Wait for all RawMaterialGrades API calls to complete
          //   Promise.all(rawMaterialPromises).then(() => {
          //     this.checkOtherDataObsolete();
          //     this.afterAllProcessData();
          //     this.teiasoftLoader.stop();
          //   });
          // } else {

          // }
        }
      }));
    }));
  }

  private async validateMaterialCodesOnLoad(): Promise<boolean> {
    const rowsByMaterialCode = new Map<string, { materialCode: string; rowIndexes: number[] }>();

    this.dataSet.forEach((item, rowIndex) => {
      const materialCode = item?.material?.materialCode?.toString().trim();
      if (!materialCode) {
        return;
      }

      const normalizedMaterialCode = materialCode.toLowerCase();
      const current = rowsByMaterialCode.get(normalizedMaterialCode);
      if (current) {
        current.rowIndexes.push(rowIndex);
      } else {
        rowsByMaterialCode.set(normalizedMaterialCode, { materialCode, rowIndexes: [rowIndex] });
      }
    });

    let materialCodesCleared = false;
    await Promise.all(Array.from(rowsByMaterialCode.values()).map(async ({ materialCode, rowIndexes }) => {
      try {
        await this.getItemAttributesByMaterialCodeCached(materialCode, this.enquiry.header?.unitSystem!);
      } catch (error) {
        if (!this.isMaterialCodeUnavailableError(error)) {
          return;
        }

        rowIndexes.forEach(rowIndex => {
          this.dataSet[rowIndex].material = null;
          this.materialAttributesByRow.delete(rowIndex);
        });
        materialCodesCleared = true;
      }
    }));

    return materialCodesCleared;
  }

  private isMaterialCodeUnavailableError(error: unknown): boolean {
    return error === this.translate.instant('errors.400040');
  }

  checkOtherDataObsolete() {
    // Ciclo dentro il dataset
    let _i: number = -1;
    let _k: number = -1;
    for (var x = 0; x < this.dataSet.length; x++) {
      // NormGrades (creo una nuova lista che esclude quelli che non sono più validi)
      // Spostata dentro la getNormGrades

      // RawMaterialGrade
      // Qui i dati si aggiornano sulla base dell'esito del check nella getNormGrades

      // SMS
      _k = -1;
      if (this.dataSet[x].sms != null) _k = this.itemParameterValues.sms!.findIndex(s => s.smsId == this.dataSet[x].sms!.smsId);
      if (_k == -1) {
        this.dataSet[x].sms = undefined;
      }

      // MarketFamily
      _k = -1;
      if (this.dataSet[x].marketFamily != null) _k = this.itemParameterValues.marketFamily!.findIndex(m => m.marketFamilyId == this.dataSet[x].marketFamily!.marketFamilyId);
      if (_k == -1) {
        this.dataSet[x].marketFamily = undefined;
      }

      // SurfaceType
      _k = -1;
      if (this.dataSet[x].surfaceType != null) _k = this.itemParameterValues.surfaceTypes!.findIndex(s => s.surfaceTypeId == this.dataSet[x].surfaceType!.surfaceTypeId);
      if (_k == -1) {
        this.dataSet[x].surfaceType = undefined;
      }




    }
  }

  onColumnWidthUpdate(gridConfiguration: GridConfiguration) {
    gridConfiguration.gridColumns = gridConfiguration.gridColumns?.filter(gc => this.columnsToShow.findIndex(x => x.toLowerCase() == gc.name?.toLowerCase()) != -1);
    this.gridConfiguration = new GridConfiguration()
    this.gridConfiguration = gridConfiguration;
    this.setDimensions();
    this.saveGridConfiguration(gridConfiguration);
  }

  onColumnResizeEnd() {
    this.teiasoftLoader.start();
    this.resizableColumnsService.columnResized();
  }

  saveGridConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.updateUserConfiguration();
  }

  updateUserConfiguration() {
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(() => {
      localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    });
  }

  /**
   * SET GRID DIMENSION
   */
  setDimensions() {
    this.rowWidth = 0;

    const visibleColumns = (this.gridConfiguration.gridColumns ?? []).filter(gc => gc.visible !== false);
    for (var x = 0; x < visibleColumns.length; x++) {
      this.rowWidth = this.rowWidth + (visibleColumns[x].width ?? this.DEFAULT_COL_WIDTH);
    }
    this.rowWidth = this.rowWidth + (visibleColumns.length * 2);  // add extra pixel for each visible column

  }

  /**
   * GET WIDTH OF EACH COLUMN
   * @param values 
   * @returns 
   */
  getColWidth(values: any[]): number {
    //let _defaultW: number = 10;
    // Prendo il primo valore che non sia null
    let _val: any;
    for (var k = 0; k < values.length; k++) {
      if (values[k] != null) {
        _val = values[k];
      }
    }

    if (typeof _val == 'object' && _val != null) {
      return this.defaultW + 10;
    } else {
      if (values.filter(x => x != null).length > 0) {
        let _length: number = 0;
        _length = values.filter(x => x != null).sort(
          function (a, b) {
            return b.length - a.length;
          })[0].toString().length;
        let _w: number = _length * 0.65;
        return _w < this.defaultW ? this.defaultW : _w;
      } else {
        return this.defaultW;
      }
    }
  }

  /**
   * GET CELL VALUE IF IS A OBJECT
   * @param col 
   * @param obj 
   * @returns 
   */
  getObjectValue(col: string, obj: any): string {
    if (obj == null || obj.length == 0) return '';

    if (col.toLowerCase() == 'unitsystem' || col.toLowerCase() == 'quantityuom' || col.toLowerCase() == 'oduom'
      || col.toLowerCase() == 'iduom' || col.toLowerCase() == 'wtuom' || col.toLowerCase() == 'typeoftolerance' || col.toLowerCase() == 'lengthtype'
      || col.toLowerCase() == 'lengthuom' || col.toLowerCase() == 'ut' || col.toLowerCase() == 'hydrotest' || col.toLowerCase() == 'endscondition'
      || col.toLowerCase() == 'ht' || col.toLowerCase() == 'htadditional' || col.toLowerCase() == 'inspectiontype3dot2' || col.toLowerCase() == 'multiplecutting'
      || col.toLowerCase() == 'testcondition' || col.toLowerCase() == 'totalweightuom' || col.toLowerCase() == 'marketingroute'
      || col.toLowerCase() == 'odtoleranceuom' || col.toLowerCase() == 'idtoleranceuom' || col.toLowerCase() == 'wttoleranceuom')
      return obj;

    if (col.toLowerCase() == 'normgrades')
      return obj.map((i: any) => i["normGradeCode"]).join(',');

    if (col.toLowerCase() == "rawmaterialgrade")
      return obj["rawMaterialGradeCode"];

    if (col.toLowerCase() == "material")
      return obj["materialCode"];

    if (col.toLowerCase() == "sms")
      return obj["description"];

    if (col.toLowerCase() == "marketfamily")
      return obj["name"];

    if (col.toLowerCase() == "surfacetype")
      return obj["name"];

    if (col.toLowerCase() == "sql")
      return obj["name"];

    if (col.toLowerCase() == "offerscheme") {
      if (typeof obj === 'string') return obj;
      return obj["offerSchemeDescription"] ?? obj["offerSchemeCode"] ?? '';
    }

    if (col.toLowerCase() == "mill")
      return obj["shortName"];

    if (col.toLowerCase() == "npsschedule")
      return obj["npsDescription"];


    if (col.toLowerCase() == "gradecustomeranalysislimitation")
      return obj["limitation"];


    if (col.toLowerCase() == "gradecustomerotherlimitation")
      return obj["limitation"];

    if (col.toLowerCase() == 'tubeexecution')
      return obj["description"]

    return '--';
  }

  /**
   * GET CELL VALUES IF IS A OBJECT AND RETURN AN ARRAY (FOR NORMGRADES)
   * @param col 
   * @param obj 
   * @returns 
   */
  getObjectValues(col: string, obj: any[]): any[] {
    if (obj == null || obj.length == 0) return [];

    let _ret: any[] = new Array();
    if (col.toLowerCase() == 'normgrades') {
      for (var x = 0; x < obj.length; x++) {
        if (obj[x] && obj[x]["normGradeCode"])
          _ret.push(obj[x]["normGradeCode"]);
      }
      //return obj.map((x: { [x: string]: any; }) => x["normGradeCode"]);
    }
    return _ret;
  }

  /**
   * GET CELL VALUE
   * @param value 
   * @returns 
   */
  getValue(value: any, row: number, colName: string): any {
    if (value == null || value == undefined || value === '') return '';
    if (typeof value == 'object' && value["npsDescription"]) return value["npsDescription"];
    if (typeof value !== 'number') {
      //return parseFloat(value).toFixed(this.getRoundDigits(row,colName));
      return value;
    }

    const _date = getDateOnlyDisplayDate(value) || new Date(value);
    const _refDate = new Date('2000-01-01')
    if (!isNaN(_date.getTime()) && _date.getTime() > _refDate.getTime()) {
      // If not assigned in input
      // MQF-284 - E' sbagliato prendere la lingua del browser. Usiamo la global dateFormat già settata sulla lungua dell'utente
      /* if (this.dateFormat == '' || this.dateTimeFormat == '') {
        let _lang: string = navigator.language.slice(0, 2) == 'it' ? 'it' : 'en';
        this.dateFormat = _lang == 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
        this.dateTimeFormat = _lang == 'en' ? 'MM/dd/yyyy HH:mm' : 'dd/MM/yyyy HH:mm';
      }
      return this.datePipe.transform(_date, this.dateFormat); */
      return this.datePipe.transform(_date, this.globals.dateFormat!);
      // END MQF-284

    }
    return value.toFixed(this.getRoundDigits(row, colName)); // number: return the number without truncating
  }

  getEditDateValue(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    return value.toString();
  }

  hasDateValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  getBooleanValue(value: any, row: number, colName: string): string {
    if (value === true) return this.translate.instant("noTranslations.yes");
    if (value === false) return this.translate.instant("noTranslations.no");

    return '';
  }

  /**
   * CHECK IF A ROW IS SELECTED
   * @param rowNum 
   * @returns 
   */
  getIfImChecked(rowNum: number): boolean {
    if (!this.mapSelected || this.mapSelected.length === 0) return false;
    return this.mapSelected.findIndex(x => x.row === rowNum) !== -1;
  }

  /**
   * CHECK IF A CELL IS IN MAPSELECTED (FOR CSS STYLE) TO COLOR BACKGROUND
   * @param row 
   * @param col 
   * @returns 
   */
  selectedCell(row: number, col: number): boolean {
    if (!this.mapSelected || this.mapSelected.length == 0) return false;
    // Cerco questa colonna con idedit a true
    let _i: number = this.mapSelected.findIndex(x => x.col == col && x.row == row); // && x.inEdit == true);
    if (_i != -1) {
      if (this.mapSelected[_i].inEdit)
        return false;
      else
        return true;
    }
    else {
      return false;
    }

  }

  /**
   * CHECK IF A CELL IS IN EDIT
   * @param row 
   * @param col 
   * @returns 
   */
  isInEdit(row: number, col: number): boolean {
    if (!this.mapSelected || this.mapSelected.length == 0) return false;
    let _item = this.mapSelected.find(x => x.col == col && x.row == row);
    if (_item && _item.inEdit)
      return true;
    return false;
  }

  isSelectionCheckboxDisabled(row: number): boolean {
    // MQF-333: check if this row was marked as to be deleted and user is in edit mode
    const itemNoIndex = 0;
    if (this.mapSelected.some(x => x.inEdit) && this.itemsNoToDelete.includes(this.dataSheet[itemNoIndex].colValue![row])) return true;

    if (!this.mapSelected || this.mapSelected.length == 0) return false;
    return this.mapSelected.filter(x => x.row == row && x.inEdit == true).length > 0;
  }

  /**
   * 
   * @param col 
   * @returns 
   */
  isColInEdit(col: number): boolean {
    if (!this.mapSelected || this.mapSelected.length == 0) return false;
    let _item: MapSelected = new MapSelected();
    _item = this.mapSelected.filter(x => x.col == col)[0];
    if (_item)
      return _item.inEdit!;
    else
      return false;
  }

  handleKeydown(event: KeyboardEvent, rowIndex: number, colIndex: number): void {
    if (event.key === 'Tab' || event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();

      // Determine next or previous cell based on Shift key
      const isShiftPressed = event.shiftKey;
      let nextRowIndex = rowIndex;
      let nextColIndex = isShiftPressed ? colIndex - 1 : colIndex + 1;

      // Handle row and column boundaries
      const lastColumnIndex = this.dataSheet.length - 1;

      if (nextColIndex > lastColumnIndex) {
        nextColIndex = 0;
        nextRowIndex += 1;
      } else if (nextColIndex < 0) {
        nextColIndex = lastColumnIndex;
        nextRowIndex -= 1;
      }

      // Handle out-of-bounds rows
      if (nextRowIndex >= this.dataSheet[0].colValue!.length) {
        nextRowIndex = 0;
      } else if (nextRowIndex < 0) {
        nextRowIndex = this.dataSheet[0].colValue!.length - 1;
      }

      // Focus the next cell
      const { nextCell, newNextColIndex } = this.getNextCell(nextRowIndex, nextColIndex);

      if (nextCell) {
        nextCell.focus();
        // MP: i can't find a better solution so far, when clicking norm grade we simulate click and focus
        if (this.dataSheet[newNextColIndex].colName?.toLowerCase() == 'normgrades' || this.dataSheet[newNextColIndex].colName?.toLowerCase() == 'rawmaterialgrade' || this.dataSheet[newNextColIndex].colName?.toLowerCase() == 'mill' || this.dataSheet[newNextColIndex].colName?.toLowerCase() == 'material') {
          nextCell.click();
          setTimeout(() => {
            // Find the autocomplete inside the teiasoft-input component
            const inputElement = nextCell.querySelector('teiasoft-input .ti-cnt') as HTMLElement;
            if (inputElement) {
              inputElement.click();
            }
          }, 250);

        }
        else if (this.dataSheet[newNextColIndex].colName?.toLowerCase() == 'customerdeliverydate') {
          nextCell.click();
          setTimeout(() => {
            // Find the autocomplete inside the teiasoft-input component
            const inputElement = nextCell.querySelector('teiasoft-datetime .tdt-cnt input') as HTMLElement;
            if (inputElement) {
              inputElement.focus();
            }
          }, 250);

        }
        else {
          setTimeout(() => {
            nextCell.click();
          }, 0);
        }
      }

    }

    if (event.key === 'Escape') {
      this.mapSelected?.forEach(ms => this.undoChange(ms.row!, ms.col!, true));
      this.closeEditLight();
    }
  }

  getNextCell(nextRowIndex: number, nextColIndex: number): any {
    if (nextColIndex >= this.dataSheet.length) {
      nextColIndex = 0;
      nextRowIndex = (nextRowIndex + 1) % this.dataSheet[0].colValue!.length;
    } else if (nextColIndex < 0) {
      nextColIndex = this.dataSheet.length - 1;
      nextRowIndex = (nextRowIndex - 1 + this.dataSheet[0].colValue!.length) % this.dataSheet[0].colValue!.length;
    }

    if (!this.isToDisable(nextRowIndex, nextColIndex, this.dataSheet[nextColIndex].colName!) && !this.isToLock(nextRowIndex, nextColIndex, this.dataSheet[nextColIndex].colName!) && this.dataSheet[nextColIndex].colName?.toLowerCase() != 'npsschedule') {
      const nextCell = document.querySelector(
        `.tds-cell[tabindex="${nextRowIndex}"][data-row="${nextRowIndex}"][data-col="${nextColIndex}"]`
      ) as HTMLElement;
      return { nextCell, newNextColIndex: nextColIndex };
    }
    else {
      return this.getNextCell(nextRowIndex, nextColIndex + 1);
    }
  }


  /**
   * SE CELL IN EDIT MODE
   * @param row 
   * @param col 
   * @param colName 
   * @param colValue 
   */
  makeMeEditable(row: number, col: number, colName: string, colValue: any, colType: string, evt: MouseEvent) {


    let _i: number = -1;
    // ****** CHECK EDITABILITA' **************************************/
    if (this.mapSelected.length > 0 && this.mapSelected.findIndex(selection => selection.row == row) == -1) {
      // user hit a not selected row
      if (this.mapSelected.length > 1 && !this.valueChanged) {
        this.closeEditLight();
        return;
      }
      if (this.mapSelected.length > 1 && this.valueChanged)
        this.showPendingChangesDialog(1);
    }

    if (this.mapSelected.length > 0 && this.mapSelected.findIndex(slc => slc.col === col && slc.row === row && slc.inEdit == true) != -1) {
      // this cell is already in edit mode
      return;
    }
    if (this.mapSelected.length > 0 && this.mapSelected.findIndex(slc => slc.col === col && slc.row === row && slc.inEdit == true) == -1) {
      // this cell is not in edit mode, check if one of selected has pending edit
      if (this.mapSelected.some(slc => slc.inEdit == true) && this.valueChanged) {
        this.showPendingChangesDialog(2);
        return;
      }
    }


    if (this.isToLock(row, col, colName)) {
      return;
    }

    if (colName.toLowerCase() == 'itemno' || colName.toLowerCase() == 'unitsystem') {
      this.teiasoftToaster.show("info", this.translate.instant("errors.fieldNotEditable"));
      return;
    }

    for (var x = 0; x < this.mapSelected.length; x++) {
      if (this.mapSelected[x].col == col && this.mapSelected[x].row == row && this.mapSelected[x].inEdit) { return };
    }

    // Verifico se questo item è nella lista da cancellare
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'itemno');
    let _itemNo: string = this.dataSheet[_i].colValue![row];
    if (this.itemsNoToDelete.findIndex(x => x == _itemNo) != -1) {
      this.teiasoftToaster.show("info", this.translate.instant("errors.selectionNotEditable"));
      return;
    }

    // Se ho più celle selezionate e clicco fuori da una di quelle selezionate, svuoto tutto e vado avanti
    if (this.mapSelected && this.mapSelected.length > 0 && this.mapSelected.findIndex(x => x.row == row) == -1) {
      this.closeEdit();
    }

    // Se sto toccando una Uom e ho una warning per differenti UnitSystem esco
    if (colName.toLowerCase().indexOf("uom") != -1 && this.logOperations.findIndex(x => x.code == this.unitSystemError) != -1) {
      return;
    }

    // Se sto toccando una Limitation o RawMaterial e ho una warning per differenti NormGrade
    if (colName.toLowerCase().indexOf("rawmaterial") != -1 && this.logOperations.findIndex(x => x.code == this.differentNormGradesError) != -1) {
      return;
    }

    if (colName.toLowerCase().indexOf("limitation") != -1 && this.logOperations.findIndex(x => x.code == this.differentNormGradesError) != -1) {
      return;
    }

    // Se ho più righe selezionate di tipologia diversa (in edit e in delete) non è possibile modificare le celle
    if (this.isSelectionEditAndDeleteMix()) {
      this.teiasoftToaster.show("info", this.translate.instant("errors.selectionNotEditable"));
      return;
    }

    // MQF-278 - Se la tube execution è custom a false non posso editare le tolerances
    if (colName.toLowerCase().indexOf("wttoleranceplus") != -1 || colName.toLowerCase().indexOf("wttoleranceminus") != -1) {
      _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'tubeexecution');
      let _tE: TubeExecution = this.dataSheet[_i].colValue![row];
      if (_tE.isCustom == false) {
        return;
      }
    }

    /*********** CHECK VALIDITA' *************************************/
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'npsschedule');
    let _iVeSchedule: boolean = false;
    if (!this.mapSelected || this.mapSelected.length == 0) {
      if (this.dataSheet[_i].colValue![row] != '' && this.dataSheet[_i].colValue![row] != null) {
        _iVeSchedule = true;
      }
    } else {
      for (var x = 0; x < this.mapSelected.length; x++) {
        if (this.dataSheet[_i].colValue![this.mapSelected[x].row!] != '' && this.dataSheet[_i].colValue![this.mapSelected[x].row!] != null) {
          _iVeSchedule = true;
          break;
        }
      }
    }

    // Se sto toccando OD & WT ho uno schedule sulla riga apro NPS
    if (colName.toLowerCase() == 'od' || colName.toLowerCase() == 'id' || colName.toLowerCase() == 'wt' ||
      colName.toLowerCase() == 'oduom' || colName.toLowerCase() == 'iduom' || colName.toLowerCase() == 'wtuom') {
      if (_iVeSchedule) {
        if (colName.toLowerCase() != 'id' && colName.toLowerCase() != 'iduom') {
          this.writeLog("warning", this.translate.instant('errors.dimWithNps'), this.npsError);
          this.closeEditLight();
          return;
        } else {
          this.writeLog("warning", this.translate.instant('errors.idWithNps'), this.npsError);
          this.closeEditLight();
          return;
        }
      }
    }

    // Se sto toccando le altre uom eho differenti UnitSystem selezionati
    if (colName.toLowerCase() == 'quantityuom' || colName.toLowerCase() == 'lengthuom' || colName.toLowerCase() == 'totalweightuom') {
      // Verifico nel log se ho errori relativi allo unit system
      let _i: number = this.logOperations.findIndex(x => x.code == this.unitSystemError);
      if (_i != -1) {
        this.writeLog("error", this.translate.instant('errors.uomsDifferentUnitSystem'), this.uomsDifferentUnitSystemError);
        this.closeEditLight();
        return;
      }
    }

    // Se sto toccando npsschedule
    if (colName.toLowerCase() == 'npsschedule') {
      // Verifico nel log se ho errori relativi allo unit system
      let _i: number = this.logOperations.findIndex(x => x.code == this.unitSystemError);
      if (_i != -1) {
        // Non posso cambiare nps se ho unitsystem differenti selezionati
        this.writeLog("error", this.translate.instant('errors.npsWithDifferentUnitSystem'), this.uomsDifferentUnitSystemError);
        this.closeEditLight();
        return;
      }
      this.selectedNpsRow = new NpsAndSchedule();
      this.selectedNpsRow = this.dataSheet[col].colValue![row];
    }

    // Check limitation
    // Se nella selezione le normgrades sono diverse impedisco l'edit
    if (this.mapSelected && this.mapSelected.length > 1 && (colName.toLowerCase() == 'gradecustomeranalysislimitation' || colName.toLowerCase() == 'gradecustomerotherlimitation')) {
      // Verifico se per tutte le selezioni ho lo stesso NormGrade
      let _prev: string = "";
      let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'normgrades');
      for (var m = 0; m < this.mapSelected.length; m++) {
        if (m == 0) {
          _prev = JSON.stringify(this.dataSheet[_i].colValue![this.mapSelected[m].row!].sort((a: any, b: any) => { return a.normGradeId - b.normGradeId }));
        } else {
          if (_prev != JSON.stringify(this.dataSheet[_i].colValue![this.mapSelected[m].row!].sort((a: any, b: any) => { return a.normGradeId - b.normGradeId }))) {
            this.writeLog("error", this.translate.instant('errors.limitationDifferentNormGrades'), this.differentNormGradesError);
            this.closeEditLight();
            this.mapSelected = new Array();
            return;
          } else {
            _prev = JSON.stringify(this.dataSheet[_i].colValue![this.mapSelected[m].row!]);
          }
        }
      }
    }

    // MQF-286 - Se una o più normgrades non sono nella lista dei 100 le aggiungo
    if (colName.toLowerCase() == 'normgrades') {
      let _i: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'normgrades');
      let _iMaterial: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'material');

      let material = this.dataSheet[_iMaterial].colValue![row];

      if (material) {
        this.setNormsByMaterial(material);
      }
      else {
        this.normGradesDataset = this.normGradesDataset_Cache;
        let _temp: NormGrade[] = new Array();
        _temp = this.dataSheet[_i].colValue![row];
        if (_temp && _temp.length > 0) {
          for (var x = 0; x < _temp.length; x++) {
            if (this.normGradesDataset.findIndex(n => n.normGradeId == _temp[x].normGradeId) == -1)
              this.normGradesDataset!.unshift(_temp[x]);
          }
        }
      }

      //if (this.mapSelected && this.mapSelected.length > 0){

      //}
    }

    if (colName.toLowerCase() == 'sms') {
      let _i: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'marketingroute');
      let marketingRoute = this.dataSheet[_i].colValue![row];
      this.smsOptionList = this.getSmsOptionList(marketingRoute);
    }

    if (colName.toLowerCase() == 'tubeexecution') {
      let _i: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'marketingroute');
      let marketingRoute = this.dataSheet[_i].colValue![row];
      this.tubeExecutionOptionList = this.getTubeExecutionOptionList(marketingRoute);
    }

    if (colName.toLowerCase() == 'surfacetype') {
      let _i: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'marketingroute');
      let marketingRoute = this.dataSheet[_i].colValue![row];
      this.surfaceTypeOptionList = this.getSurfaceTypeOptionList(marketingRoute);
    }

    if (colName.toLowerCase() == 'sql') {
      this.ensureSqlOptionsForRow(row);
    }


    /*** FINE CHECK */

    // SIMULO IL CLICK SULLA CHECKBOX
    //this.onSelectRow(row);

    // Se sono UOMS
    if (colName.toLowerCase().endsWith('uom')) {
      // Prendo lo UnitSystem per la riga selezionata
      let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'unitsystem');
      let _unitSystem: string = this.dataSheet[_i].colValue![row];

      if (colName.toLowerCase() == 'quantityuom') {
        this.quantityUomsList = new Array();
        this.quantityUomsList = this.getUoms('quantityUoms', _unitSystem);
      }

      if (colName.toLowerCase() == 'oduom') {
        this.odUomsList = new Array();
        this.odUomsList = this.getUoms('odUoms', _unitSystem);
      }

      if (colName.toLowerCase() == 'iduom') {
        this.idUomsList = new Array();
        this.idUomsList = this.getUoms('idUoms', _unitSystem);
      }

      if (colName.toLowerCase() == 'wtuom') {
        this.wtUomsList = new Array();
        this.wtUomsList = this.getUoms('wtUoms', _unitSystem);
      }

      if (colName.toLowerCase() == 'lengthuom') {
        this.lengthUomsList = new Array();
        this.lengthUomsList = this.getUoms('lengthUoms', _unitSystem);
      }

      if (colName.toLowerCase() == 'totalweightuom') {
        this.totalWeightUomsList = new Array();
        this.totalWeightUomsList = this.getUoms('totalWeightUoms', _unitSystem);
      }

      if (colName.toLowerCase() == 'wttoleranceuom' || colName.toLowerCase() == 'idtoleranceuom' || colName.toLowerCase() == 'odtoleranceuom') {
        this.toleranceUomsList = new Array();
        this.toleranceUomsList = this.getUoms('toleranceUoms', _unitSystem);
      }
    }

    // Se sono GradeCustomerAnalysisLimitatiom
    if (colName.toLowerCase() == 'gradecustomeranalysislimitation' || colName.toLowerCase() == 'gradecustomerotherlimitation') {
      let _val: ItemLimitation = new ItemLimitation();
      _val = colValue!;
      if (_val && (_val.isCustom == false || (_val.isCustom == true && _val.limitation == ''))) {
        let _i: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'normgrades');
        let _values: NormGrade[] = this.dataSheet[_i].colValue![row];
        let _ids: number[] = new Array();
        for (var x = 0; x < _values.length; x++) {
          _ids.push(_values[x].normGradeId!);
        }
        this.getLimitationsForNormGrades(_ids, true, colName); // MQF-352
      }
    }

    // Metto in edit la riga cliccata
    /*     this.mapSelected = this.mapSelected.map(s => {
          if (s.row === row) {
            s.inEdit = true;
          }
          return s;
        }); */

    // Setto la colonna selezionata
    this.selectedCol = col;
    this.selectedRow = row;
    if (this.dataSheet[col]!.colValue![row] != undefined) // MWF-370 - Obsolete Value GBR 12/07/2024
      this.originalValue = JSON.parse(JSON.stringify(this.dataSheet[col]!.colValue![row]!)); // deep copy

    /* if (colType == 'string' || colType == 'number')
      setTimeout(() => $('.edit-input').focus(), 100);

    if (colType == 'select' || colType == 'boolean')
      setTimeout(() => $('.ts-select').focus(), 100);
 */
    if (colName.toLowerCase() == 'npsschedule')
      this.getNpsAndSchedules();

    if (colName.toLowerCase() == 'mill')
      this.prepareModalObject(evt);



    // MQF-240 - Salto da cella a cella
    if (this.mapSelected.length < 2) {
      this.closeEdit();
      let _item: MapSelected = new MapSelected();
      _item.col = col;
      _item.row = row;
      _item.inEdit = true;
      this.mapSelected.push(_item);
    } else {
      for (let x = 0; x < this.mapSelected.length; x++) {
        this.mapSelected[x].col = col;
        this.mapSelected[x].inEdit = false;
      }
      _i = this.mapSelected.findIndex(x => x.row == row);
      this.mapSelected[_i].inEdit = true;
    }
    /** END MQF-240 */

    // MQF-228 Se sono RawMaterialGrade devo ricaricare la lista ogni volta
    if (colName.toLowerCase() == 'rawmaterialgrade') {
      // In questo caso basta prendere il primo selezionato che poi vale per tutti
      let _iAl: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
      let _iOl = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomerotherlimitation');
      let _analysisValue: ItemLimitation = this.dataSheet[_iAl].colValue![this.mapSelected[0].row!];
      let _otherValue: ItemLimitation = this.dataSheet[_iOl].colValue![this.mapSelected[0].row!];
      let _i: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'normgrades');
      let _values: NormGrade[] = this.dataSheet[_i].colValue![row];
      let _ids: number[] = new Array();
      for (var x = 0; x < _values.length; x++) {
        _ids.push(_values[x].normGradeId!);
      }
      const currentRmId = this.dataSheet[col].colValue![row]?.rawMaterialGradeId;
      this.getRawMaterialGradesFromNormGradesAndLimitations('', _ids, _analysisValue, _otherValue, currentRmId);
    }

    this.checkDataOnSelection();

    this.focusEditableCell(row, col, colType);

  }

  private focusEditableCell(row: number, col: number, colType: string): void {
    const selectSelectors = ['select', '.ts-select'];
    const textSelectors = ['input:not([type="hidden"])', '.input', '.ti-input', '.edit-input', 'textarea', '[contenteditable="true"]', 'teiasoft-datetime input'];
    const selectors = (colType === 'select' || colType === 'boolean') ? [...selectSelectors, ...textSelectors] : textSelectors;

    setTimeout(() => {
      const cell = document.querySelector<HTMLElement>(`.tds-cell[data-row="${row}"][data-col="${col}"]`);
      if (!cell) {
        return;
      }

      for (const selector of selectors) {
        const element = cell.querySelector<HTMLElement>(selector);
        if (element) {
          element.focus();
          if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            element.select?.();
          }
          return;
        }
      }

      cell.focus();
    }, 0);
  }

  /**
   * PREPARE 
   * @param evt 
   */
  prepareModalObject(evt: MouseEvent) {
    $('.ti-autocomplete-cnt').css("width", "auto");
    $('.ti-autocomplete-cnt').css("left", (evt.clientX - $('.tds-cell').width()) + "px");
    $('.ti-autocomplete-cnt').css("top", (evt.clientY + 20) + "px");
  }

  /**
  * CHECK VALIDITY UNITSYSTEM (VERIFICA SE SERVE)
  * @param colName 
  * @returns 
  */
  /*   checkValidityUnitSystem(colName:string){
      // Se sto modificando UnitSystem e sulle stesse righe ho almeno uno schedule id devo valorizzare od e wt sulla base del sistema metrico selezionato
      if (colName.toLowerCase() == 'unitsystem'){
        let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'npsschedule');
        for (var x = 0; x < this.mapSelected.length; x++){
          if (this.dataSheet[_i].colValue![this.mapSelected[x].row!] != '' && this.dataSheet[_i].colValue![this.mapSelected[x].row!] != null){
            this.closeEdit();
            return;
          }
        }
      }
    } */

  /**
   * WITE LOG ON MODAL
   * @param type 
   * @param message 
   */
  writeLog(type: string, message: string, code: number) {
    if (!this.logOperations) this.logOperations = new Array();
    // Rimuovo eventuali log precedenti per lo stesso code prima di aggiungerlo
    this.removeLog(code);

    let _item: LogOperation = new LogOperation();
    _item.type = type;
    _item.message = message;
    _item.code = code;
    this.logOperations.unshift(_item);

    this.setFormValidity((this.cellsInError.length + this.cellsXlxsInError.length) === 0);
  }

  /**
   * REMOVE LOG
   */
  removeLog(code: number) {
    if (!this.logOperations) return;
    this.logOperations = this.logOperations.filter(x => x.code != code);

    this.setFormValidity((this.cellsInError.length + this.cellsXlxsInError.length) === 0);
  }

  /**
   * EMIT IF FORM IS VALID
   * @param isValid 
   */
  setFormValidity(isValid: boolean) {
    this.validForm.emit(isValid);
  }

  /**
   * GET BOOLEAN LIST
   */
  getBooleanList() {
    let _emptyOption: SelectOption = new SelectOption();
    _emptyOption.text = '';
    _emptyOption.value = null;

    this.booleanList = new Array();
    this.booleanList.push(_emptyOption);
    let _item: SelectOption = new SelectOption();
    /*     _item.text = "";
        _item.value = null;
        this.booleanList.push(_item);
        _item = new SelectOption(); */
    _item.text = this.translate.instant("noTranslations.yes");
    _item.value = true;
    this.booleanList.push(_item);
    _item = new SelectOption();
    _item.text = this.translate.instant("noTranslations.no");
    _item.value = false;
    this.booleanList.push(_item);
  }

  /**
   * GET UNIT SYSTEM
   */
  getUnitSystems() {
    this.unitSystemOptionList = new Array();
    this.unitSystemOptionList.push({ value: 'Metric', text: this.translate.instant("enquiryBook.metric") });
    this.unitSystemOptionList.push({ value: 'Imperial', text: this.translate.instant("enquiryBook.imperial") });
  }

  /**
   * GET UOMS
   * @param uom 
   * @param unitSystem 
   * @returns 
   */
  getUoms(uom: string, unitSystem: string): SelectOption[] {
    let _list: SelectOption[] = new Array();

    for (const prop in this.itemParameterValues) {
      if (prop.toString() == uom) {
        let _uoms: UomsType = new UomsType();
        _uoms = this.itemParameterValues[prop as keyof ItemParametersValues] as UomsType;
        if (unitSystem.toLowerCase() == 'metric') {
          for (var x = 0; x < _uoms.metricUoms!.length; x++) {
            let _item: SelectOption = new SelectOption();
            _item.text = _uoms.metricUoms![x].uomCode!;
            _item.value = _uoms.metricUoms![x].uomCode!;
            _list.push(_item);
          }
        } else {
          for (var x = 0; x < _uoms.imperialUoms!.length; x++) {
            let _item: SelectOption = new SelectOption();
            _item.text = _uoms.imperialUoms![x].uomCode!;
            _item.value = _uoms.imperialUoms![x].uomCode!;
            _list.push(_item);
          }
        }
      }
    }
    return _list;
  }

  /**
   * GET DEFAULT VALUES ON SELECT
   * @param value 
   * @param row 
   * @param col 
   * @returns 
   */
  getSelectDefalutValue(value: any, row: number, col: number): boolean {
    let _value: any = this.dataSheet![row].colValue![col];
    if (_value == null) return false;
    if (_value == value)
      return true;
    else
      return false;
  }

  getSelectDefalutValueObj(value: any, row: number, col: number): boolean {
    // GET object value
    let _value: any = this.dataSheet![row].colValue![col];
    let _colName: string = this.dataSheet![row].colName!;
    if (_value == null) return false;
    if (typeof _value == 'object') {
      if (_colName == 'TubeExecution') {
        _value = _value["tubeExecutionId"];
      }

      if (_colName == 'GradeCustomerOtherLimitation' || _colName == 'GradeCustomerAnalysisLimitation') {
        _value = _value["limitation"];
      }

      if (_colName == 'Sms') {
        _value = _value["smsId"];
      }

      if (_colName == 'MarketFamily') {
        _value = _value["marketFamilyId"];
      }

      if (_colName == "SurfaceType") {
        _value = _value["surfaceTypeId"];
      }

      if (_colName == "SurfaceType") {
        _value = _value["surfaceTypeId"];
      }
    }

    if (_value == value)
      return true;
    else
      return false;
  }

  /**
   * GET IF LIMITATION CUSTOM
   * @param row 
   * @param col 
   * @param colName 
   * @returns 
   */
  getIsCustomLimitation(row: number, col: number, colName: string): boolean {
    let _value: ItemLimitation = new ItemLimitation();
    _value = this.dataSheet[col].colValue![row];
    return _value && _value.isCustom == true ? true : false;
  }

  /**
   * SET FOR THIS ROW THE ISCUSTOM LIMITATION
   * @param row 
   * @param col 
   */
  onCheckLimitation(row: number, col: number, colName: string) {
    let _getLimitations: boolean = false;

    let _ids: number[] = new Array();
    let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'normgrades');
    let _values: NormGrade[] = this.dataSheet[_i].colValue![row];
    _ids = new Array();
    for (var x = 0; x < _values.length; x++) {
      _ids.push(_values[x].normGradeId!);
    }

    let inEditItemIndex = this.mapSelected.findIndex(x => x.inEdit);
    if (inEditItemIndex > -1) {
      let _value: ItemLimitation = new ItemLimitation();
      _value = this.dataSheet[this.mapSelected[inEditItemIndex].col!].colValue![this.mapSelected[inEditItemIndex].row!];

      if (!_value.isCustom) {
        _value.isCustom = true;
        _value.limitation = '';
        this.dataSheet[this.mapSelected[inEditItemIndex].col!].colValue![this.mapSelected[inEditItemIndex].row!] = _value;
        this.setValueOnDataSet(this.mapSelected[inEditItemIndex].row!, this.mapSelected[inEditItemIndex].col!, _value);
      }
      else {
        _value.isCustom = false;
        _value.limitation = '';
        this.dataSheet[this.mapSelected[inEditItemIndex].col!].colValue![this.mapSelected[inEditItemIndex].row!] = _value;
        this.setValueOnDataSet(this.mapSelected[inEditItemIndex].row!, this.mapSelected[inEditItemIndex].col!, _value);
        _getLimitations = true;
      }
      if (_getLimitations) {
        this.getLimitationsForNormGrades(_ids, true, colName);
      }
    }

  }

  /**
   * GET LIMITATION VALUE FOR EDIT INPUT
   * @param row 
   * @param col 
   * @returns 
   */
  getLimitationValue(row: number, col: number): string {
    let _value: ItemLimitation = new ItemLimitation();
    _value = this.dataSheet[col].colValue![row];
    return _value.limitation!;
  }

  /**
   * GET IF MY ROW HAS NORMGRADES
   * @param row 
   * @param col 
   * @returns 
   */
  thisRowHasNormgrades(row: number, col: number): boolean {
    let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'normgrades');
    if (!this.dataSheet[_i].colValue || !Array.isArray(this.dataSheet[_i].colValue![row]))
      return false;
    else
      return true;
  }

  getSmsOptionList(marketingroute: string): SelectOption[] {
    let smsOptionList = new Array();

    if (marketingroute) {
      let smsParams = this.itemParameterValues.sms!.filter(s => s.marketingRoute === marketingroute);
      for (var x = 0; x < smsParams.length; x++) {
        let _item: SelectOption = new SelectOption();
        _item.text = smsParams[x].description;
        _item.value = smsParams[x].smsId;
        smsOptionList.push(_item);
      }
    }
    return smsOptionList;
  }

  getTubeExecutionOptionList(marketingroute: string): SelectOption[] {
    let optionList = new Array();

    let _emptyOption: SelectOption = new SelectOption();
    _emptyOption.text = '';
    _emptyOption.value = null;
    optionList.push(_emptyOption);

    let tubeExecParameters = this.itemParameterValues.tubeExecution;

    if (marketingroute) {
      tubeExecParameters = tubeExecParameters?.filter(t => t.marketingRoute === marketingroute || t.isCustom);
    }

    for (var x = 0; x < tubeExecParameters!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = tubeExecParameters![x].description;
      _item.value = tubeExecParameters![x].tubeExecutionId;
      optionList.push(_item);
    }

    return optionList;
  }

  getSurfaceTypeOptionList(marketingroute: string): SelectOption[] {
    let optionList = new Array();

    let _emptyOption: SelectOption = new SelectOption();
    _emptyOption.text = '';
    _emptyOption.value = null;
    optionList.push(_emptyOption);

    let surfaceTypesParameters = this.itemParameterValues.surfaceTypes;

    if (marketingroute == 'Hot') {
      surfaceTypesParameters = surfaceTypesParameters?.filter(s => s.name !== 'IN BRIGHT CONDITION');
    }

    for (var x = 0; x < surfaceTypesParameters!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = surfaceTypesParameters![x].description;
      _item.value = surfaceTypesParameters![x].surfaceTypeId;
      optionList.push(_item);
    }

    return optionList;
  }

  /**
   * FILL OPTION LIST FOR SELECT
   */
  fillOptionLists() {
    let _emptyOption: SelectOption = new SelectOption();
    _emptyOption.text = '';
    _emptyOption.value = null;

    this.marketingRouteOptionList = new Array();

    let smsMarketingRouteOpts = [...new Set(this.itemParameterValues.sms!.map(s => s.marketingRoute))];

    for (var x = 0; x < smsMarketingRouteOpts.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = smsMarketingRouteOpts[x];
      _item.value = smsMarketingRouteOpts[x];
      this.marketingRouteOptionList.push(_item);
    }

    this.typeOfToleranceOptionList = new Array();
    this.typeOfToleranceOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.typeOfTolerance!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.typeOfTolerance![x].value;
      _item.value = this.itemParameterValues.typeOfTolerance![x].value;
      _item.isDefault = this.itemParameterValues.typeOfTolerance![x].isDefault;
      this.typeOfToleranceOptionList.push(_item);
    }


    this.marketFamilyOptionList = new Array();
    this.marketFamilyOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.marketFamily!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.marketFamily![x].name;
      _item.value = this.itemParameterValues.marketFamily![x].marketFamilyId;
      this.marketFamilyOptionList.push(_item);
    }

    this.htOptionList = new Array();
    this.htOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.ht!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.ht![x].value;
      _item.value = this.itemParameterValues.ht![x].value;
      this.htOptionList.push(_item);
    }


    this.htAdditionalOptionList = new Array();
    this.htAdditionalOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.htAdditional!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.htAdditional![x].value;
      _item.value = this.itemParameterValues.htAdditional![x].value;
      this.htAdditionalOptionList.push(_item);
    }

    this.testConditionOptionList = new Array();
    // this.testConditionOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.testCondition!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.testCondition![x].value;
      _item.value = this.itemParameterValues.testCondition![x].value;
      this.testConditionOptionList.push(_item);
    }

    this.sqlOptionList = new Array();
    this.sqlOptionList.push(_emptyOption);
    for (const sql of (this.itemParameterValues.sqls || [])) {
      const _item: SelectOption = new SelectOption();
      _item.text = sql.name;
      _item.value = sql.sqlId;
      this.sqlOptionList.push(_item);
    }
    this.defaultSqlOptionList = this.sqlOptionList.map(opt => ({ ...opt } as SelectOption));

    this.offerSchemeOptionList = new Array();
    this.offerSchemeOptionList.push(_emptyOption);
    for (const offerScheme of (this.itemParameterValues.offerSchemes || [])) {
      const _item: SelectOption = new SelectOption();
      _item.text = offerScheme.offerSchemeDescription ?? offerScheme.offerSchemeCode;
      _item.value = offerScheme.offerSchemeCode;
      this.offerSchemeOptionList.push(_item);
    }

    this.inspectionType3Dot2OptionList = new Array();
    this.inspectionType3Dot2OptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.inspectionType3dot2!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.inspectionType3dot2![x].value;
      _item.value = this.itemParameterValues.inspectionType3dot2![x].value;
      this.inspectionType3Dot2OptionList.push(_item);
    }

    this.multipleCuttingOptionList = new Array();
    this.multipleCuttingOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.multipleCutting!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.multipleCutting![x].value;
      _item.value = this.itemParameterValues.multipleCutting![x].value;
      this.multipleCuttingOptionList.push(_item);
    }

    this.surfaceTypeOptionList = new Array();
    this.surfaceTypeOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.surfaceTypes!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.surfaceTypes![x].name;
      _item.value = this.itemParameterValues.surfaceTypes![x].surfaceTypeId;
      this.surfaceTypeOptionList.push(_item);
    }

    this.utOptionList = new Array();
    this.utOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.ut!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.ut![x].value;
      _item.value = this.itemParameterValues.ut![x].value;
      this.utOptionList.push(_item);
    }

    this.hydroTesttOptionList = new Array();
    this.hydroTesttOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.hydroTest!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.hydroTest![x].value;
      _item.value = this.itemParameterValues.hydroTest![x].value;
      this.hydroTesttOptionList.push(_item);
    }

    this.endsConditionOptionList = new Array();
    this.endsConditionOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.endsCondition!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.endsCondition![x].value;
      _item.value = this.itemParameterValues.endsCondition![x].value;
      this.endsConditionOptionList.push(_item);
    }

    this.lengthTypeOptionList = new Array();
    this.lengthTypeOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.lengthType!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.lengthType![x].value;
      _item.value = this.itemParameterValues.lengthType![x].value;
      this.lengthTypeOptionList.push(_item);
    }

    this.tubeExecutionOptionList = new Array();
    this.tubeExecutionOptionList.push(_emptyOption);
    for (var x = 0; x < this.itemParameterValues.tubeExecution!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.tubeExecution![x].description;
      _item.value = this.itemParameterValues.tubeExecution![x].tubeExecutionId;
      this.tubeExecutionOptionList.push(_item);
    }

    this.millDataset = new Array();
    this.millDataset = this.itemParameterValues!.mills!;
  }

  /**
   * CHECK DATA VALIDITY 
   * @returns 
   */
  checkDataOnSelection() {
    let _i: number = -1;

    // Rimuovo i precedenti valori dal log
    this.removeLog(this.unitSystemError);
    this.removeLog(this.npsError);
    this.removeLog(this.uomsDifferentUnitSystemError);
    this.removeLog(this.differentNormGradesError);
    this.removeLog(this.differentLimitationsError);
    this.removeLog(this.differentTubeExecution);
    this.removeLog(this.differentUomsQty);
    this.removeLog(this.differentUomsOd);
    this.removeLog(this.differentUomsWt);
    this.removeLog(this.differentUomsId);
    this.removeLog(this.differentLengthUom);
    this.removeLog(this.differentMarketingRoute);
    this.removeLog(this.differentCts);
    this.removeLog(this.differentMaterialCodesError);
    this.removeLog(this.differentHydroTestEditabilityError);
    this.removeLog(this.differentWtDependentEditabilityError);
    this.removeLog(this.differentOdDependentEditabilityError);
    this.removeLog(this.differentIdDependentEditabilityError);


    //this.removeLog(this.millRuleActive);

    // All UNITSYSTEM Have to be equals / update: this is guaranteed by the enquiry model rules


    // Tutti i NormGrades devono essere uguali, perchè al momento della selezione non posso sapere se le RawMaterialGrade selezionate sono compatibili
    // con le relative NormGrade
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'normgrades');
    let _prevIds: number[] = new Array();
    for (var x = 0; x < this.mapSelected.length; x++) {
      let _ids: number[] = new Array();
      _ids = this.dataSheet[_i].colValue![this.mapSelected[x].row!] ? this.dataSheet[_i].colValue![this.mapSelected[x].row!].map((k: { [x: string]: any; }) => k["normGradeId"]) : [];
      if (_prevIds.length > 0) {
        let _ret: boolean = this.compare(_prevIds, _ids);
        if (_ret == false) {
          this.writeLog("warning", this.translate.instant('errors.differentNormGrades'), this.differentNormGradesError);
          break;
        }
      }
      _prevIds = new Array();
      _prevIds = _ids;
    }

    // MQF-264 - Se le normgrades sono tutte uguali ma ho differenti Limitations devo lucchettare le raw material grade
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'gradecustomeranalysislimitation');
    let _isCustom: boolean | null = null;
    let _limitation: string = "";
    for (var x = 0; x < this.mapSelected.length; x++) {
      if (_isCustom != null) {
        if (this.dataSheet[_i].colValue![this.mapSelected[x].row!].isCustom != _isCustom || this.dataSheet[_i].colValue![this.mapSelected[x].row!].limitation != _limitation) {
          this.writeLog("warning", this.translate.instant('errors.differentLimitationsError'), this.differentLimitationsError);
          break;
        }
      }
      _isCustom = this.dataSheet[_i].colValue![this.mapSelected[x].row!].isCustom;
      _limitation = this.dataSheet[_i].colValue![this.mapSelected[x].row!].limitation;
    }

    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'gradecustomerotherlimitation');
    _isCustom = null;
    _limitation = "";
    for (var x = 0; x < this.mapSelected.length; x++) {
      if (_isCustom != null) {
        if (this.dataSheet[_i].colValue![this.mapSelected[x].row!].isCustom != _isCustom || this.dataSheet[_i].colValue![this.mapSelected[x].row!].limitation != _limitation) {
          this.writeLog("warning", this.translate.instant('errors.differentLimitationsError'), this.differentLimitationsError);
          break;
        }
      }
      _isCustom = this.dataSheet[_i].colValue![this.mapSelected[x].row!].isCustom;
      _limitation = this.dataSheet[_i].colValue![this.mapSelected[x].row!].limitation;
    }

    // MQF-278 se nella selezione multipla ho degli item con Tube Execution custom e altri non custom, devo lucchettare le Tol+ e Tol-
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'tubeexecution');
    let _prevValue: boolean | null = null;
    for (var x = 0; x < this.mapSelected.length; x++) {
      let _tE: TubeExecution = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
      if (_prevValue != null && _tE && _tE.isCustom != _prevValue) {
        this.writeLog("warning", this.translate.instant('errors.differentTubeExecution'), this.differentTubeExecution);
        break;
      }
      if (_tE)
        _prevValue = _tE.isCustom!
    }

    // MQF- 296 Different NPS
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'npsschedule');
    let _prevNpsValue: string | null = null;
    for (var x = 0; x < this.mapSelected.length; x++) {
      if (_prevNpsValue != '' && this.dataSheet[_i].colValue![this.mapSelected[x].row!] != _prevNpsValue) {
        this.writeLog("warning", this.translate.instant('errors.dimWithNps'), this.npsError);
        break;
      }
      _prevNpsValue = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
    }

    // MQF-273 nella selezione multipla non posso cambiare valore per campi che sono espressi in uom diverse (qty, id, od, wt)
    // altrimenti applicherei il valore va a cascate indipentemente dalla uom 
    this.checkDifferentUoms('quantityuom', this.differentUomsQty);
    // this.checkDifferentUoms('oduom', this.differentUomsOd);
    // this.checkDifferentUoms('wtuom', this.differentUomsWt);
    // this.checkDifferentUoms('iduom', this.differentUomsId);
    // this.checkDifferentUoms('lengthuom', this.differentLengthUom);

    // Mill Rule
    let _marketingRoute: string = "";
    for (var x = 0; x < this.mapSelected.length; x++) {
      _marketingRoute = this.dataSheet.filter(x => x.colName!.toLowerCase() == 'sms')[0].colValue![this.mapSelected[x].row!] && this.dataSheet.filter(x => x.colName!.toLowerCase() == 'sms')[0].colValue![this.mapSelected[x].row!]["marketingRoute"];
      if ((_marketingRoute == 'Cold' || _marketingRoute == 'HB HOT') && this.millChangedByUser == false) {
        //this.writeLog("warning", this.translate.instant('errors.millRuleActive'), this.millRuleActive);
        break;
      }
    }

    // Different Marketing Route
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'marketingroute');
    let _prevMrValue: string | null = null;
    for (var x = 0; x < this.mapSelected.length; x++) {
      if (_prevMrValue && _prevMrValue != '' && this.dataSheet[_i].colValue![this.mapSelected[x].row!] != _prevMrValue) {
        this.writeLog("warning", this.translate.instant('errors.differentMarketingRoute'), this.differentMarketingRoute);
        break;
      }
      _prevMrValue = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
    }

    // Different CTS
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'cts');
    let _prevCtsValue: string | null = null;
    if (this.mapSelected.length > 1) {
      for (var x = 0; x < this.mapSelected.length; x++) {
        if (_prevCtsValue != null && this.dataSheet[_i].colValue![this.mapSelected[x].row!] != _prevCtsValue) {
          this.writeLog("warning", this.translate.instant('errors.differentCts'), this.differentCts);
          break;
        }
        _prevCtsValue = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
      }
    }

    // Different Material Codes
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
    let _prevMaterialCodeValue: string | null = null;
    if (this.mapSelected.length > 1) {
      for (var x = 0; x < this.mapSelected.length; x++) {
        if (_prevMaterialCodeValue != null && JSON.stringify(this.dataSheet[_i].colValue![this.mapSelected[x].row!]) != JSON.stringify(_prevMaterialCodeValue)) {
          this.writeLog("warning", this.translate.instant('errors.differentMaterialCodes'), this.differentMaterialCodesError);
          break;
        }
        _prevMaterialCodeValue = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
      }
    }

    if (this.hasMixedHydroTestEditabilityInSelection()) {
      this.writeLog("warning", this.translate.instant('errors.differentHydroTestEditability'), this.differentHydroTestEditabilityError);
    }

    if (this.hasMixedOdDependentEditabilityInSelection()) {
      this.writeLog("warning", this.translate.instant('errors.differentOdDependentEditability'), this.differentOdDependentEditabilityError);
    }

    if (this.hasMixedIdDependentEditabilityInSelection()) {
      this.writeLog("warning", this.translate.instant('errors.differentIdDependentEditability'), this.differentIdDependentEditabilityError);
    }

    if (this.hasMixedWtDependentEditabilityInSelection()) {
      this.writeLog("warning", this.translate.instant('errors.differentWtDependentEditability'), this.differentWtDependentEditabilityError);
    }


  }

  private hasMixedHydroTestEditabilityInSelection(): boolean {
    if (this.mapSelected.length <= 1) {
      return false;
    }

    let previousDisabledState: boolean | null = null;
    for (let x = 0; x < this.mapSelected.length; x++) {
      const rowIndex = this.mapSelected[x].row;
      if (rowIndex == null) {
        continue;
      }

      const isDisabled = this.isHydroTestDisabledForRow(rowIndex);
      if (previousDisabledState != null && isDisabled !== previousDisabledState) {
        return true;
      }

      previousDisabledState = isDisabled;
    }

    return false;
  }

  private hasMixedOdDependentEditabilityInSelection(): boolean {
    if (this.mapSelected.length <= 1) {
      return false;
    }

    let previousDisabledState: boolean | null = null;
    for (let x = 0; x < this.mapSelected.length; x++) {
      const rowIndex = this.mapSelected[x].row;
      if (rowIndex == null) {
        continue;
      }

      const isDisabled = this.isOdDependentFieldDisabledForRow(rowIndex);
      if (previousDisabledState != null && isDisabled !== previousDisabledState) {
        return true;
      }

      previousDisabledState = isDisabled;
    }

    return false;
  }

  private hasMixedIdDependentEditabilityInSelection(): boolean {
    if (this.mapSelected.length <= 1) {
      return false;
    }

    let previousDisabledState: boolean | null = null;
    for (let x = 0; x < this.mapSelected.length; x++) {
      const rowIndex = this.mapSelected[x].row;
      if (rowIndex == null) {
        continue;
      }

      const isDisabled = this.isIdDependentFieldDisabledForRow(rowIndex);
      if (previousDisabledState != null && isDisabled !== previousDisabledState) {
        return true;
      }

      previousDisabledState = isDisabled;
    }

    return false;
  }

  private hasMixedWtDependentEditabilityInSelection(): boolean {
    if (this.mapSelected.length <= 1) {
      return false;
    }

    let previousDisabledState: boolean | null = null;
    for (let x = 0; x < this.mapSelected.length; x++) {
      const rowIndex = this.mapSelected[x].row;
      if (rowIndex == null) {
        continue;
      }

      const isDisabled = this.isWtDependentFieldDisabledForRow(rowIndex);
      if (previousDisabledState != null && isDisabled !== previousDisabledState) {
        return true;
      }

      previousDisabledState = isDisabled;
    }

    return false;
  }

  checkDifferentUoms(colName: string, errorCode: number) {
    const _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == colName);
    let _uom: string = "";
    let _previousUom: string = "";
    for (var x = 0; x < this.mapSelected.length; x++) {
      _uom = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
      if (_previousUom != '' && _previousUom != _uom) {
        this.writeLog("warning", this.translate.instant('errors.uomIncompatible'), errorCode);
        break;
      }
      _previousUom = _uom;
    }
  }

  /**
   * ARRAY COMPARISON
   * @param a 
   * @param b 
   * @returns 
   */
  compare(a: any[], b: any[]): boolean {
    const compareArrays = (a: any[], b: any[]) =>
      a.length === b.length &&
      a.every((element: any, index: number) => b.indexOf(element) != -1);

    return compareArrays(a, b);
  }

  /**
   * BUTTONS LIST WTODID/NPS
   * @param npsValue 
   */
  getWtOdIDNpsTTButtons(npsValue: string) {
    this.toolbarButtonsList = new Array();

    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "wtOdId";
    _item.action = "select|wtOdIt";
    _item.type = "toggle";
    _item.state = npsValue != null ? "" : 'pressed';
    _item.toggleText = "wtOdId";
    this.toolbarButtonsList.push(_item);

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "nps";
    _item.action = "select|nps";
    _item.type = "toggle";
    _item.state = npsValue != null ? "pressed" : '';
    _item.toggleText = "nps";
    this.toolbarButtonsList.push(_item);

  }

  /**
   * GET NPS LIST
   */
  getNpsAndSchedules() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getNpsAndSchedules().subscribe(res => {
      this.teiasoftLoader.stop();
      this.dataSetNps = new Array();
      if (res) {
        this.dataSetNps = this.utils.sortNpSAndSchedule(res.npsSchedules!); // MQF-150

        for (var x = 0; x < this.dataSetNps.length; x++) {
          let obj: any = this.dataSetNps[x];
          for (const key in obj) {
            if (typeof obj[key] == 'number') {
              if (key.toLowerCase() != 'npsscheduleid') {
                let _digits: number = 2;
                let _col: string = key.substring(0, 2);
                if (key.indexOf("Metric") != -1 && this.roundDigitsForEditInPlace!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForEditInPlace!.filter(r => r.fieldName == _col)[0].metricDigits!;
                }
                if (key.indexOf("Imperial") != -1 && this.roundDigitsForEditInPlace!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForEditInPlace!.filter(r => r.fieldName == _col)[0].imperialDigits!;
                }
                this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(_digits); // Number(this.dataSetNps[x][key].toFixed(4));
              }
              //this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(4); // Number(this.dataSetNps[x][key].toFixed(4));
            }
          }


          // Adding Uoms
          let _metricUom: string = "metricUom";
          this.dataSetNps[x][_metricUom as string] = 'mm';

          let _imperialUom: string = "imperialUom";
          this.dataSetNps[x][_imperialUom as string] = 'in';
        }

        let rowInEditIndex = this.mapSelected.findIndex(slc => slc.inEdit == true);
        if (this.dataSheet[this.mapSelected[rowInEditIndex].col!].colValue![this.mapSelected[rowInEditIndex].row!] != undefined) // MQF-370 Obsolete Values GBR 12/07/2024
          this.originalValue = JSON.parse(JSON.stringify(this.dataSheet[this.mapSelected[rowInEditIndex].col!].colValue![this.mapSelected[rowInEditIndex].row!]));

        // store original values for Nps 
        let _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
        this.orignalOdValue = this.dataSheet[_i].colValue![this.mapSelected[rowInEditIndex].row!];
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'id');
        this.orignalIdValue = this.dataSheet[_i].colValue![this.mapSelected[rowInEditIndex].row!];
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
        this.orignalWtValue = this.dataSheet[_i].colValue![this.mapSelected[rowInEditIndex].row!];;

        this.showSelectNps = true;
        this.showSelectNpsSourceRow = this.mapSelected[rowInEditIndex].row;
      }
    }));
  }

  /**
   * GET NORMGRADES
   * @param value 
   */
  getNormGrades(value: string, hasRowMaterialCode: boolean = false) {
    this.subscriptions.add(this.backendService.getNormGrades([]).subscribe(res => {
      if (res && res.normGrades) {
        this.normGradesDataset = new Array();

        if (hasRowMaterialCode) {

          this.normGradesDataset = [
            ...this.normGradesMaterialDataset!.filter(x => x.normGradeCode!.toLowerCase().startsWith(value.toLowerCase())).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!)),
            ...this.normGradesMaterialDataset!.filter(x =>
              x.normGradeCode!.toLowerCase().includes(value!.toLowerCase()) &&
              !x.normGradeCode!.toLowerCase().startsWith(value!.toLowerCase())
            ).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!))
          ];
        }
        else if (value != '') {

          this.normGradesDataset = [
            ...res.normGrades.filter(x => x.normGradeCode!.toLowerCase().startsWith(value.toLowerCase())).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!)),
            ...res.normGrades.filter(x =>
              x.normGradeCode!.toLowerCase().includes(value!.toLowerCase()) &&
              !x.normGradeCode!.toLowerCase().startsWith(value!.toLowerCase())
            ).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!))
          ];


        } else {
          this.normGradesDataset = res.normGrades!
            .slice() // Create a shallow copy of the array to avoid modifying the original array
            .sort((a: any, b: any) => {
              let nameA: string = a["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
              let nameB: string = b["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              // names must be equal
              return 0;
            }) // Sort by the 'score' property in descending order
            .slice(0, 100); // Take the top 100 records

          this.normGradesDataset_Cache = this.normGradesDataset;
          // GBR 14/06/2024 MQF-316: Perchè l'assunto sotto? Lo ripristino dopo la parte commentata
          // Se sono in edit e la norm grade associata non è presente nei 100 la aggiungo
          // Agisco solo su una selezione (l'assunto è che siano tutte uguali)
          /*  let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'normgrades');
           if (this.mapSelected && this.mapSelected.length > 0){
             let _temp: NormGrade[] = new Array();
             _temp = this.dataSheet[_i].colValue![this.mapSelected[0].row!];
             for (var x=0; x < _temp.length; x++){
               if (this.normGradesDataset.findIndex(n => n.normGradeId == _temp[x].normGradeId) == -1)
               this.normGradesDataset!.unshift(_temp[x]);
             }
           } */

          // GBR 14/06/2024 MQF-316 - Ripristino: Se sono in edit e la norm grade associata non è presente nei 100 la aggiungo
          let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'normgrades');
          if (this.mapSelected && this.mapSelected.length > 0) {
            let _temp: NormGrade[] = new Array();
            _temp = this.dataSheet[_i].colValue![this.mapSelected[0].row!];
            for (var x = 0; x < _temp.length; x++) {
              if (this.normGradesDataset.findIndex(n => n.normGradeId == _temp[x].normGradeId) == -1)
                this.normGradesDataset!.unshift(_temp[x]);
            }
          }
        }

        // this.isFormValid(); 
      }
    }));
  }

  /**
   * GET LIMITATIONS FOR NORMGRADE
   * @param normGradeIds 
   * @param fromFillForm 
   */
  getLimitationsForNormGrades(normGradeIds: number[], showToaster: boolean, colName?: string, loadRaws?: boolean) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getLimitationsForNormGrades(normGradeIds).subscribe(res => {
      this.limitationForNormGrade = new LimitationsForNormGrades();
      this.limitationForNormGrade = res;
      this.analysisLimitationOptionList = new Array();
      this.otherLimitationOptionList = new Array();

      let _iAl: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
      let _iOl = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomerotherlimitation');
      let _iRm: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'rawmaterialgrade');

      // IN caso non ricevo alcun dato da BE pulisco solo se non ho Limitation Custom associate 
      if (res.gradeCustomerAnalysisLimitations?.length == 0 || res.gradeCustomerOtherLimitations?.length == 0) {
        let emptyLim: ItemLimitation = new ItemLimitation();
        emptyLim.isCustom = true;
        emptyLim.limitation = '';

        for (let i = 0; i < this.mapSelected.length; i++) {
          if (this.dataSheet[_iAl].colValue![this.mapSelected[i].row!] && (this.dataSheet[_iAl].colValue![this.mapSelected[i].row!].isCustom == false || !this.dataSheet[_iAl].colValue![this.mapSelected[i].row!].isCustom)) {
            this.dataSheet[_iAl].colValue![this.mapSelected[i].row!] = JSON.parse(JSON.stringify(emptyLim));
            this.setValueOnDataSet(this.mapSelected[i].row!, _iAl, null);
          }
          if (this.dataSheet[_iOl].colValue![this.mapSelected[i].row!] && (this.dataSheet[_iOl].colValue![this.mapSelected[i].row!].isCustom == false || !this.dataSheet[_iOl].colValue![this.mapSelected[i].row!].isCustom)) {
            this.dataSheet[_iOl].colValue![this.mapSelected[i].row!] = JSON.parse(JSON.stringify(emptyLim));
            this.setValueOnDataSet(this.mapSelected[i].row!, _iOl, null);
          }

          this.dataSheet[_iRm].colValue![this.mapSelected[i].row!] = null;
          this.setValueOnDataSet(this.mapSelected[i].row!, _iRm, null);
        }
        this.teiasoftLoader.stop();
        if (showToaster) this.teiasoftToaster.show("info", this.translate.instant("errors.noLimitationForNormGrade"));
        this.isFormValid();
        this.checkDataOnSelection();

        // this.retCallApi.next(1);
        return;
      }

      /* ANALYSIS LIMITATION */
      if (res.gradeCustomerAnalysisLimitations!.length > 0) {
        for (var x = 0; x < res.gradeCustomerAnalysisLimitations!.length; x++) {
          let _item: SelectOption = new SelectOption();
          _item.value = res.gradeCustomerAnalysisLimitations![x].limitation!;
          _item.text = res.gradeCustomerAnalysisLimitations![x].limitation!;
          this.analysisLimitationOptionList.push(_item);
        }
      }

      /* OTHER LIMITATION */
      if (res.gradeCustomerOtherLimitations!.length > 0) {
        for (var x = 0; x < res.gradeCustomerOtherLimitations!.length; x++) {
          let _item: SelectOption = new SelectOption();
          _item.value = res.gradeCustomerOtherLimitations![x].limitation!;
          _item.text = res.gradeCustomerOtherLimitations![x].limitation!;
          this.otherLimitationOptionList.push(_item);
        }
      }

      for (let i = 0; i < this.mapSelected.length; i++) {
        let _analysisValue: ItemLimitation = this.dataSheet[_iAl].colValue![this.mapSelected[i].row!];
        let _otherValue: ItemLimitation = this.dataSheet[_iOl].colValue![this.mapSelected[i].row!];
        // Setto il default value per Analysis se la limitation è vuota
        if (!colName || (colName && colName!.toLowerCase() == 'gradecustomeranalysislimitation')) { // se specificata, aggiorno solo la colonna in edit
          if ((!_analysisValue || _analysisValue.limitation == '') || !colName) { //} || (_analysisValue && _analysisValue.isCustom == false)) {
            //this.dataSheet[_iAl].colValue![this.mapSelected[i].row!] = new ItemLimitation();
            this.dataSheet[_iAl].colValue![this.mapSelected[i].row!].limitation = res.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0] ? res.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0]!.limitation : res.gradeCustomerAnalysisLimitations![0].limitation;
            this.dataSheet[_iAl].colValue![this.mapSelected[i].row!].isCustom = false;
            this.setValueOnDataSet(this.mapSelected[i].row!, _iAl, this.dataSheet[_iAl].colValue![this.mapSelected[i].row!]);
            //this.valueChanged = true;
          }
        }

        if (!colName || (colName && colName!.toLowerCase() == 'gradecustomerotherlimitation')) {
          // Setto il default value per Other se la limitation è vuota
          if ((!_otherValue || _otherValue.limitation == '' || !colName)) {// || (_otherValue && _otherValue.isCustom == false)) {
            //this.dataSheet[_iOl].colValue![this.mapSelected[i].row!] = new ItemLimitation();
            this.dataSheet[_iOl].colValue![this.mapSelected[i].row!].limitation = res.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0] ? res.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0]!.limitation : res.gradeCustomerOtherLimitations![0].limitation;
            this.dataSheet[_iOl].colValue![this.mapSelected[i].row!].isCustom = false;
            this.setValueOnDataSet(this.mapSelected[i].row!, _iOl, this.dataSheet[_iOl].colValue![this.mapSelected[i].row!]);
            //this.valueChanged = true;
          }
        }

        if (loadRaws == true)
          this.getRawMaterialGradesFromNormGradesAndLimitationsForAll(normGradeIds, this.dataSheet[_iAl].colValue![this.mapSelected[i].row!], this.dataSheet[_iOl].colValue![this.mapSelected[i].row!], this.mapSelected[i].row!);
      }

      // Dopo aver assegnato le Limitations chiamo la GetRawMaterialGrade
      //this.getRawMaterialGradesFromNormGradesAndLimitations('', normGradeIds, this.dataSheet[_iAl].colValue![this.mapSelected[0].row!], this.dataSheet[_iOl].colValue![this.mapSelected[0].row!]);
      this.teiasoftLoader.stop();
      this.isFormValid();
      this.retCallApi.next(1);

    }));
  }

  // Nuovo metodo di get delle raw material grade
  getRawMaterialGradesFromNormGradesAndLimitationsForAll(normGradesId: number[], analysisLimitationValue: ItemLimitation | string, otherLimitationValue: ItemLimitation | string, row: number) {
    this.imCallingApi = true;
    let col: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'rawmaterialgrade');
    const ignoreLimitations = (analysisLimitationValue as ItemLimitation)?.isCustom || (otherLimitationValue as ItemLimitation)?.isCustom;
    let _analysisLim: string | null = typeof analysisLimitationValue == 'object' ? analysisLimitationValue.limitation! : (analysisLimitationValue as string);
    let _otherLim: string | null = typeof otherLimitationValue == 'object' ? otherLimitationValue.limitation! : (otherLimitationValue as string);

    if (ignoreLimitations) {
      _analysisLim = null;
      _otherLim = null;
    } else if (_analysisLim == '' || _otherLim == '') {
      this.imCallingApi = false;
      return;
    }
    this.teiasoftLoader.start();
    this.subscriptions.add(this.rawMaterialGradeService.getRawMaterialGradesFromNormGradesAndLimitations(normGradesId, _analysisLim, _otherLim).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        this.rawMaterialGradeDataset = new Array();
        //this.rawMaterialGradeDisabled = false;
        if (res.rawMaterialGrades.length > 0) {
          this.rawMaterialGradeDataset = res.rawMaterialGrades!
            .slice() // Create a shallow copy of the array to avoid modifying the original array
            .sort((a: any, b: any) => {
              let nameA: string = a["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
              let nameB: string = b["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            }).slice(0, 100);

          const currentRawMaterial = this.dataSheet[col].colValue![row];
          const autoSelectedGrade = this.getSingleAutoSelectableRawMaterialGrade(this.rawMaterialGradeDataset);
          if (currentRawMaterial?.rawMaterialGradeId && this.rawMaterialGradeDataset.find((rm: RawMaterialGrade) => rm.rawMaterialGradeId == currentRawMaterial.rawMaterialGradeId)) {
            this.dataSheet[col].colValue![row] = currentRawMaterial;
            this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
          }
          else if (autoSelectedGrade) {
            this.dataSheet[col].colValue![row] = autoSelectedGrade;
            this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
          }
          else {

            // se ho il material code cerco la rm relativa
            const hasMaterialCode = this.dataSheet[this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'material')].colValue![row] != null;
            const actualRm = { ...currentRawMaterial };


            if (hasMaterialCode && actualRm && this.rawMaterialGradeDataset.find((rm: RawMaterialGrade) => rm.rawMaterialGradeId == actualRm.rawMaterialGradeId)) {
              // se actual rm è inclusa tra le possibili non devo fare null
            }
            else {
              this.dataSheet[col].colValue![row] = null;
              this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
            }


          }


          // after set raw material grade, clean up xls import error
          this.cleanMeXlxsError(row, 'rawmaterialgrade');
        } else {
          // MQF-359 - Se non ho RawMaterialGrade pulisco eventuali errori presenti nell'import excel
          this.cleanMeXlxsError(row, 'rawmaterialgrade');
          // MQF-359 

          this.dataSheet[col].colValue![row] = null;
          /* EDIT ALSO DATASET */
          this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
          this.writeLog("warning", this.translate.instant("enquiryBook.noRawMaterials"), this.noRawMaterialError);
        }
      }
      this.imCallingApi = false;
      // if (this.mapSelected && this.mapSelected.length > 0) this.closeEdit();
      this.isFormValid();
      this.checkDataOnSelection();
      this.teiasoftLoader.stop();
    }));
  }

  /**
   * GET RAW MATERIAL GRADE FOR LIMITATION
   * @param value 
   * @param normGradesId 
   * @param fromFillForm 
   */
  getRawMaterialGradesFromNormGradesAndLimitations(value: string, normGradesId: number[], analysisLimitationValue: ItemLimitation | string, otherLimitationValue: ItemLimitation | string, previousSelectedRawMaterialId?: number) {
    this.imCallingApi = true;
    this.teiasoftLoader.start();
    let col: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'rawmaterialgrade');
    const ignoreLimitations = (analysisLimitationValue as ItemLimitation)?.isCustom || (otherLimitationValue as ItemLimitation)?.isCustom;
    let _analysisLim: string | null = typeof analysisLimitationValue == 'object' ? analysisLimitationValue.limitation! : (analysisLimitationValue as string);
    let _otherLim: string | null = typeof otherLimitationValue == 'object' ? otherLimitationValue.limitation! : (otherLimitationValue as string);

    if (ignoreLimitations) {
      _analysisLim = null;
      _otherLim = null;
    } else if (_analysisLim == '' || _otherLim == '') {
      this.imCallingApi = false;
      this.teiasoftLoader.stop();
      return;
    }

    this.subscriptions.add(this.rawMaterialGradeService.getRawMaterialGradesFromNormGradesAndLimitations(normGradesId, _analysisLim, _otherLim).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        this.rawMaterialGradeDataset = new Array();
        //this.rawMaterialGradeDisabled = false;
        if (res.rawMaterialGrades.length > 0) {
          if (value != '') {
            this.rawMaterialGradeDataset = res.rawMaterialGrades.filter(x => x.rawMaterialGradeCode!.toLowerCase().includes(value.toLowerCase()));
          } else {
            this.rawMaterialGradeDataset = res.rawMaterialGrades!
              .slice() // Create a shallow copy of the array to avoid modifying the original array
              .sort((a: any, b: any) => {
                let nameA: string = a["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                let nameB: string = b["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              })
              .slice(0, 100);
          }
          const rowInEdit = this.mapSelected.find(ms => ms.inEdit)?.row;
          for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
            const selectedIndex = this.mapSelected.findIndex(k => k.row == x);
            if (selectedIndex != -1) {
              const previousRowValue = this.dataSheet[col].colValue![x];
              let rawMaterialToApply: RawMaterialGrade | undefined;

              if (previousSelectedRawMaterialId && rowInEdit === x) {
                rawMaterialToApply = this.rawMaterialGradeDataset.find(rm => rm.rawMaterialGradeId == previousSelectedRawMaterialId);
              }

              if (!rawMaterialToApply && previousRowValue?.rawMaterialGradeId) {
                rawMaterialToApply = this.rawMaterialGradeDataset.find(rm => rm.rawMaterialGradeId == previousRowValue.rawMaterialGradeId);
              }

              if (!rawMaterialToApply) {
                rawMaterialToApply = this.getSingleAutoSelectableRawMaterialGrade(this.rawMaterialGradeDataset);
              }

              if (rawMaterialToApply) {
                this.setValueOnDataSheetAndDataSet(col, selectedIndex, rawMaterialToApply);
              }

              // after set raw material grade, clean up xls import error
              this.cleanMeXlxsError(x, 'rawmaterialgrade');
            }
          }
        } else {
          for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
            if (this.mapSelected.findIndex(k => k.row == x) != -1) {
              this.dataSheet[col].colValue![x] = null;
              /* EDIT ALSO DATASET */
              this.setValueOnDataSet(x, col, this.dataSheet[col].colValue![x]);
            }
          }
          this.writeLog("warning", this.translate.instant("enquiryBook.noRawMaterials"), this.noRawMaterialError);
        }
      }
      this.imCallingApi = false;
      // if (this.mapSelected && this.mapSelected.length > 0) this.closeEdit();
      this.teiasoftLoader.stop();
    }));
  }

  /**
   * GET RAW MATERIAL GRADES
   * @param value 
   * @param normGradeIds 
   */
  getRawMaterialGrades(value: string, normGradeIds: number[]) {
    let col: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'rawmaterialgrade');
    this.subscriptions.add(this.backendService.getRawMaterialGrades(normGradeIds).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        this.rawMaterialGradeDataset = new Array();
        if (res.rawMaterialGrades.length > 0) {
          if (value != '') {
            this.rawMaterialGradeDataset = res.rawMaterialGrades.filter(x => x.rawMaterialGradeCode!.toLowerCase().includes(value.toLowerCase()));
          } else {
            this.rawMaterialGradeDataset = res.rawMaterialGrades!
              .slice() // Create a shallow copy of the array to avoid modifying the original array
              .sort((a: any, b: any) => {
                let nameA: string = a["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                let nameB: string = b["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              })
              .slice(0, 100);
          }
          // Se è un solo valore popolo direttamente la select
          const autoSelectedGrade = this.getSingleAutoSelectableRawMaterialGrade(this.rawMaterialGradeDataset);
          for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
            if (this.mapSelected.findIndex(k => k.row == x) != -1) {
              const currentRawMaterial = this.dataSheet[col].colValue![x];
              const currentIsValid = currentRawMaterial?.rawMaterialGradeId && this.rawMaterialGradeDataset.find(rm => rm.rawMaterialGradeId == currentRawMaterial.rawMaterialGradeId);
              this.dataSheet[col].colValue![x] = currentIsValid ? currentRawMaterial : autoSelectedGrade || null;
              /* EDIT ALSO DATASET */
              this.setValueOnDataSet(x, col, this.dataSheet[col].colValue![x]);
            }
          }
        } else {
          for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
            if (this.mapSelected.findIndex(k => k.row == x) != -1) {
              this.dataSheet[col].colValue![x] = null;
              /* EDIT ALSO DATASET */
              this.setValueOnDataSet(x, col, this.dataSheet[col].colValue![x]);
            }
          }

          this.writeLog("warning", this.translate.instant("enquiryBook.noRawMaterials"), this.noRawMaterialError);
        }
      }
    }));
  }

  private getAutoSelectableRawMaterialGrades(rawMaterialGrades?: RawMaterialGrade[] | null): RawMaterialGrade[] {
    return (rawMaterialGrades || []).filter(rawMaterialGrade => rawMaterialGrade?.isDummy !== true);
  }

  private getSingleAutoSelectableRawMaterialGrade(rawMaterialGrades?: RawMaterialGrade[] | null): RawMaterialGrade | undefined {
    const selectableGrades = this.getAutoSelectableRawMaterialGrades(rawMaterialGrades);
    return selectableGrades.length === 1 ? selectableGrades[0] : undefined;
  }

  /**
   * UPDATE materials dataset
   */
  getMaterialsDataset(materialCode: string): Material[] {
    return !materialCode ? this.materials : this.materials.filter(mat => mat.materialCode?.includes(materialCode))
      .sort((a: any, b: any) => {
        let nameA: string = a["materialCode"]!.toUpperCase(); // ignore upper and lowercase
        let nameB: string = b["materialCode"]!.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
      .slice(0, 100);
  }

  /**
   * SET WTODIS/NPS Values
   * @param show 
   * @param cancelValue 
   */
  setWtOdIdNps(show: string, cancelValue: boolean) {
    if (show == 'nps') {
      // Turn OFF 
      /*       this.odIsRequired = false;
            this.odReadOnly = true;
      
            this.odUomIsRequired = false;
            this.odUomReadOnly = true;
      
            this.idIsRequired = false;
            this.idValue = null; 
            this.idReadOnly = true;
      
            this.idUomIsRequired = false;
            this.idUomValue = null; 
            this.idUomReadOnly = true;
      
            this.wtIsRequired = false;
            this.wtReadOnly = true;
      
            this.wtUomIsRequired = false;
            this.wtUomReadOnly = true; */

      // Turn ON Nps Description
      /*       this.npsIsReadOnly = true;
            this.npsDisabled = false;
            this.npsIsrequired = true; */

    } else {
      // Turn ON ID/OD/WT
      /*  this.odIsRequired = true;
       this.odValue = cancelValue ? '' : this.items[this.selectedIndexItem].od;
       this.odReadOnly = false;
 
       this.odUomIsRequired = true;
       this.odUomValue = cancelValue ? '' : this.items[this.selectedIndexItem].odUom;
       this.odUomReadOnly = false;
 
       this.idIsRequired = true;
       this.idValue = cancelValue ? '' : this.items[this.selectedIndexItem].id;
       this.idReadOnly = false;
 
 
       this.idUomIsRequired = true;
       this.idUomValue = cancelValue ? '' : this.items[this.selectedIndexItem].idUom;
       this.idUomReadOnly = false;
 
       this.wtIsRequired = true;
       this.wtValue = cancelValue ? '' :this.items[this.selectedIndexItem].wt;
       this.wtReadOnly = false;
 
       this.wtUomIsRequired = true;
       this.wtUomValue = cancelValue ? '' :this.items[this.selectedIndexItem].wtUom;
       this.wtUomReadOnly = false; */

      // Turn OFF Nps Description
      /*       this.npsValue = '';
            this.npsId =  null;
            this.npsIsReadOnly = true;
            this.npsDisabled = true;
            this.npsIsrequired = false; */
    }
  }

  /**
   * SET NEW VALUE IN DATASET
   * @param x 
   * @param col 
   * @param value 
   */
  setValueOnDataSet(x: number, col: number, value: any) {
    const toLowerFirst = (s: string) => s.charAt(0).toLowerCase() + s.slice(1);

    const columnName = toLowerFirst(this.dataSheet[col]?.colName!); // first char tolowercase
    if (!this.dataSet || this.dataSet.length === 0 || !columnName || !this.dataSet[x]) {
      return;
    }

    // Ensure the dataset exposes the column even when it is missing on the model rows.
    const prop = this.ensureDataSetColumn(columnName);
    if (!prop) {
      return;
    }

    const propName = prop.toLowerCase();
    if (propName === 'npsschedule') {
      this.dataSet[x][prop] = new EnquiryNpsSchedule(); //sadasddasasd // Devo creare un oggetto EnquiryNpsSchedule
      if (value && value["npsScheduleId"]) value["npsScheduleId"] = parseInt(value["npsScheduleId"]);
      this.dataSet[x][prop] = value;
    } else if (propName === 'sms') {
      this.dataSet[x][prop] = new ItemSms();
      if (value) this.dataSet[x][prop] = this.itemParameterValues.sms!.filter(x => x.smsId == value["smsId"])[0];
    } else if (propName === 'marketfamily') {
      this.dataSet[x][prop] = new MarketFamily();
      this.dataSet[x][prop] = this.itemParameterValues.marketFamily!.filter(x => x.marketFamilyId == value["marketFamilyId"])[0];
    } else if (propName === 'surfacetype') {
      this.dataSet[x][prop] = new SurfaceTypes();
      if (value) this.dataSet[x][prop] = this.itemParameterValues.surfaceTypes!.filter(x => x.surfaceTypeId == value["surfaceTypeId"])[0];
    } else if (propName === 'sql') {
      this.dataSet[x][prop] = null;
      if (value && value["sqlId"]) {
        this.dataSet[x][prop] = this.itemParameterValues.sqls?.find(x => x.sqlId == value["sqlId"]) ?? null;
      }
    } else if (propName === 'offerscheme') {
      this.dataSet[x][prop] = null;
      if (typeof value === 'string') {
        this.dataSet[x][prop] = this.itemParameterValues.offerSchemes?.find(x => x.offerSchemeCode == value) ?? null;
      } else if (value && value["offerSchemeCode"]) {
        this.dataSet[x][prop] = this.itemParameterValues.offerSchemes?.find(x => x.offerSchemeCode == value["offerSchemeCode"]) ?? null;
      }
    } else if (propName === 'tubeexecution') {
      this.dataSet[x][prop] = new TubeExecution();
      if (value && value["tubeExecutionId"]) {
        const match = this.itemParameterValues.tubeExecution!.find(x => x.tubeExecutionId === value["tubeExecutionId"]);
        if (match) {
          this.dataSet[x][prop] = match;
        }
      }
      // this.dataSet[x][prop] = this.itemParameterValues.tubeExecution!.filter(x => x.tubeExecutionId == value["tubeExecutionId"])[0];
    } else if (propName === 'gradecustomeranalysislimitation') {
      if (typeof value == 'string')
        this.dataSet[x][prop] = new ItemLimitation();
      this.dataSet[x][prop] = value;
    } else if (propName === 'gradecustomerotherlimitation') {
      this.dataSet[x][prop] = new ItemLimitation();
      this.dataSet[x][prop] = value;
    } else if (propName === 'rawmaterialgrade') {
      this.dataSet[x][prop] = new RawMaterialGrade();
      this.dataSet[x][prop] = value || null;
    } else {
      this.dataSet[x][prop] = value;
    }

    this.changedDataset.emit(this.dataSet);
  }

  private ensureDataSetColumn(columnName: string): string | null {
    if (!columnName) {
      return null;
    }

    const baseRow = this.dataSet[0];
    const existingProp = baseRow ? Object.keys(baseRow).find(key => key.toLowerCase() === columnName.toLowerCase()) : undefined;
    if (existingProp) {
      return existingProp;
    }

    this.dataSet.forEach(row => {
      if (row && typeof row === 'object' && !Object.prototype.hasOwnProperty.call(row, columnName)) {
        row[columnName] = null;
      }
    });

    return columnName;
  }

  /**
   * CLOSE EDIT
   */
  closeEdit() {
    this.isFormValid();
    // Faccio partire la validazione se le col della map selected sono sompilate
    // let _check: number = this.mapSelected.findIndex(x => x.col == null);
    // if (_check == -1) this.isFormValid();
    // this.itemsNoToDelete = new Array();
    this.removeLog(999);
    this.buttonsList[0].disabled = true;
    this.buttonsList[1].disabled = true;
    this.buttonsList[1].active = false;
    this.mapSelected = [];
    this.selectedCol = -1;
    this.selectedRow = -1;

    this.valueChanged = false;
    this.globals.discardEditInPlace?.next(0);
    this.setIsInEdit.emit(false);
  }

  closeEditLight() {
    let _check: number = this.mapSelected.findIndex(x => x.col == null);
    // if (_check == -1) this.isFormValid();
    // this.removeLog(999);
    for (var x = 0; x < this.mapSelected.length; x++) {
      this.mapSelected[x].col = null;
      this.mapSelected[x].inEdit = false;
    }
    this.selectedCol = -1;
    this.selectedRow = -1;

    this.valueChanged = false;
    // this.logOperations = new Array(); // Clear di tutti gli errori
    this.isFormValid();
    this.setIsInEdit.emit(false);
  }

  /**
   * CHANGE ALL UOMS VALUE
   * @param system 
   */
  changeAllUoms(system: string) {
    this.odUomsList = new Array();
    this.odUomsList = this.getUoms('odUoms', system);
    this.idUomsList = new Array();
    this.idUomsList = this.getUoms('idUoms', system);
    this.wtUomsList = new Array();
    this.wtUomsList = this.getUoms('wtUoms', system);
    this.quantityUomsList = new Array();
    this.quantityUomsList = this.getUoms('quantityUoms', system);
    this.lengthUomsList = new Array();
    this.lengthUomsList = this.getUoms('lengthUoms', system);
    this.totalWeightUomsList = new Array();
    this.totalWeightUomsList = this.getUoms('totalWeightUoms', system);
    let _defUom: string = "";
    let _uoms: UomsType = new UomsType();
    for (var x = 0; x < this.dataSheet.length; x++) {
      if (this.dataSheet[x].colName?.toLowerCase() == 'oduom') {
        for (var m = 0; m < this.mapSelected.length; m++) {
          if (system.toLowerCase() == 'metric') {
            _defUom = this.itemParameterValues.odUoms!.metricUoms!.filter(u => u.isDefault == true)[0].uomCode!;
          } else {
            _defUom = this.itemParameterValues.odUoms!.imperialUoms!.filter(u => u.isDefault == true)[0].uomCode!;
          }
          for (var m = 0; m < this.mapSelected.length; m++) {
            this.dataSheet[x].colValue![this.mapSelected[m].row!] = _defUom;
            this.setValueOnDataSet(this.mapSelected[m].row!, x, _defUom);
          }
        }
      }

      if (this.dataSheet[x].colName?.toLowerCase() == 'iduom') {
        if (system.toLowerCase() == 'metric') {
          _defUom = this.itemParameterValues.idUoms!.metricUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        } else {
          _defUom = this.itemParameterValues.idUoms!.imperialUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        }

        for (var m = 0; m < this.mapSelected.length; m++) {
          this.dataSheet[x].colValue![this.mapSelected[m].row!] = _defUom;
          this.setValueOnDataSet(this.mapSelected[m].row!, x, _defUom);
        }
      }

      if (this.dataSheet[x].colName?.toLowerCase() == 'wtuom') {
        if (system.toLowerCase() == 'metric') {
          _defUom = this.itemParameterValues.wtUoms!.metricUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        } else {
          _defUom = this.itemParameterValues.wtUoms!.imperialUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        }

        for (var m = 0; m < this.mapSelected.length; m++) {
          this.dataSheet[x].colValue![this.mapSelected[m].row!] = _defUom;
          this.setValueOnDataSet(this.mapSelected[m].row!, x, _defUom);
        }
      }

      if (this.dataSheet[x].colName?.toLowerCase() == 'quantityuom') {
        if (system.toLowerCase() == 'metric') {
          _defUom = this.itemParameterValues.quantityUoms!.metricUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        } else {
          _defUom = this.itemParameterValues.quantityUoms!.imperialUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        }
        for (var m = 0; m < this.mapSelected.length; m++) {
          this.dataSheet[x].colValue![this.mapSelected[m].row!] = _defUom;
          this.setValueOnDataSet(this.mapSelected[m].row!, x, _defUom);
        }
      }

      if (this.dataSheet[x].colName?.toLowerCase() == 'lengthuom') {
        if (system.toLowerCase() == 'metric') {
          _defUom = this.itemParameterValues.lengthUoms!.metricUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        } else {
          _defUom = this.itemParameterValues.lengthUoms!.imperialUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        }

        for (var m = 0; m < this.mapSelected.length; m++) {
          this.dataSheet[x].colValue![this.mapSelected[m].row!] = _defUom;
          this.setValueOnDataSet(this.mapSelected[m].row!, x, _defUom);
        }
      }

      if (this.dataSheet[x].colName?.toLowerCase() == 'totalweightuom') {
        if (system.toLowerCase() == 'metric') {
          _defUom = this.itemParameterValues.totalWeightUoms!.metricUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        } else {
          _defUom = this.itemParameterValues.totalWeightUoms!.imperialUoms!.filter(u => u.isDefault == true)[0].uomCode!;
        }
        for (var m = 0; m < this.mapSelected.length; m++) {
          this.dataSheet[x].colValue![this.mapSelected[m].row!] = _defUom;
          this.setValueOnDataSet(this.mapSelected[m].row!, x, _defUom);
        }
      }
    }

  }

  updateNpsOdWt(row: number, col: number, system: string) {
    system = system.toLowerCase();
    let _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'npsschedule')
    const nps = this.dataSheet[_i]!.colValue![row] as any;
    if (nps && nps.npsScheduleId) {
      this.mapSelected.forEach(ms => {
        if (system == 'metric') {
          _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
          this.dataSheet[_i].colValue![ms.row!] = parseFloat(nps["odMetric"]).toFixed(this.getRoundDigits(row, 'od'));
          this.setValueOnDataSet(ms.row!, _i, this.dataSheet[_i].colValue![ms.row!]);
          _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
          this.dataSheet[_i].colValue![ms.row!] = parseFloat(nps["wtMetric"]).toFixed(this.getRoundDigits(row, 'wt'));
          this.setValueOnDataSet(ms.row!, _i, this.dataSheet[_i].colValue![ms.row!]);
        } else {
          _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
          this.dataSheet[_i].colValue![ms.row!] = parseFloat(nps["odImperial"]).toFixed(this.getRoundDigits(row, 'od'));
          this.setValueOnDataSet(ms.row!, _i, this.dataSheet[_i].colValue![ms.row!]);
          _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
          this.dataSheet[_i].colValue![ms.row!] = parseFloat(nps["wtImperial"]).toFixed(this.getRoundDigits(row, 'wt'));
          this.setValueOnDataSet(ms.row!, _i, this.dataSheet[_i].colValue![ms.row!]);
        }
      });
    }
  }

  /**
   * START VALIDAZIONE FORM
   * @returns 
   */
  isFormValid() {

    this.buildFilters(); // here i update the filter values because this method is invoked every time a value changes

    let rowsToBeDeleted: number[] = new Array();

    // Ignore validation for to be deleted items
    let _iItemNo: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'itemno');

    for (let x = 0; x < this.itemsNoToDelete.length; x++) {
      rowsToBeDeleted.push(this.dataSheet[_iItemNo].colValue!.findIndex(k => k == this.itemsNoToDelete[x]))
    }

    let tempSelected: MapSelected[] = new Array();
    tempSelected = JSON.parse(JSON.stringify(this.mapSelected));

    // resetMapselected = true;
    this.mapSelected = new Array();

    for (let x = 0; x < this.dataSheet.length; x++) {

      for (let k = 0; k < this.dataSheet[x].colValue!.length; k++) {

        if (rowsToBeDeleted.indexOf(k) == -1) { // validate only the rows that are not to be deleted
          let _item: MapSelected = new MapSelected();
          _item.col = x;
          _item.row = k;
          _item.inEdit = false;

          this.mapSelected.push(_item);
        }

      }
    }

    this.normalizeNullDeliveryExtraPropertiesForValidation();

    // Resetto l'array delle celle in errore
    this.cellsInError = new Array();
    let retValidation: boolean = true;

    // let _retCheckItemNo: boolean = this.checkAreValidItemNo();
    // if (!_retCheckItemNo) retValidation = false;
    let _retIsValidLenght: boolean = this.checkLength();
    if (!_retIsValidLenght) retValidation = false;

    let _retMandatory = this.checkIsValidMandatory();
    if (!_retMandatory) retValidation = false;
    let _retCustomerItemNo: boolean = this.checkCustomerItemNo();
    if (!_retCustomerItemNo) retValidation = false;
    let _retCheckWtIdOd: boolean = this.checkWtOdId();
    if (!_retCheckWtIdOd) retValidation = false;
    let _retIsGreaterThanZero: boolean = this.isGraterZeroValuesValid();
    if (!_retIsGreaterThanZero) retValidation = false;
    let _retIsValidFormat: boolean = this.isValidFormat();
    if (!_retIsValidFormat) retValidation = false;

    let _retTolerancesValid: boolean = this.tolerancesAreValid();
    if (!_retTolerancesValid) retValidation = false;

    let _retExtraDeliveryPropsValid: boolean = this.extraDeliveryPropertiesAreValid();
    if (!_retExtraDeliveryPropsValid) retValidation = false;


    // Se anche l'ultimo step è corretto, allora faccio una clean di tutti i possibili errori che sono rimasti pendenti dall'import xlsx
    //if (retValidation && this.cellsXlxsInError.length == 0) this.removeLog(this.fromXlsxError)

    // MQF-360 - Check dei pulsanti se la validazione è passata
    if (retValidation) {
      if (tempSelected.length == 1) { // Seleziono un solo item
        // Abilito tutti i bottoni
        this.buttonsList[0].disabled = false;
        this.buttonsList[1].disabled = false;
      } else if (tempSelected.length > 1) { // Seleziono più di un item
        // Abilito solo il bottone di delete
        this.buttonsList[0].disabled = true;
        // Disable the deletion if the selected rows is a mix of delete and edit
        this.buttonsList[1].disabled = this.isSelectionEditAndDeleteMix();
      }
    } else {
      // this.buttonsList[0].disabled = true;
      this.buttonsList[1].disabled = false; // il cancella lo lascio sempre attivo
    }
    // END MQF-360

    this.mapSelected = JSON.parse(JSON.stringify(tempSelected)); // recovery the original selection

    return retValidation;

  }

  private normalizeNullDeliveryExtraPropertiesForValidation(): void {
    if (!this.dataSheet || this.dataSheet.length === 0 || !this.mapSelected || this.mapSelected.length === 0) {
      return;
    }

    const toLowerFirst = (s: string) => s.charAt(0).toLowerCase() + s.slice(1);
    let hasUpdates = false;

    for (const prop of this.deliveryExtraProperties) {
      const colIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == prop.toLowerCase());
      if (colIndex === -1) continue;

      const columnName = this.dataSheet[colIndex].colName!;
      const dataSetProp = this.ensureDataSetColumn(toLowerFirst(columnName));
      if (!dataSetProp) continue;

      for (const selected of this.mapSelected) {
        const rowIndex = selected.row!;
        const currentValue = this.dataSheet[colIndex].colValue![rowIndex];

        let normalizedValue = currentValue;
        if (currentValue === 'true') normalizedValue = true;
        else if (currentValue === 'false') normalizedValue = false;
        else if (currentValue === undefined || currentValue === null || currentValue === '') normalizedValue = false;

        if (normalizedValue !== currentValue) {
          this.dataSheet[colIndex].colValue![rowIndex] = normalizedValue;
          this.dataSet[rowIndex][dataSetProp] = normalizedValue;
          hasUpdates = true;
        }
      }
    }

    if (hasUpdates) {
      this.changedDataset.emit(this.dataSet);
    }
  }

  checkAreValidItemNo(): boolean {
    let _ret: boolean = true;
    let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'itemno');

    let _temp: string[] = new Array();

    if (this.dataSheet.length === 0)
      return _ret;

    for (var x = 0; x < this.dataSheet[_i].colValue!.length; x++) {
      if (_temp.findIndex(t => t == this.dataSheet[_i].colValue![x]) != -1) {
        // duplicated itemNO
        this.setCellAsError(x, _i, this.itemNoError);
        this.writeLog('error', this.translate.instant('errors.itemNoError'), this.itemNoError);
        _ret = false;
      }
      _temp.push(this.dataSheet[_i].colValue![x]);

    }

    if (_ret) {
      this.removeLog(this.itemNoError);
    }

    return _ret;
  }

  /**
   * LIGHT RED THE CELL FOR MANDATORY FIELDS MISSING
   * @param row 
   * @param col 
   * @returns 
   */
  checkIsValidMandatory(): boolean {
    let _ret: boolean = true;
    // Commentato perchè qesto controllo funziona solo sulla cella in selezione in quel momento, mentre devo farlo su tutte le celle delle riche selezionate
    /* for (var x=0; x < this.mapSelected.length; x++){
      if (this.dataSheet[this.mapSelected[x].col!].isRequired 
          && this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase() != 'od' && this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase() != 'oduom'
          && this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase() != 'id' && this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase() != 'iduom'
          && this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase() != 'wt' && this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase() != 'wtuom'
          && (this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] == '' || this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] == null)){
            this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.mandatoryFields);
            _ret = false;
      }
    } */

    for (var x = 0; x < this.dataSheet.length; x++) {
      if (this.dataSheet[x].isRequired
        && this.dataSheet[x].colName!.toLowerCase() != 'od' && this.dataSheet[x].colName!.toLowerCase() != 'oduom'
        && this.dataSheet[x].colName!.toLowerCase() != 'id' && this.dataSheet[x].colName!.toLowerCase() != 'iduom'
        && this.dataSheet[x].colName!.toLowerCase() != 'wt' && this.dataSheet[x].colName!.toLowerCase() != 'wtuom'
        && this.dataSheet[x].colName!.toLowerCase() != 'lengthmin' && this.dataSheet[x].colName!.toLowerCase() != 'lengthmax'
        && this.dataSheet[x].colName!.toLowerCase() != 'tubeexecution'
        && this.dataSheet[x].colName!.toLowerCase() != 'wttoleranceminus'
        && this.dataSheet[x].colName!.toLowerCase() != 'wttoleranceplus'
        && this.dataSheet[x].colName!.toLowerCase() != 'wttoleranceuom'
        && this.dataSheet[x].colName!.toLowerCase() != 'rawmaterialgrade'

      ) {
        for (var m = 0; m < this.mapSelected.length; m++) {
          if (this.dataSheet[x].colValue![this.mapSelected[m].row!] == undefined || this.dataSheet[x].colValue![this.mapSelected[m].row!].toString() == '' || this.dataSheet[x].colValue![this.mapSelected[m].row!] == null) {
            _ret = false;

            if (!this.hasXlsxError(this.mapSelected[m].row!, this.dataSheet[x].colName!)) {
              this.setCellAsError(this.mapSelected[m].row!, x, this.mandatoryFieldsError);
              this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
            }


          }
        }
      }

      if (this.dataSheet[x].isRequired && this.dataSheet[x].colName!.toLowerCase() == 'rawmaterialgrade') {
        for (var m = 0; m < this.dataSheet[x].colValue!.length; m++) {
          this.isRawMaterialGradeRequired(m!);
        }
      }

      if (this.dataSheet[x].isRequired && this.dataSheet[x].colName!.toLowerCase() == 'gradecustomeranalysislimitation') {
        for (var m = 0; m < this.mapSelected.length; m++) {
          if (
            (this.dataSheet[x].colValue![this.mapSelected[m].row!] == null)
            || (!this.dataSheet[x].colValue![this.mapSelected[m].row!].isCustom && !this.dataSheet[x].colValue![this.mapSelected[m].row!].limitation) // non custom e nessuna limitation selezionata
            || (this.dataSheet[x].colValue![this.mapSelected[m].row!] && this.dataSheet[x].colValue![this.mapSelected[m].row!].isCustom == true && (this.dataSheet[x].colValue![this.mapSelected[m].row!].limitation == '' || this.dataSheet[x].colValue![this.mapSelected[m].row!].limitation == undefined))
          ) {
            _ret = false;
            if (!this.hasXlsxError(this.mapSelected[m].row!, this.dataSheet[x].colName!)) {
              this.setCellAsError(this.mapSelected[m].row!, x, this.mandatoryFieldsError);
              this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
            }
          }
        }
      }

      if (this.dataSheet[x].isRequired && this.dataSheet[x].colName!.toLowerCase() == 'gradecustomerotherlimitation') {
        for (var m = 0; m < this.mapSelected.length; m++) {
          if (
            (this.dataSheet[x].colValue![this.mapSelected[m].row!] == null)
            || (!this.dataSheet[x].colValue![this.mapSelected[m].row!].isCustom && !this.dataSheet[x].colValue![this.mapSelected[m].row!].limitation) // non custom e nessuna limitation selezionata
            || (this.dataSheet[x].colValue![this.mapSelected[m].row!] && this.dataSheet[x].colValue![this.mapSelected[m].row!].isCustom == true
              && (this.dataSheet[x].colValue![this.mapSelected[m].row!].limitation == '' || this.dataSheet[x].colValue![this.mapSelected[m].row!].limitation == undefined))) {
            _ret = false;
            if (!this.hasXlsxError(this.mapSelected[m].row!, this.dataSheet[x].colName!)) {
              this.setCellAsError(this.mapSelected[m].row!, x, this.mandatoryFieldsError);
              this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
            }
          }
        }
      }

      // length are mandatory only when fixed length and multiple length or when random length
      if (this.dataSheet[x].colName!.toLowerCase() === 'lengthmin' || this.dataSheet[x].colName!.toLowerCase() === 'lengthmax') {
        for (var m = 0; m < this.mapSelected.length; m++) {
          let lengthTypeIndex = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'lengthtype');
          let multipleLengthIndex = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'multiplelength');

          if (this.dataSheet[x].colValue![this.mapSelected[m].row!] == null && (this.dataSheet[lengthTypeIndex].colValue![this.mapSelected[m].row!] == 'FL' && this.dataSheet[multipleLengthIndex].colValue![this.mapSelected[m].row!]!!)) {
            _ret = false;
            if (!this.hasXlsxError(this.mapSelected[m].row!, this.dataSheet[x].colName!)) {
              this.setCellAsError(this.mapSelected[m].row!, x, this.mandatoryFieldsError);
              this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
            }
          }
        }
      }

      // 2025-06-16: remove check as requested MQF-762
      // testcondition are mandatory only when header order reason is distribution
      // if (this.enquiry.header?.orderReason == 'Distribution' && this.dataSheet[x].colName!.toLowerCase() === 'testcondition') {
      //   for (var m = 0; m < this.mapSelected.length; m++) {
      //     if (this.dataSheet[x].colValue![this.mapSelected[m].row!] == undefined || this.dataSheet[x].colValue![this.mapSelected[m].row!].toString() == '' || this.dataSheet[x].colValue![this.mapSelected[m].row!] == null) {
      //       _ret = false;
      //       if (this.cellsXlxsInError.findIndex(c => c.row == this.mapSelected[m].row && c.colName!.toLowerCase() == this.dataSheet[x].colName!.toLowerCase() + "field") == -1) {
      //         this.setCellAsError(this.mapSelected[m].row!, x, this.mandatoryFieldsError);
      //         this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
      //       }
      //     } else {
      //       this.cleanMeXlxsError(this.mapSelected[m].row!, this.dataSheet[x].colName!);
      //     }
      //   }
      // }



      if (_ret == true && this.cellsInError.length == 0) {
        this.removeLog(this.mandatoryFieldsError);
      }

      _ret = true;
    }
    return _ret;
  }

  checkCustomerItemNo(): boolean {
    const customerItemNoColIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'customeritemno');
    if (customerItemNoColIndex == -1) {
      this.removeLog(this.customerItemNoFormatError);
      this.removeLog(this.customerItemNoDuplicateError);
      return true;
    }

    const rowsToValidate = Array.from(new Set(
      this.mapSelected
        .map(ms => ms.row)
        .filter((row): row is number => row !== undefined && row !== null && row >= 0)
    ));

    if (rowsToValidate.length === 0) {
      this.removeLog(this.customerItemNoFormatError);
      this.removeLog(this.customerItemNoDuplicateError);
      return true;
    }

    let isValid = true;
    let hasFormatError = false;
    const rowsByCustomerItemNo = new Map<number, number[]>();

    for (let x = 0; x < rowsToValidate.length; x++) {
      const row = rowsToValidate[x];
      const rawValue = this.dataSheet[customerItemNoColIndex].colValue![row];
      const normalizedValue = this.utils.normalizeCustomerItemNo(rawValue);
      const numericValue = this.utils.toCustomerItemNoNumber(normalizedValue);

      if (numericValue === null) {
        isValid = false;
        hasFormatError = true;
        this.setCellAsError(row, customerItemNoColIndex, this.customerItemNoFormatError);
        continue;
      }

      const rows = rowsByCustomerItemNo.get(numericValue) || [];
      rows.push(row);
      rowsByCustomerItemNo.set(numericValue, rows);
    }

    if (hasFormatError) {
      this.writeLog("error", this.translate.instant('errors.formatNotValid'), this.customerItemNoFormatError);
    } else {
      this.removeLog(this.customerItemNoFormatError);
    }

    let hasDuplicateError = false;
    rowsByCustomerItemNo.forEach(rows => {
      if (rows.length <= 1) {
        return;
      }

      hasDuplicateError = true;
      isValid = false;
      rows.forEach(row => this.setCellAsError(row, customerItemNoColIndex, this.customerItemNoDuplicateError));
    });

    if (hasDuplicateError) {
      this.writeLog("error", this.translate.instant('errors.customerItemNoDuplicate'), this.customerItemNoDuplicateError);
    } else {
      this.removeLog(this.customerItemNoDuplicateError);
    }

    return isValid;
  }

  isRawMaterialGradeRequired(row: number) {
    let _iRm: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'rawmaterialgrade');
    let _iAl: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
    let _iOl = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomerotherlimitation');
    let _analysisValue: ItemLimitation = this.dataSheet[_iAl].colValue![row];
    let _otherValue: ItemLimitation = this.dataSheet[_iOl].colValue![row];
    let _i: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'normgrades');
    let _values: NormGrade[] = this.dataSheet[_i].colValue![row] || [];
    let _ids: number[] = new Array();
    for (var x = 0; x < _values.length; x++) {
      _ids.push(_values[x].normGradeId!);
    }

    const ignoreLimitations = _analysisValue?.isCustom || _otherValue?.isCustom;
    const analysisLimitation = ignoreLimitations ? null : _analysisValue?.limitation;
    const otherLimitation = ignoreLimitations ? null : _otherValue?.limitation;

    if (!ignoreLimitations && (!analysisLimitation || !otherLimitation)) {
      this.removeCellError(row, _iRm, this.mandatoryFieldsError);
      this.cleanMeXlxsError(row, 'rawmaterialgrade');
      return;
    }


    this.subscriptions.add(this.rawMaterialGradeService.getRawMaterialGradesFromNormGradesAndLimitations(_ids, analysisLimitation ?? null, otherLimitation ?? null).subscribe(res => {
      if (res.rawMaterialGrades && res.rawMaterialGrades.length > 0) {
        // here is required
        if (this.dataSheet[_iRm!].colValue![row] == undefined || this.dataSheet[_iRm!].colValue![row] == null || this.dataSheet[_iRm!].colValue![row] == '') {
          this.setCellAsError(row, _iRm, this.mandatoryFieldsError);
          this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
        }

      }
      else {
        this.cleanMeXlxsError(row, 'rawmaterialgrade');
        this.removeCellError(row, _iRm, this.mandatoryFieldsError);
      }

    }));

  }


  /**
   * CHECK WT/ID/OD
   * @returns 
   */
  checkWtOdId(): boolean {
    let _i: number = -1;
    let _ret: boolean = true;
    for (var x = 0; x < this.mapSelected.length; x++) {
      _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'npsschedule');
      let _isNps: boolean = this.dataSheet[_i].colValue![this.mapSelected[x].row!] == null ? false : true;
      let _iOdValue = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
      let _odValue: any = this.dataSheet[_iOdValue].colValue![this.mapSelected[x].row!];
      let _iIdValue = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'id');
      let _idValue: any = this.dataSheet[_iIdValue].colValue![this.mapSelected[x].row!];
      let _iWtValue = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
      let _wtValue: any = this.dataSheet[_iWtValue].colValue![this.mapSelected[x].row!];

      // NOT VALID - ALL VALUES NULL
      /*      if (this.checkWtOdIdFilled(_odValue, _idValue, _wtValue) == 'err'){
             this.writeLog("error", this.translate.instant('errors.mandatoryFields'),this.mandatoryFields);
             //return false;
           } */

      let _od: number = 0;
      let _id: number = 0;
      let _wt: number = 0;
      _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'unitsystem');

      // MQF-364 Spostato dichiarazioni
      let hasOdValue: boolean = false;
      let hasOdUomValue: boolean = true;
      let hasIdValue: boolean = false;
      let hasIdUomValue: boolean = true;
      let hasWtValue: boolean = false;
      let hasWtUomValue: boolean = true;

      if (!_isNps) {

        hasOdValue = (_odValue != null && _odValue != '');
        // hasOdUomValue = (_odUomValue != null && _odUomValue != '');
        hasIdValue = (_idValue != null && _idValue != '');
        // hasIdUomValue = (_idUomValue != null && _idUomValue != '');
        hasWtValue = (_wtValue != null && _wtValue != '');
        // hasWtUomValue = (_wtUomValue != null && _wtUomValue != '');

        if (hasOdValue && hasIdValue && hasWtValue) {
          this.writeLog("error", this.translate.instant('errors.odIdWtOnlyTwo'), this.odIdWtOnlyTwoError);
          this.setCellAsError(this.mapSelected[x].row!, _iOdValue, this.odIdWtOnlyTwoError);
          this.setCellAsError(this.mapSelected[x].row!, _iIdValue, this.odIdWtOnlyTwoError);
          this.setCellAsError(this.mapSelected[x].row!, _iWtValue, this.odIdWtOnlyTwoError);
          _ret = false;
          continue;
        }

        // If a value exists, ensure the corresponding UOM also exists
        // this.checkOdIdWtUoms(hasOdValue, hasOdUomValue, x, _iOdUom, hasIdValue, hasIdUomValue, _iIdUom, hasWtValue, hasWtUomValue, _iWtUom);

        // Count how many conditions are true
        const trueConditionsCount = [hasOdValue && hasOdUomValue, hasIdValue && hasIdUomValue, hasWtValue && hasWtUomValue].filter((condition) => condition).length;
        const atLeastTwoTrue = trueConditionsCount >= 2;

        if (!atLeastTwoTrue) _ret = false;
        if (!atLeastTwoTrue && !(hasOdValue)) {
          this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
          this.setCellAsError(this.mapSelected[x].row!, _iOdValue, this.mandatoryFieldsError)
        };

        if (!atLeastTwoTrue && !(hasIdValue)) {
          this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
          this.setCellAsError(this.mapSelected[x].row!, _iIdValue, this.mandatoryFieldsError);
        }

        if (!atLeastTwoTrue && !(hasWtValue)) {
          this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
          this.setCellAsError(this.mapSelected[x].row!, _iWtValue, this.mandatoryFieldsError);
        }

      }

      _od = _odValue;
      _id = _idValue;
      _wt = _wtValue;


      // MQF-364 Gestisco qui
      if (!_isNps && hasOdValue && hasIdValue && _od <= _id) {
        this.setCellAsError(this.mapSelected[x].row!, _iIdValue, this.odWtIdError);
        this.setCellAsError(this.mapSelected[x].row!, _iOdValue, this.odWtIdError);
        this.writeLog("error", this.translate.instant('errors.odMajorId'), this.odWtIdError);
        _ret = false;
      } else {
        if (this.cellsInError.length == 0) this.removeLog(this.odWtIdError);
      }

      if (!_isNps && hasOdValue && hasWtValue && _wt > 0 && _od > 0 && _od <= (2 * _wt)) {
        this.setCellAsError(this.mapSelected[x].row!, _iOdValue, this.odWtIdError);
        this.setCellAsError(this.mapSelected[x].row!, _iWtValue, this.odWtIdError);
        this.writeLog("error", this.translate.instant('errors.odMajorWt'), this.odWtIdError);
        _ret = false;
      } else {
        if (this.cellsInError.length == 0) this.removeLog(this.odWtIdError);
      }

      // 
      if (!_isNps && hasOdValue && hasWtValue && hasIdValue && ((Number((_od - _id)).toFixed(2) != (2 * _wt).toFixed(2)))) {
        this.setCellAsError(this.mapSelected[x].row!, _iOdValue, this.odWtIdNotConsistenError);
        this.setCellAsError(this.mapSelected[x].row!, _iWtValue, this.odWtIdNotConsistenError);
        this.setCellAsError(this.mapSelected[x].row!, _iIdValue, this.odWtIdNotConsistenError);
        this.writeLog("error", this.translate.instant('errors.odIdWtNotConsistent'), this.odWtIdNotConsistenError);
        _ret = false;
      } else {
        if (this.cellsInError.length == 0) this.removeLog(this.odWtIdNotConsistenError);
      }
    }
    return _ret;
  }

  private checkOdIdWtUoms(hasOdValue: boolean, hasOdUomValue: boolean, x: number, _iOdUom: number, hasIdValue: boolean, hasIdUomValue: boolean, _iIdUom: number, hasWtValue: boolean, hasWtUomValue: boolean, _iWtUom: number) {
    if (hasOdValue && !hasOdUomValue) {
      this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
      this.setCellAsError(this.mapSelected[x].row!, _iOdUom, this.mandatoryFieldsError);
    }

    if (hasIdValue && !hasIdUomValue) {
      this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
      this.setCellAsError(this.mapSelected[x].row!, _iIdUom, this.mandatoryFieldsError);
    }

    if (hasWtValue && !hasWtUomValue) {
      this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
      this.setCellAsError(this.mapSelected[x].row!, _iWtUom, this.mandatoryFieldsError);
    }
  }

  /**
   * CHECK LenghtMin-Max-Type
   * @returns 
   */
  checkLength(): boolean {
    let _ret: boolean = true;
    let _i: number = -1;
    for (var x = 0; x < this.mapSelected.length; x++) {

      let lengthmin: number = 0;
      let lengthmax: number = 0;
      let lengthType: string;
      let qtyUom: string;
      let cts: boolean;
      let mill: any;
      let testcondition: any;
      let sms: any;

      let _iLt = this.idx('lengthtype');
      lengthType = this.dataSheet[_iLt].colValue![this.mapSelected[x].row!];
      let _iLmin = this.idx('lengthmin');
      let lengthMinValue: any = this.dataSheet[_iLmin].colValue![this.mapSelected[x].row!];
      let _iLmax = this.idx('lengthmax');
      let lengthMaxValue: any = this.dataSheet[_iLmax].colValue![this.mapSelected[x].row!];
      let _iQuom = this.idx('quantityuom');
      qtyUom = this.dataSheet[_iQuom].colValue![this.mapSelected[x].row!];

      let _iUbent = this.idx('ubent');
      let uBentValue = this.dataSheet[_iUbent]?.colValue![this.mapSelected[x].row!];

      let _iMultipleLength = this.idx('multiplelength');
      let multipleLengthValue = this.dataSheet[_iMultipleLength]?.colValue![this.mapSelected[x].row!];

      let _iCts = this.idx('cts');
      cts = this.dataSheet[_iCts].colValue![this.mapSelected[x].row!];

      let _iMill = this.idx('mill');
      mill = this.dataSheet[_iMill].colValue![this.mapSelected[x].row!];

      let _iTestCondition = this.idx('testcondition');
      testcondition = this.dataSheet[_iTestCondition].colValue![this.mapSelected[x].row!];

      let _iSms = this.idx('sms');
      sms = this.dataSheet[_iSms].colValue![this.mapSelected[x].row!];


      lengthmin = parseFloat(lengthMinValue);
      lengthmax = parseFloat(lengthMaxValue);
      // Case when lengthType is "FL"
      if (lengthType === "FL") {
        // If multipleLengthValue is true, check that min is less than max
        if (multipleLengthValue && lengthMaxValue <= lengthMinValue) {
          this.writeLog("error", this.translate.instant("errors.lengthMinMax"), this.lengthMinMaxError);
          this.setCellAsError(this.mapSelected[x].row!, _iLmin, this.lengthMinMaxError);
          this.setCellAsError(this.mapSelected[x].row!, _iLmax, this.lengthMinMaxError);

          _ret = false;
        }

        // when fixed length if multiplelength is false , clean min and max values
        if (!multipleLengthValue) {
          this.dataSheet[_iLmin].colValue![this.mapSelected[x].row!] = null;
          this.dataSheet[_iLmax].colValue![this.mapSelected[x].row!] = null;
          this.setValueOnDataSet(this.mapSelected[x].row!, _iLmin, this.dataSheet[_iLmin].colValue![this.mapSelected[x].row!]);
          this.setValueOnDataSet(this.mapSelected[x].row!, _iLmax, this.dataSheet[_iLmax].colValue![this.mapSelected[x].row!]);

        }

        // Ensure nominalLengthValue exists (assuming it maps to a similar field)
        let _iNominalLength = this.dataSheet.findIndex(col => col.colName?.toLowerCase() == 'lengthnominal');
        let nominalLengthValue = this.dataSheet[_iNominalLength]?.colValue![this.mapSelected[x].row!];

        if (!nominalLengthValue) {
          this.writeLog("error", this.translate.instant("errors.nominalLengthRequired"), this.nominalLengthError);
          this.setCellAsError(this.mapSelected[x].row!, _iNominalLength, this.nominalLengthError);
          _ret = false;
        }
      } else {
        // For RL length types, multipleLengthValue SHOULD BE FALSE
        if (_iMultipleLength) {
          this.dataSheet[_iMultipleLength].colValue![this.mapSelected[x].row!] = false;
          this.setValueOnDataSet(this.mapSelected[x].row!, _iMultipleLength, this.dataSheet[_iMultipleLength].colValue![this.mapSelected[x].row!]);
        }

        // For RL length types, always check that min is less than max
        if (lengthMaxValue <= lengthMinValue) {
          this.writeLog("error", this.translate.instant("errors.lengthMinMax"), this.lengthMinMaxError);
          this.setCellAsError(this.mapSelected[x].row!, _iLmin, this.lengthMinMaxError);
          this.setCellAsError(this.mapSelected[x].row!, _iLmax, this.lengthMinMaxError);
          _ret = false;
        }
      }

      const qtyUomType = this.getQuantityUomTypeByUomCode(qtyUom);

      if (qtyUomType?.toLowerCase() === 'units' && lengthType === "RL") {
        this.writeLog("error", this.translate.instant("errors.lengthShouldBeFixed"), this.lengthShouldBeFixedError);
        this.setCellAsError(this.mapSelected[x].row!, _iLt, this.lengthShouldBeFixedError);
        _ret = false;
      }

      // uBentValue check
      if (uBentValue && (multipleLengthValue || lengthType !== "FL")) {
        this.writeLog("error", this.translate.instant("errors.uBentShouldBeFixedLength"), this.uBentShouldBeFixedLengthError);
        this.setCellAsError(this.mapSelected[x].row!, _iMultipleLength, this.uBentShouldBeFixedLengthError);

        _ret = false;
      }


      if (!!uBentValue && !!cts) {
        this.writeLog("error", this.translate.instant("errors.uBentCtsCheck"), this.uBentCtsError);
        this.setCellAsError(this.mapSelected[x].row!, _iCts, this.uBentCtsError);
        _ret = false;

      }

      // IF cts => TC shuold be TC1 except when mill == CV and SMS == instrumentation
      if (!!cts && this.enquiry.header?.orderReason != 'Project') {
        if (testcondition != 'TC1') {
          // TC1 is always allowed, TC2 only if CV and instrumentation
          if (mill.shortName != 'CV' || sms.description != 'INSTRUMENTATION') {
            this.writeLog("error", this.translate.instant("errors.testConditionCtsCheck"), this.testConditionCtsError);
            this.setCellAsError(this.mapSelected[x].row!, _iTestCondition, this.testConditionCtsError);
            _ret = false;
          }
        }
      }


      // every issue about length is handled, remove length logs
      if (_ret) {
        this.removeLog(this.lengthMinMaxError);
        this.removeLog(this.lengthMinMaxFixedError);
        this.removeLog(this.lengthShouldBeFixedError);
        this.removeLog(this.uBentShouldBeFixedLengthError);
        this.removeLog(this.multipleLengthNotAllowedError);
        this.removeLog(this.nominalLengthError);
        this.removeLog(this.uBentCtsError);
        this.removeLog(this.testConditionCtsError);
      }

    }

    return _ret;
  }

  getQuantityUomTypeByUomCode(uomCode: string): string | undefined {
    if (!uomCode) return undefined;

    if (this.enquiry.header?.unitSystem?.toLowerCase() == 'metric')
      return this.itemParameterValues.quantityUoms?.metricUoms?.filter(u => u.uomCode?.toLowerCase() === uomCode.toLowerCase())[0].uomType;
    else {
      return this.itemParameterValues.quantityUoms?.imperialUoms?.filter(u => u.uomCode?.toLowerCase() === uomCode.toLowerCase())[0].uomType;
    }
  }

  /**
   * Is Greater than ZERO validation
   * @returns 
   */
  isGraterZeroValuesValid(): boolean {
    let _ret: boolean = true;
    // let _i:number = -1;
    let _fields: string[] = new Array();
    for (var x = 0; x < this.mapSelected.length; x++) {

      let colname: string = this.dataSheet[this.mapSelected[x].col!].colName!.toLowerCase();

      if (colname == 'quantity') {
        if (!this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] || parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0) {
          _ret = false;
          _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
          this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.greaterThanZeroError)
        }
      }
      if (colname == 'od') {
        if (this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] && parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0) {
          _ret = false;
          _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
          this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.greaterThanZeroError)
        }
      }
      if (colname == 'id') {
        if (this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] && parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0) {
          _ret = false;
          _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
          this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.greaterThanZeroError)
        }
      }
      if (colname == 'wt') {
        if (this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] && parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0) {
          _ret = false;
          _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
          this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.greaterThanZeroError)
        }
      }
      if (colname == 'lengthmin') {
        if (Number.isFinite(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!]) && parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0) {
          _ret = false;
          _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
          this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.greaterThanZeroError)
        }
      }
      if (colname == 'lengthmax') {
        if (Number.isFinite(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!]) && parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0) {
          _ret = false;
          _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
          this.setCellAsError(this.mapSelected[x].row!, this.mapSelected[x].col!, this.greaterThanZeroError)
        }
      }

      // if (colname == 'totalweight') {
      //   if ( (this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] || parseFloat(this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!].toString()) <= 0)) {
      //     _ret = false;
      //     _fields.push(this.dataSheet[this.mapSelected[x].col!].colName!);
      //   }
      // }

    }

    if (_ret == false)
      this.writeLog("error", this.translate.instant('errors.greaterZero') + " (" + _fields.join(", ") + ") ", this.greaterThanZeroError);
    else
      this.removeLog(this.greaterThanZeroError);

    return _ret;
  }

  private idx = (name: string) => this.dataSheet.findIndex(c => c.colName?.toLowerCase() === name);


  /**
   * CHECK DECIMAL FORMAT 
   * @returns 
   */
  isValidFormat(): boolean {
    let _ret = true;

    // 1) Resolve all column indexes once (no logic change)
    const idxQuantity = this.idx('quantity');
    const idxOd = this.idx('od');
    const idxId = this.idx('id');
    const idxWt = this.idx('wt');
    const idxTotalWeight = this.idx('totalweight');
    const idxOdToleranceMinus = this.idx('odtoleranceminus');
    const idxOdTolerancePlus = this.idx('odtoleranceplus');
    const idxIdToleranceMinus = this.idx('idtoleranceminus');
    const idxIdTolerancePlus = this.idx('idtoleranceplus');
    const idxWtToleranceMinus = this.idx('wttoleranceminus');
    const idxWtTolerancePlus = this.idx('wttoleranceplus');
    const idxLengthMin = this.idx('lengthmin');
    const idxLengthMax = this.idx('lengthmax');

    for (let x = 0; x < this.mapSelected.length; x++) {
      const row = this.mapSelected[x].row!;

      // quantity (val && toString())
      let _quantity: any =
        this.utils.checkDecimal(this.dataSheet[idxQuantity].colValue![row] && this.dataSheet[idxQuantity].colValue![row].toString());
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxQuantity, x, _quantity);

      // od ? toString() : ''
      _quantity =
        this.dataSheet[idxOd].colValue![row]
          ? this.utils.checkDecimal(this.dataSheet[idxOd].colValue![row].toString())
          : '';
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxOd, x, _quantity);

      // id ? toString() : ''
      _quantity =
        this.dataSheet[idxId].colValue![row]
          ? this.utils.checkDecimal(this.dataSheet[idxId].colValue![row].toString())
          : '';
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxId, x, _quantity);

      // wt ? toString() : ''
      _quantity =
        this.dataSheet[idxWt].colValue![row]
          ? this.utils.checkDecimal(this.dataSheet[idxWt].colValue![row].toString())
          : '';
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxWt, x, _quantity);

      // totalweight (only if column exists)
      if (idxTotalWeight !== -1) {
        _quantity = this.utils.checkDecimal(this.dataSheet[idxTotalWeight].colValue![row].toString());
        if (_quantity == 'error') _ret = false;
        else this.updateQtyAfterValidation(idxTotalWeight, x, _quantity);
      }

      // odtoleranceminus (val && toString())
      if (idxOdToleranceMinus !== -1) {
        _quantity =
          this.utils.checkDecimal(this.dataSheet[idxOdToleranceMinus].colValue![row] && this.dataSheet[idxOdToleranceMinus].colValue![row].toString());
        if (_quantity == 'error') _ret = false;
        else this.updateQtyAfterValidation(idxOdToleranceMinus, x, _quantity);
      }

      // odtoleranceplus (val && toString())
      if (idxOdTolerancePlus !== -1) {
        _quantity =
          this.utils.checkDecimal(this.dataSheet[idxOdTolerancePlus].colValue![row] && this.dataSheet[idxOdTolerancePlus].colValue![row].toString());
        if (_quantity == 'error') _ret = false;
        else this.updateQtyAfterValidation(idxOdTolerancePlus, x, _quantity);
      }

      // idtoleranceminus (val && toString())
      if (idxIdToleranceMinus !== -1) {
        _quantity =
          this.utils.checkDecimal(this.dataSheet[idxIdToleranceMinus].colValue![row] && this.dataSheet[idxIdToleranceMinus].colValue![row].toString());
        if (_quantity == 'error') _ret = false;
        else this.updateQtyAfterValidation(idxIdToleranceMinus, x, _quantity);
      }

      // idtoleranceplus (val && toString())
      if (idxIdTolerancePlus !== -1) {
        _quantity =
          this.utils.checkDecimal(this.dataSheet[idxIdTolerancePlus].colValue![row] && this.dataSheet[idxIdTolerancePlus].colValue![row].toString());
        if (_quantity == 'error') _ret = false;
        else this.updateQtyAfterValidation(idxIdTolerancePlus, x, _quantity);
      }

      // wttoleranceminus (val && toString())
      _quantity =
        this.utils.checkDecimal(this.dataSheet[idxWtToleranceMinus].colValue![row] && this.dataSheet[idxWtToleranceMinus].colValue![row].toString());
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxWtToleranceMinus, x, _quantity);

      // wttoleranceplus (val && toString())
      _quantity =
        this.utils.checkDecimal(this.dataSheet[idxWtTolerancePlus].colValue![row] && this.dataSheet[idxWtTolerancePlus].colValue![row].toString());
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxWtTolerancePlus, x, _quantity);

      // lengthmin (val && toString())
      _quantity =
        this.utils.checkDecimal(this.dataSheet[idxLengthMin].colValue![row] && this.dataSheet[idxLengthMin].colValue![row].toString());
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxLengthMin, x, _quantity);

      // lengthmax (val && toString())
      _quantity =
        this.utils.checkDecimal(this.dataSheet[idxLengthMax].colValue![row] && this.dataSheet[idxLengthMax].colValue![row].toString());
      if (_quantity == 'error') _ret = false;
      else this.updateQtyAfterValidation(idxLengthMax, x, _quantity);
    }

    if (_ret == false)
      this.writeLog("error", this.translate.instant('errors.formatNotValid'), this.decimalValuesError);
    else
      this.removeLog(this.decimalValuesError);

    return _ret;
  }


  updateQtyAfterValidation(_i: number, x: number, _quantity: any) {
    this.dataSheet[_i].colValue![this.mapSelected[x].row!] = _quantity;
    this.setValueOnDataSet(this.mapSelected[x].row!, _i, _quantity);
  }

  /**
   * Tolerances Validation
   * @returns 
   */
  tolerancesAreValid(): boolean {
    let _ret: boolean = true;

    // Indexes for OD tolerances
    let _iOd = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
    let _iOdToleranceMinus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'odtoleranceminus');
    let _iOdTolerancePlus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'odtoleranceplus');
    let _iOdToleranceUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'odtoleranceuom');

    // Indexes for ID tolerances
    let _iId = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'id');
    let _iIdToleranceMinus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceminus');
    let _iIdTolerancePlus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceplus');
    let _iIdToleranceUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceuom');

    // Indexes for WT tolerances
    let _iWt = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
    let _iWtToleranceMinus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wttoleranceminus');
    let _iWtTolerancePlus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wttoleranceplus');
    let _iWtToleranceUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wttoleranceuom');


    for (let x = 0; x < this.mapSelected.length; x++) {
      let row = this.mapSelected[x].row!;
      let hasOdValue = !!this.dataSheet[_iOd]?.colValue![row];
      let hasIdValue = !!this.dataSheet[_iId]?.colValue![row];
      let hasWtValue = !!this.dataSheet[_iWt]?.colValue![row];

      let _odMinus = parseFloat(this.dataSheet[_iOdToleranceMinus]?.colValue![row] ?? '');
      let _odPlus = parseFloat(this.dataSheet[_iOdTolerancePlus]?.colValue![row] ?? '');
      let _odUom = this.dataSheet[_iOdToleranceUom]?.colValue![row];
      let _idMinus = parseFloat(this.dataSheet[_iIdToleranceMinus]?.colValue![row] ?? '');
      let _idPlus = parseFloat(this.dataSheet[_iIdTolerancePlus]?.colValue![row] ?? '');
      let _idUom = this.dataSheet[_iIdToleranceUom]?.colValue![row];
      let _wtMinus = parseFloat(this.dataSheet[_iWtToleranceMinus]?.colValue![row] ?? '');
      let _wtPlus = parseFloat(this.dataSheet[_iWtTolerancePlus]?.colValue![row] ?? '');
      let _wtTolUom = this.dataSheet[_iWtToleranceUom]?.colValue![row];

      // Tolerance count rule
      const hasWtTolerance = Number.isFinite(_wtPlus) && Number.isFinite(_wtMinus) && hasWtValue;
      const hasOdTolerance = Number.isFinite(_odMinus) && Number.isFinite(_odPlus) && hasOdValue;
      const hasIdTolerance = Number.isFinite(_idMinus) && Number.isFinite(_idPlus) && hasIdValue;
      const hasAnyOdTolerance = Number.isFinite(_odMinus) || Number.isFinite(_odPlus) || !!_odUom;
      const hasAnyIdTolerance = Number.isFinite(_idMinus) || Number.isFinite(_idPlus) || !!_idUom;
      const hasAnyWtTolerance = Number.isFinite(_wtMinus) || Number.isFinite(_wtPlus) || !!_wtTolUom;

      const toleranceCount = [hasWtTolerance, hasOdTolerance, hasIdTolerance].filter(Boolean).length;
      if (toleranceCount > 2) {
        _ret = false;
        this.setCellAsError(row, _iIdToleranceMinus, this.tolerancesError);
        this.setCellAsError(row, _iIdTolerancePlus, this.tolerancesError);
        this.setCellAsError(row, _iOdToleranceMinus, this.tolerancesError);
        this.setCellAsError(row, _iOdTolerancePlus, this.tolerancesError);
        this.setCellAsError(row, _iWtToleranceMinus, this.tolerancesError);
        this.setCellAsError(row, _iWtTolerancePlus, this.tolerancesError);
      }

      // OD tolerance checks
      // is od has not value, clean od tolerances fields
      if (hasAnyOdTolerance && !hasOdValue) {
        this.dataSheet[_iOdToleranceMinus].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iOdToleranceMinus, null);
        this.dataSheet[_iOdTolerancePlus].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iOdTolerancePlus, null);
        this.dataSheet[_iOdToleranceUom].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iOdToleranceUom, null);
      }

      if ((Number.isFinite(_odMinus) || Number.isFinite(_odPlus)) && (!Number.isFinite(_odMinus) || !Number.isFinite(_odPlus) || !_odUom)) {
        _ret = false;
        if (!Number.isFinite(_odMinus)) this.setCellAsError(row, _iOdToleranceMinus, this.tolerancesError);
        if (!Number.isFinite(_odPlus)) this.setCellAsError(row, _iOdTolerancePlus, this.tolerancesError);
        if (!_odUom) this.setCellAsError(row, _iOdToleranceUom, this.tolerancesError);
      }

      if (hasOdTolerance && _odMinus > _odPlus) {
        _ret = false;
        this.setCellAsError(row, _iOdToleranceMinus, this.tolerancesError);
        this.setCellAsError(row, _iOdTolerancePlus, this.tolerancesError);
      }

      // ID tolerance checks
      if (hasAnyIdTolerance && !hasIdValue) {
        this.dataSheet[_iIdToleranceMinus].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iIdToleranceMinus, null);
        this.dataSheet[_iIdTolerancePlus].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iIdTolerancePlus, null);
        this.dataSheet[_iIdToleranceUom].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iIdToleranceUom, null);
      }

      if ((Number.isFinite(_idMinus) || Number.isFinite(_idPlus)) && (!Number.isFinite(_idMinus) || !Number.isFinite(_idPlus) || !_idUom)) {
        _ret = false;
        if (!Number.isFinite(_idMinus)) this.setCellAsError(row, _iIdToleranceMinus, this.tolerancesError);
        if (!Number.isFinite(_idPlus)) this.setCellAsError(row, _iIdTolerancePlus, this.tolerancesError);
        if (!_idUom) this.setCellAsError(row, _iIdToleranceUom, this.tolerancesError);
      }

      if (hasIdTolerance && _idMinus > _idPlus) {
        _ret = false;
        this.setCellAsError(row, _iIdToleranceMinus, this.tolerancesError);
        this.setCellAsError(row, _iIdTolerancePlus, this.tolerancesError);
      }

      // WT tolerance checks
      if (hasAnyWtTolerance && !hasWtValue) {
        this.dataSheet[_iWtToleranceMinus].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iWtToleranceMinus, null);
        this.dataSheet[_iWtTolerancePlus].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iWtTolerancePlus, null);
        this.setValueOnDataSheetAndDataSet(_iWtToleranceUom, x, null);
      }

      if ((Number.isFinite(_wtMinus) || Number.isFinite(_wtPlus)) && (!Number.isFinite(_wtMinus) || !Number.isFinite(_wtPlus) || !_wtTolUom)) {
        _ret = false;
        if (!Number.isFinite(_wtMinus)) this.setCellAsError(row, _iWtToleranceMinus, this.tolerancesError);
        if (!Number.isFinite(_wtPlus)) this.setCellAsError(row, _iWtTolerancePlus, this.tolerancesError);
        if (!_wtTolUom) this.setCellAsError(row, _iWtToleranceUom, this.tolerancesError);
      }

      if (hasWtTolerance && _wtMinus > _wtPlus) {
        _ret = false;
        this.setCellAsError(row, _iWtToleranceMinus, this.tolerancesError);
        this.setCellAsError(row, _iWtTolerancePlus, this.tolerancesError);
      }

      // Check if WT UOM is percentage for non-custom tube execution
      let tubExecIdx = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'tubeexecution');
      let typeOfToleranceIdx = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'typeoftolerance');

      let typeOfTolerance = this.dataSheet[typeOfToleranceIdx]?.colValue![row];
      let tubeExec = tubExecIdx != -1 ? this.dataSheet[tubExecIdx]?.colValue![row] : null;
      const hasTubeExecution = !!tubeExec;
      const requiresWtTolerance = hasWtValue && hasTubeExecution;

      if (hasWtValue && (typeOfTolerance == null || typeOfTolerance == undefined || typeOfTolerance == '')) {
        this.setCellAsError(row, typeOfToleranceIdx, this.mandatoryFieldsError);
        _ret = false;
      }

      if (requiresWtTolerance || hasAnyWtTolerance) {
        if (_wtMinus == null || _wtMinus == undefined || isNaN(_wtMinus)) {
          this.setCellAsError(row, _iWtToleranceMinus, this.mandatoryFieldsError);
          _ret = false;
        }
        if (_wtPlus == null || _wtPlus == undefined || isNaN(_wtPlus)) {
          this.setCellAsError(row, _iWtTolerancePlus, this.mandatoryFieldsError);
          _ret = false;
        }
        if (_wtTolUom == null || _wtTolUom == undefined) {
          this.setCellAsError(row, _iWtToleranceUom, this.mandatoryFieldsError);
          _ret = false;
        }
      }

      if (hasWtValue && hasTubeExecution && !tubeExec.isCustom && _wtTolUom && _wtTolUom != '%') {
        this.setCellAsError(row, _iWtToleranceUom, this.tolerancesError);
      }
    }

    // Final logging
    if (_ret) {
      this.removeLog(this.tolerancesError);
    } else {
      this.writeLog("error", this.translate.instant('errors.tolerancesNotValid'), this.tolerancesError);
    }

    return _ret;
  }


  extraDeliveryPropertiesAreValid(): boolean {
    let _ret: boolean = true;
    this.removeLog(this.htError);
    return _ret;

    // deprecated check as requested by customer 2025-03-27

    // Indexes for OD tolerances
    let _iMill = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');
    let _iHt = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'ht');


    for (let x = 0; x < this.mapSelected.length; x++) {
      let row = this.mapSelected[x].row!;
      let mill = this.dataSheet[_iMill]?.colValue![row].shortName;
      if (mill == 'CV') {
        let ht = this.dataSheet[_iHt]?.colValue![row];
        if (ht != false) {
          this.setCellAsError(row, _iHt, this.htError);
          _ret = false;
        }
      }
    }

    if (_ret) {
      this.removeLog(this.htError);
    } else {
      this.writeLog("error", this.translate.instant('errors.htNotValid'), this.htError);
    }

    return _ret;

  }

  setValueOnDataSheetAndDataSet(columnIndex: number, selectedRowIndex: number, value: any) {
    this.dataSheet[columnIndex].colValue![this.mapSelected[selectedRowIndex].row!] = value;
    this.setValueOnDataSet(this.mapSelected[selectedRowIndex].row!, columnIndex, value);
  }

  setValueOnDataSheetAndDataSetByColumnName(columnName: string, selectedRowIndex: number, value: any) {
    const columnIndex = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == columnName.toLowerCase());
    if (columnIndex != -1) {
      this.dataSheet[columnIndex].colValue![this.mapSelected[selectedRowIndex].row!] = value;
      this.setValueOnDataSet(this.mapSelected[selectedRowIndex].row!, columnIndex, value);
    }
  }

  /* DEPRECATED */
  /*   checkWtOdIdFilled(odValue: any, idValue: any, wtValue: any): string{
      let _case: string = "";
      // NOT VALID - ALL VALUES NULL
      if (odValue == '' && idValue == '' && wtValue == ''){
        _case = "err";
      }
  
      // NOT VALID - OD VALID, ID NULL, WT NULL
      if (odValue != '' && idValue == '' && wtValue == ''){
        _case = "err";
      }
  
      // NOT VALID - OD NULL, ID VALID, WT NULL
      if (odValue == '' && idValue != '' && wtValue == ''){
        _case = "err";
      }
  
      // NOT VALID - OD NULL, ID NULL, WT VALID
      if (odValue == '' && idValue == '' && wtValue != ''){
        _case = "err";
      }
  
      // 1 VALID - OD VALID, ID VALID, WT NULL
      let _i: number = -1;
      if (odValue != '' && idValue != '' && wtValue == ''){
        _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'wt');
        this.dataSheet[_i].isRequired = false;
  
        _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'wtuom');
        this.dataSheet[_i].isRequired = false;
        _case = '1';
      }
  
      // 2 VALID - OD NULL, ID VALID, WT VALID
      if (odValue == '' && idValue != '' && wtValue != ''){
        _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'od');
        this.dataSheet[_i].isRequired = false;
  
        _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'oduom');
        this.dataSheet[_i].isRequired = false;
        _case = '2';
      }
  
      // 3 VALID - OD VALID, ID NULL, WT VALID
      if (odValue != '' && idValue == '' && wtValue != ''){
        _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'id');
        this.dataSheet[_i].isRequired = false;
  
        _i = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'iduom');
        this.dataSheet[_i].isRequired = false;
        _case = '3';
      }
  
      return _case;
    }
   */
  /**
   * CHECK MILL RUL ON INPUT OD, SELECT SMS
   */
  checkMillRule() {
    // VERIFICARE
  }

  private normalizeSurfaceTypeText(value?: string | null): string {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private findSurfaceTypeByNames(names: string[]): SurfaceTypes | undefined {
    const candidates = names.map(name => this.normalizeSurfaceTypeText(name));
    return this.itemParameterValues.surfaceTypes?.find(surface => {
      const name = this.normalizeSurfaceTypeText(surface.name);
      const description = this.normalizeSurfaceTypeText((surface as any).description);
      return candidates.includes(name) || candidates.includes(description);
    });
  }

  private getOdInMmForSelectedRow(selectedItemIdx: number): number | null {
    if (selectedItemIdx < 0 || selectedItemIdx >= this.mapSelected.length) {
      return null;
    }

    const rowIndex = this.mapSelected[selectedItemIdx].row!;
    return this.getOdInMmByRowIndex(rowIndex);
  }

  private getOdInMmByRowIndex(rowIndex: number): number | null {
    const odColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
    if (odColumnIndex == -1) {
      return null;
    }

    const odValue = Number(this.dataSheet[odColumnIndex].colValue?.[rowIndex]);
    if (!Number.isFinite(odValue)) {
      return null;
    }

    // const odUom = (this.dataSheet[odUomColumnIndex].colValue?.[rowIndex] || '').toString().toLowerCase();
    if (this.enquiry.header?.unitSystem?.toLowerCase() == 'imperial') {
      return odValue * 25.4;
    }
    return odValue; // default mm
  }

  private isHollowBarsSms(sms?: ItemSms | null): boolean {
    const normalizedDescription = (sms?.description ?? '').toString().trim().toLowerCase();
    const normalizedName = ((sms as any)?.name ?? '').toString().trim().toLowerCase();
    return normalizedDescription === 'hollow bars' || normalizedName === 'hollow bars';
  }

  private isHexuSms(sms?: { name?: string | null } | null): boolean {
    return (sms?.name ?? '').toString().trim().toUpperCase() === 'HEXU';
  }

  private applyFirstNewItemHeaderHexuUbentDefault(): void {
    if (!this.dataSet || this.dataSet.length != 1 || !this.isHexuSms(this.enquiry?.header?.sms)) {
      return;
    }

    const firstItem = this.dataSet[0];
    if (!firstItem || typeof firstItem !== 'object' || !this.isNewItem(firstItem)) {
      return;
    }

    const uBentKey = Object.keys(firstItem).find(k => k.toLowerCase() == 'ubent') || 'uBent';
    firstItem[uBentKey] = true;
  }

  private isNewItem(item: any): boolean {
    const itemNo = item?.itemNo;
    return itemNo == null
      || itemNo === ''
      || (typeof itemNo === 'string' && itemNo.trim().toLowerCase().startsWith('new('));
  }

  private isHydroEditableMillCode(millShortName?: string | null): boolean {
    const normalizedMillCode = (millShortName ?? '').toString().trim().toUpperCase();
    return normalizedMillCode === 'MB' || normalizedMillCode === 'RS';
  }

  private getMillForRow(rowIndex: number): Mill | null {
    const millColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');
    return millColumnIndex != -1 ? this.dataSheet[millColumnIndex].colValue?.[rowIndex] as Mill | null : null;
  }

  private isHydroTestDisabledForRow(rowIndex: number): boolean {
    const ctsColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'cts');
    if (ctsColumnIndex == -1 || !this.dataSheet[ctsColumnIndex].colValue?.[rowIndex]) {
      return false;
    }

    const millShortName = this.getMillForRow(rowIndex)?.shortName;
    return !this.isHydroEditableMillCode(millShortName);
  }

  private resolveHydroTestDefaultValueForRow(rowIndex: number): boolean {
    const smsColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'sms');
    const sms = smsColumnIndex != -1 ? this.dataSheet[smsColumnIndex].colValue?.[rowIndex] as ItemSms | null : null;
    const isHollowBars = this.isHollowBarsSms(sms);
    const odMm = this.getOdInMmByRowIndex(rowIndex);
    return isHollowBars || (odMm !== null && odMm > 168.3);
  }

  private setCellValueByRowIndex(columnName: string, rowIndex: number, value: any): void {
    const columnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == columnName.toLowerCase());
    if (columnIndex == -1) {
      return;
    }

    this.dataSheet[columnIndex].colValue![rowIndex] = value;
    this.setValueOnDataSet(rowIndex, columnIndex, value);
  }

  private syncHydroTestRuleForRow(rowIndex: number, applyDefaultForEditable: boolean): void {
    const ctsColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'cts');
    if (ctsColumnIndex == -1 || !this.dataSheet[ctsColumnIndex].colValue?.[rowIndex]) {
      return;
    }

    if (this.isHydroTestDisabledForRow(rowIndex)) {
      this.setCellValueByRowIndex('hydroTest', rowIndex, false);
      return;
    }

    if (!applyDefaultForEditable) {
      return;
    }

    this.setCellValueByRowIndex('hydroTest', rowIndex, this.resolveHydroTestDefaultValueForRow(rowIndex));
  }

  private enforceHydroTestRulesOnLoad(): void {
    const hydroTestColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'hydrotest');
    if (hydroTestColumnIndex == -1) {
      return;
    }

    const rowCount = this.dataSheet[hydroTestColumnIndex].colValue?.length || 0;
    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      this.syncHydroTestRuleForRow(rowIndex, false);
    }
  }

  private resolveDefaultSurfaceTypeForSelectedRow(selectedItemIdx: number): SurfaceTypes | undefined {
    if (selectedItemIdx < 0 || selectedItemIdx >= this.mapSelected.length) {
      return undefined;
    }

    const rowIndex = this.mapSelected[selectedItemIdx].row!;
    const marketingRouteColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'marketingroute');
    const smsColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'sms');
    const millColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');

    const marketingRoute = (marketingRouteColumnIndex != -1 ? this.dataSheet[marketingRouteColumnIndex].colValue?.[rowIndex] : null) as string | null;
    const sms = (smsColumnIndex != -1 ? this.dataSheet[smsColumnIndex].colValue?.[rowIndex] : null) as ItemSms | null;
    const route = (marketingRoute || sms?.marketingRoute || '').toString().toLowerCase();

    const mill = (millColumnIndex != -1 ? this.dataSheet[millColumnIndex].colValue?.[rowIndex] : null) as Mill | null;
    const millShortName = (mill?.shortName || '').toString().toUpperCase();
    const odMm = this.getOdInMmForSelectedRow(selectedItemIdx);

    const pickled = this.findSurfaceTypeByNames(['PICKLED / PASSIVATED']);
    const freeFromScale = this.findSurfaceTypeByNames(['FREE FROM SCALE']);
    const brightAnnealed = this.findSurfaceTypeByNames(['BRIGHT ANNEALED', 'IN BRIGHT CONDITION']);

    if (route !== 'cold') {
      return pickled;
    }

    if (millShortName === 'CV' && odMm !== null && odMm >= 6 && odMm <= 15) {
      return brightAnnealed || pickled;
    }

    if (millShortName === 'CV' && odMm !== null && odMm > 15) {
      return freeFromScale || pickled;
    }

    if (millShortName === 'RS') {
      return freeFromScale || pickled;
    }

    return pickled;
  }

  private applyDefaultSurfaceTypeForSelectedRow(selectedItemIdx: number): void {
    const surfaceTypeColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'surfacetype');
    if (surfaceTypeColumnIndex == -1) {
      return;
    }

    const defaultSurfaceType = this.resolveDefaultSurfaceTypeForSelectedRow(selectedItemIdx);
    if (!defaultSurfaceType) {
      return;
    }

    this.setValueOnDataSheetAndDataSet(surfaceTypeColumnIndex, selectedItemIdx, defaultSurfaceType);
  }

  setDefaultQuantityUom(selectedItemIdx: number) {
    const isMetric = this.enquiry.header?.unitSystem == 'Metric';
    let quantityUomValue;
    const _iSms = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'sms');
    const _iQtyUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'quantityuom');
    const _iQty = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'quantity');
    const _iLenghtType = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'lengthtype');
    const rowIndex = this.mapSelected[selectedItemIdx].row!;
    const previousQuantityUom = (this.dataSheet[_iQtyUom].colValue?.[rowIndex] ?? null) as string | null;

    const sms = this.dataSheet[_iSms].colValue![rowIndex] as ItemSms;
    const lengtType = this.dataSheet[_iLenghtType].colValue![rowIndex];

    const uoms = this.itemParameterValues.quantityUoms;

    const findUom = (list: Uom[], code: string) => list?.find(qu => qu.uomCode === code)?.uomCode;

    if (sms?.description?.toLowerCase() === 'hollow bars') {
      quantityUomValue = isMetric ? findUom(uoms?.metricUoms!, 'kg') : findUom(uoms?.imperialUoms!, 'lb');
    } else if (lengtType === 'FL') {
      quantityUomValue = findUom(uoms?.metricUoms!, 'pcs');
    } else if (lengtType === 'RL') {
      quantityUomValue = isMetric ? findUom(uoms?.metricUoms!, 'm') : findUom(uoms?.imperialUoms!, 'ft');
    }

    this.setValueOnDataSheetAndDataSet(_iQtyUom, selectedItemIdx, quantityUomValue);

    if ((quantityUomValue ?? null) !== previousQuantityUom) {
      this.setValueOnDataSheetAndDataSet(_iQty, selectedItemIdx, null);
    }

  }

  setUbent(selectedItemIdx: number, selectedSms: ItemSms) {
    const value = this.isHexuSms(selectedSms);
    const ubentIdx = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'ubent');
    this.setValueOnDataSheetAndDataSet(ubentIdx, selectedItemIdx, value);
  }


  checkSmsHollowBarsRule(selectedItemIdx: number, selectedSms: ItemSms | null) {
    if (!selectedSms)
      return;
    if (selectedSms.description?.toLowerCase() === 'hollow bars') {
      // Indexes for OD
      let _iOd = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
      let _iOdToleranceMinus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'odtoleranceminus');
      let _iOdTolerancePlus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'odtoleranceplus');
      let _iOdToleranceUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'odtoleranceuom');

      // Indexes for ID
      let _iId = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'id');
      let _iIdToleranceMinus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceminus');
      let _iIdTolerancePlus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceplus');
      let _iIdToleranceUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceuom');

      // Indexes for WT
      let _iWt = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
      let _iWtUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wtuom');
      let _iWtToleranceMinus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wttoleranceminus');
      let _iWtTolerancePlus = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wttoleranceplus');
      let _iWtToleranceUom = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wttoleranceuom');
      let _iTubExecIdx = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'tubeexecution');
      let _iTypeOfToleranceIdx = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'typeoftolerance');

      // clean tolerances values for WT
      this.setValueOnDataSheetAndDataSet(_iWt, selectedItemIdx, null);
      // this.setValueOnDataSheetAndDataSet(_iWtUom, selectedItemIdx, null);
      this.setValueOnDataSheetAndDataSet(_iWtToleranceMinus, selectedItemIdx, null);
      this.setValueOnDataSheetAndDataSet(_iWtTolerancePlus, selectedItemIdx, null);
      this.setValueOnDataSheetAndDataSet(_iWtToleranceUom, selectedItemIdx, null);
      this.setValueOnDataSheetAndDataSet(_iTubExecIdx, selectedItemIdx, null);
      this.setValueOnDataSheetAndDataSet(_iTypeOfToleranceIdx, selectedItemIdx, null);

      // if od and id are empty then default to 0
      let odValue = this.dataSheet[_iOd].colValue![this.mapSelected[selectedItemIdx].row!];
      if (!Number.isFinite(odValue))
        this.setValueOnDataSheetAndDataSet(_iOd, selectedItemIdx, 1);
      let idValue = this.dataSheet[_iId].colValue![this.mapSelected[selectedItemIdx].row!];
      if (!Number.isFinite(idValue))
        this.setValueOnDataSheetAndDataSet(_iId, selectedItemIdx, 1);

      // od tol lower 0% upper 2%
      this.setValueOnDataSheetAndDataSet(_iOdToleranceMinus, selectedItemIdx, 0);
      this.setValueOnDataSheetAndDataSet(_iOdTolerancePlus, selectedItemIdx, 2);
      this.setValueOnDataSheetAndDataSet(_iOdToleranceUom, selectedItemIdx, '%');
      // id tol lower -2% upper 0%
      this.setValueOnDataSheetAndDataSet(_iIdToleranceMinus, selectedItemIdx, -2);
      this.setValueOnDataSheetAndDataSet(_iIdTolerancePlus, selectedItemIdx, 0);
      this.setValueOnDataSheetAndDataSet(_iIdToleranceUom, selectedItemIdx, '%');
    }
  }

  onCtsSelect(selectedItemIdx: number) {
    const materialColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
    const rowIndex = this.mapSelected[selectedItemIdx]?.row;
    const hasMaterialCode = materialColumnIndex != -1
      && rowIndex != null
      && !!this.dataSheet[materialColumnIndex].colValue?.[rowIndex]?.materialCode;
    const materialValuesBeforeCts = this.getMaterialDependentCtsValuesForSelectedRow(selectedItemIdx);

    // disable all extra delivery props
    const toBeUpdatesProps = this.deliveryExtraProperties
      .map(ep => ep.toLowerCase())
      .filter(ep => ep != 'hydrotest');

    toBeUpdatesProps.forEach(prop => {

      const propIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == prop);
      this.setValueOnDataSheetAndDataSet(propIndex, selectedItemIdx, false);
    })


    // update endsConditions and test conditions if necessary

    const endsConditionValue = this.endsConditionOptionList.find(ec => ec.text == 'SquareCutDeburred')?.value;
    let propIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'endscondition');
    this.setValueOnDataSheetAndDataSet(propIndex, selectedItemIdx, endsConditionValue);

    let testConditionValue = this.testConditionOptionList.find(ec => ec.text == 'TC1')?.value;
    propIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'testcondition');
    this.setValueOnDataSheetAndDataSet(propIndex, selectedItemIdx, testConditionValue);

    let _i: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'marketingroute');
    const marketingRoute = this.dataSheet[_i].colValue![this.mapSelected[selectedItemIdx].row!];
    this.setDefaultHtValue(marketingRoute, selectedItemIdx);
    this.applyCtsHydroTestDefaultRule(selectedItemIdx);

    const materialValuesAfterCts = this.getMaterialDependentCtsValuesForSelectedRow(selectedItemIdx);
    if (hasMaterialCode && !_.isEqual(materialValuesBeforeCts, materialValuesAfterCts)) {
      this.invalidateMaterialCode(selectedItemIdx);
    }

  }

  private getMaterialDependentCtsValuesForSelectedRow(selectedItemIdx: number): Record<string, any> {
    const rowIndex = this.mapSelected[selectedItemIdx]?.row;
    if (rowIndex == null) {
      return {};
    }

    return this.materialDependentCtsProperties.reduce((values, property) => {
      const columnIndex = this.dataSheet.findIndex(column => column.colName?.toLowerCase() == property.toLowerCase());
      if (columnIndex != -1) {
        values[property] = _.cloneDeep(this.dataSheet[columnIndex].colValue?.[rowIndex]);
      }
      return values;
    }, {} as Record<string, any>);
  }

  private applyCtsHydroTestDefaultRule(selectedItemIdx: number): void {
    const rowIndex = this.mapSelected[selectedItemIdx]?.row;
    if (rowIndex == undefined || rowIndex == null) {
      return;
    }

    this.syncHydroTestRuleForRow(rowIndex, true);
  }


  checkMillRule_DEPRECATED() {
    if (this.logOperations.findIndex(x => x.code == this.millRuleActiveError) == -1) return;
    // Check OD and MILL
    let _odValue: string = "";
    let _odUomValue: string = "";
    let _marketingRoute: string = "";

    let _data: Mill = new Mill();
    for (var x = 0; x < this.mapSelected.length; x++) {
      _data = new Mill();
      _odValue = this.dataSheet.filter(x => x.colName!.toLowerCase() == 'od')[0].colValue![this.mapSelected[x].row!];
      _odUomValue = this.dataSheet.filter(x => x.colName!.toLowerCase() == 'oduom')[0].colValue![this.mapSelected[x].row!];
      _marketingRoute = this.dataSheet.filter(x => x.colName!.toLowerCase() == 'sms')[0].colValue![this.mapSelected[x].row!]["marketingRoute"];

      if (_marketingRoute == 'Cold' && (parseFloat(_odValue) >= 6 && parseFloat(_odValue) <= 88.99) && _odUomValue == 'mm')
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'CV')!;

      if (_marketingRoute == 'Cold' && (parseFloat(_odValue) > 88.99) && _odUomValue == 'mm')
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'RS')!;

      if (_data.millId) {
        this.dataSheet.filter(x => x.colName!.toLowerCase() == 'mill')[0].colValue![this.mapSelected[x].row!] = _data;
        this.dataSet[this.mapSelected[x].row!]["mill"] = _data;
        this.writeLog("info", _data.shortName + " " + this.translate.instant("errors.applyMillRule"), 0)
      } /* else {
        this.dataSheet.filter(x => x.colName!.toLowerCase() == 'mill')[0].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(x,this.mapSelected[x].row!, null);
      } */
    }
    _data = new Mill();
  }

  /**
   * Setto la cella in errore per la visualizzazione grafica
   * @param row 
   * @param col 
   * @param errorCode 
   */
  setCellAsError(row: number, col: number, errorCode: number) {
    // Push the cell only if there's no another one
    let _i: number = this.cellsInError.findIndex(x => x.col == col && x.row == row && x.errorCode == errorCode)
    if (_i == -1) {
      let _item: CellInError = new CellInError();
      _item.row = row;
      _item.col = col;
      _item.errorCode = errorCode;
      this.cellsInError.push(_item);
    }/*  else {
      if (this.cellsInError[_i].errorCode != this.fromXlsxError){
        this.cellsInError[_i].errorCode = errorCode;
      }
    } */
  }

  removeCellError(row: number, col: number, errorCode: number) {
    this.cellsInError = this.cellsInError.filter(x => !(x.col == col && x.row == row && x.errorCode == errorCode));
  }

  private normalizeXlsxErrorColName(colName?: string): string {
    return (colName || '').trim().toLowerCase();
  }

  private getXlsxErrorColCandidates(colName: string): string[] {
    const normalized = this.normalizeXlsxErrorColName(colName);
    if (!normalized) {
      return [];
    }

    const withoutField = normalized.replace(/field$/i, '');
    const withField = `${withoutField}field`;
    return [withoutField, withField];
  }

  private findXlsxErrorIndex(row: number, colName: string): number {
    const candidates = this.getXlsxErrorColCandidates(colName);
    if (candidates.length === 0) {
      return -1;
    }

    return this.cellsXlxsInError.findIndex(x =>
      x.row == row && candidates.includes(this.normalizeXlsxErrorColName(x.colName))
    );
  }

  private hasXlsxError(row: number, colName: string): boolean {
    return this.findXlsxErrorIndex(row, colName) !== -1;
  }

  isCellInError(row: number, col: number, colName: string): boolean {
    if (this.cellsInError.findIndex(x => x.row == row && x.col == col) == -1 &&
      !this.hasXlsxError(row, colName))
      return false;
    else
      return true;
  }

  setcellsXlxsAsError(row: number, colName: string, message: string) {
    if (!this.cellsXlxsInError) this.cellsXlxsInError = new Array();
    let _i: number = this.cellsXlxsInError.findIndex(x => x.row == row && x.colName == colName && x.message == message)
    if (_i == -1) {
      let _item: CellXlxsInError = new CellXlxsInError();
      _item.row = row;
      _item.colName = colName;
      _item.message = message;
      this.cellsXlxsInError.push(_item);
    }
  }
  /******************************************* EVENTS ********************************************************/

  /**
   * GRID EVENT SELECT ALL (NOT IN USE)
   */
  onSelectAll(evt: Event) {
    const checkbox = evt.target as HTMLInputElement;
    const visibleRowCount = this.getVisibleRowCount();
    const selectedVisibleCount = this.getVisibleSelectedCount();

    if (visibleRowCount === 0) {
      checkbox.checked = false;
      checkbox.indeterminate = false;
      return;
    }

    // If the checkbox is indeterminate, deselect all items
    if (selectedVisibleCount > 0 && selectedVisibleCount < visibleRowCount) {
      // let _i: number = this.mapSelected.findIndex(x => x.inEdit == true);
      // if (_i != -1 && this.valueChanged) {
      //   checkbox.indeterminate = true;
      //   this.showModalDiscardApply = true;
      //   this.discardParameter = 5;
      //   //this.teiasoftModalService.show("confirm", "EnquiryBook", this.translate.instant('commons.confirmPendingChanges'), 5, 'confirmApplyEditInPlace');
      // } else {
      //   this.mapSelected = new Array();
      //   checkbox.checked = false;
      // }
      checkbox.checked = false;
      this.closeEdit();
      return;
    }

    if (!this.mapSelected) this.mapSelected = new Array();

    if (selectedVisibleCount == visibleRowCount) {
      this.logOperations = new Array();
      this.closeEdit();
    } else {
      this.mapSelected = [];
      for (var x = 0; x < this.filteredRowIndices.length; x++) {
        let _item: MapSelected = new MapSelected();
        _item.row = this.filteredRowIndices[x];
        _item.col = null;
        this.mapSelected.push(_item);
      }
      this.removeLog(999);
    }

    if (this.mapSelected.length > 0) {
      this.mapSelected = this.mapSelected.sort(
        function (a, b) {
          return a.row! - b.row!;
        }
      );
    }
    this.itemsToDelete.emit(this.itemsNoToDelete);
    this.checkDataOnSelection();
    this.syncSelectionButtonsState();
  }

  /**
   * ON SELECTED GRID ROW FROM  CHECKBOX
   * @param rowNum 
   */
  onSelectRow(event: MouseEvent, rowNum: number) {

    if (!this.mapSelected) this.mapSelected = new Array();

    // Check if Shift key is pressed
    if (event.shiftKey && this.lastSelectedIndex !== null) {
      const start = Math.min(this.lastSelectedIndex, rowNum);
      const end = Math.max(this.lastSelectedIndex, rowNum);

      // Track if we're selecting or deselecting
      const isSelecting = !this.mapSelected.some(x => x.row === rowNum); // Check the newly clicked row

      for (let i = start; i <= end; i++) {
        if (!this.filteredRowIndices.includes(i)) continue; // skip rows hidden by active filters

        let index = this.mapSelected.findIndex(x => x.row === i);

        if (index !== -1) {
          // If already selected and we're in deselect mode, remove it
          if (!isSelecting) {
            this.mapSelected.splice(index, 1);
          }
        } else {
          // If not selected, add it
          let _item: MapSelected = new MapSelected();
          _item.row = i;
          _item.col = null;
          _item.inEdit = false;
          this.mapSelected.push(_item);
        }
      }
    } else {
      // Normal row selection toggle logic
      let _i: number = this.mapSelected.findIndex(x => x.row == rowNum);
      if (_i != -1) {
        this.mapSelected = this.mapSelected.filter(x => x.row != rowNum);
      } else {
        _i = this.mapSelected.findIndex(x => x.inEdit == true);
        let _item: MapSelected = new MapSelected();
        _item.row = rowNum;
        _item.col = _i == -1 ? null : this.mapSelected[_i].col;
        _item.inEdit = false;
        this.mapSelected.push(_item);
      }
    }

    this.lastSelectedIndex = rowNum;

    // Sort the selected rows
    if (this.mapSelected.length > 0) {
      this.mapSelected = this.mapSelected.sort((a, b) => a.row! - b.row!);
    }

    this.checkDataOnSelection();

    if (!this.isValidRowSelection(rowNum)) {
      this.teiasoftToaster.show("info", this.translate.instant("errors.selectionNotCompatible"));
      // remove selection
      const checkbox = event.target as HTMLInputElement;
      this.mapSelected = this.mapSelected.filter(slc => slc.row != rowNum);
      checkbox.checked = false;
      // MQF-363 - Faccio ripartire una checkdata on selection
      this.checkDataOnSelection();
      // END MQF-363
      return;
    }


    if (this.mapSelected.length == 0) { // Non ho più nulla selezionato
      this.logOperations = new Array();
      this.closeEdit();
    } else if (this.mapSelected.length == 1) { // Seleziono un solo item
      // Abilito tutti i bottoni
      // MQF-361 - Se seleziono una riga devo verificare che questa non sia in errore per abilitare il duplicate
      //this.buttonsList[0].disabled = false;
      this.buttonsList[0].disabled = !(this.cellsInError.findIndex(x => x.row == rowNum) == -1 && this.cellsXlxsInError.findIndex(x => x.row == rowNum) == -1);
      // END MQF-361
      this.buttonsList[1].disabled = false;
      this.closeEditLight();
    } else if (this.mapSelected.length > 1) { // Seleziono più di un item
      // Abilito solo il bottone di delete
      this.buttonsList[0].disabled = true;
      // Disable the deletion if the selected rows is a mix of delete and edit
      this.buttonsList[1].disabled = this.isSelectionEditAndDeleteMix();
      this.closeEditLight();

    }
    // If any item is duplicated disable delete and edit
    /*     if (this.logOperations.findIndex(op => op.code === this.itemNoError) !== -1) {
          this.buttonsList[0].disabled = true;
          this.buttonsList[1].disabled = true;
        } */

    let _iNo: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() === 'itemno');
    let _enableUndo: boolean = this.mapSelected.length > 0;
    // if all selected items are in delete status => show undo button
    for (let x = 0; x < this.mapSelected.length; x++) {
      if (this.itemsNoToDelete.findIndex(k => k === this.dataSheet[_iNo].colValue![this.mapSelected[x].row!]) === -1) {
        _enableUndo = false; // one selected item is not in delete status
        break;
      }
    }

    if (_enableUndo) {
      this.buttonsList[1].icon = 'fal fa-undo';
      this.buttonsList[1].disabled = false;
      this.buttonsList[1].action = 'undoDelete';
      this.buttonsList[1].tooltip = 'undoDeleteItems';
    } else {
      this.buttonsList[1].icon = 'fal fa-trash-alt';
      this.buttonsList[1].action = 'deleteItem';
      this.buttonsList[1].tooltip = "deleteItems";
    }

  }

  isSelectionEditAndDeleteMix(): boolean {
    let _i: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'itemno');
    let _isInDelete: boolean = false;
    let _isNotInDelete: boolean = false;
    for (var x = 0; x < this.mapSelected.length; x++) {
      let _itemNo: string = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
      if (this.itemsNoToDelete.findIndex(i => i == _itemNo) != -1) {
        _isInDelete = true;
      }

      if (this.itemsNoToDelete.findIndex(i => i == _itemNo) == -1) {
        _isNotInDelete = true;
      }
    }
    return _isInDelete && _isNotInDelete;
  }

  /**
   * ON KEY DOWN INPUT EVENT
   * @param evt 
   * @param row 
   * @param col 
   * @param colName 
   * @returns 
   */
  onKeyDown(evt: any, row: number, col: number, colName: string) {

    this.cleanMeXlxsError(row, colName);

    if (colName.toLowerCase() == 'gradecustomeranalysislimitation') {
      if (evt.keyCode == 13 || evt.keyCode == 9) {

        const _iRawMaterialCol = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'rawmaterialgrade');

        for (var x = 0; x < this.mapSelected.length; x++) {
          let _value: ItemLimitation = new ItemLimitation();
          _value = this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!];
          _value.limitation = evt.target.value;
          this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] = _value;
          this.setValueOnDataSet(this.mapSelected[x].row!, this.mapSelected[x].col!, _value);

          // Invalidate raw material grade
          this.dataSheet[_iRawMaterialCol].colValue![this.mapSelected[x].row!] = null;
          this.setValueOnDataSet(this.mapSelected[x].row!, _iRawMaterialCol, null);
          // MQF - 261 - Devo resettare anche l'errore della rawMaterialGrade se arrivo da XLSX
          this.cleanMeXlxsError(row, 'rawMaterialgrade');
        }
        this.closeEdit();
      }
      return;
    }
    if (colName.toLowerCase() == 'gradecustomerotherlimitation') {
      if (evt.keyCode == 13 || evt.keyCode == 9) {

        const _iRawMaterialCol = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'rawmaterialgrade');

        for (var x = 0; x < this.mapSelected.length; x++) {
          let _value: ItemLimitation = new ItemLimitation();
          _value = this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!];
          _value.limitation = evt.target.value;
          this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] = _value;
          this.setValueOnDataSet(this.mapSelected[x].row!, this.mapSelected[x].col!, _value);

          // Invalidate raw material grade
          this.dataSheet[_iRawMaterialCol].colValue![this.mapSelected[x].row!] = null;
          this.setValueOnDataSet(this.mapSelected[x].row!, _iRawMaterialCol, null);
          // MQF - 261 - Devo resettare anche l'errore della rawMaterialGrade se arrivo da XLSX
          this.cleanMeXlxsError(row, 'rawMaterialgrade');
        }
        this.closeEdit();
      }
      return;
    }

    if (colName.toLowerCase() != 'npsschedule') {

      if (this.dataSheet[col].colType === 'number') {
        // Check if the new value is a valid number
        if (!this.isValidNumberInput(evt)) {
          evt.preventDefault(); // Prevent the key press if the value is invalid
          return;
        }
      }

      if (evt.keyCode == 13 || evt.keyCode == 9) {
        // this.removeLog(this.mandatoryFields);
        for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
          if (this.mapSelected.findIndex(k => k.row == x) != -1) {
            this.dataSheet[col].colValue![x] = evt.target.value;
            /* EDIT ALSO DATASET */
            this.setValueOnDataSet(x, col, evt.target.value);
          }
        }

        this.closeEdit();
        return;
      }
    }

    if (colName.toLowerCase() == 'npsschedule') {
      if (evt.keyCode == 8 && evt.target.value != '') {
        for (var x = 0; x < this.mapSelected.length; x++) {
          this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] = null;
          let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
          this.dataSheet[_i].colValue![this.mapSelected[x].row!] = '';
          _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
          this.dataSheet[_i].colValue![this.mapSelected[x].row!] = '';
          this.closeEdit();
        }
      }
    }
  }

  isValidNumberInput(evt: any): boolean {
    const key = evt.key;
    const keyCode = evt.keyCode;

    // Allow backspace, delete, arrow keys, and other control keys
    if (
      keyCode === 8 || // Backspace
      keyCode === 46 || // Delete
      keyCode === 37 || // Left arrow
      keyCode === 39 || // Right arrow
      keyCode === 9 || // Tab
      keyCode === 13 || // Enter
      keyCode === 27 || // Escape
      (keyCode >= 35 && keyCode <= 40) // Home, End, Arrow keys
    ) {
      return true; // Allow default behavior for these keys
    }

    // Get the current value and the new value with the key pressed
    const value = evt.target.value + key;
    // Regular expression to match valid number inputs with commas or dots as decimal separators
    const numberRegex = /^-?\d*([.,]?\d*)?$/;
    return numberRegex.test(value);
  }

  // MQF-243 Se ho l'errore dentro la CellsXlxsInError lo levo
  cleanMeXlxsError(row: number, colName: string) {
    const candidates = this.getXlsxErrorColCandidates(colName);
    if (candidates.length === 0) {
      return;
    }

    this.cellsXlxsInError = this.cellsXlxsInError.filter(x => !(x.row == row && candidates.includes(this.normalizeXlsxErrorColName(x.colName))));
  }

  onFocusOut(evt: any, row: number, col: number, colName: string) {
    if (!this.valueChanged) {
      return;
    }

    this.cleanMeXlxsError(row, colName);


    if (colName.toLowerCase() == 'gradecustomeranalysislimitation') {
      const _iRawMaterialCol = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'rawmaterialgrade');
      for (var x = 0; x < this.mapSelected.length; x++) {
        let _value: ItemLimitation = new ItemLimitation();
        _value = this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!];
        _value.limitation = evt;
        this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] = _value;
        this.setValueOnDataSet(this.mapSelected[x].row!, this.mapSelected[x].col!, _value);

        // Invalidate raw material grade
        this.dataSheet[_iRawMaterialCol].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iRawMaterialCol, null);
        // MQF - 261 - Devo resettare anche l'errore della rawMaterialGrade se arrivo da XLSX
        this.cleanMeXlxsError(row, 'rawMaterialgrade');
      }
      this.closeEditLight();
      return;
    }
    if (colName.toLowerCase() == 'gradecustomerotherlimitation') {
      const _iRawMaterialCol = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'rawmaterialgrade');
      for (var x = 0; x < this.mapSelected.length; x++) {
        let _value: ItemLimitation = new ItemLimitation();
        _value = this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!];
        _value.limitation = evt;
        this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] = _value;
        this.setValueOnDataSet(this.mapSelected[x].row!, this.mapSelected[x].col!, _value);

        // Invalidate raw material grade
        this.dataSheet[_iRawMaterialCol].colValue![this.mapSelected[x].row!] = null;
        this.setValueOnDataSet(this.mapSelected[x].row!, _iRawMaterialCol, null);
        // MQF - 261 - Devo resettare anche l'errore della rawMaterialGrade se arrivo da XLSX
        this.cleanMeXlxsError(row, 'rawMaterialgrade');
      }
      this.closeEditLight();
      return;
    }

    if (colName.toLowerCase() == 'od' || colName.toLowerCase() == 'id' || colName.toLowerCase() == 'wt') {
      for (let x = 0; x < this.dataSheet[col].colValue!.length; x++) {
        const selectedMapIndex = this.mapSelected.findIndex(k => k.row == x);
        if (selectedMapIndex != -1) {

          this.invalidateMaterialCode(selectedMapIndex, x); // clean material code

          this.dataSheet[col].colValue![x] = evt;
          this.setValueOnDataSet(x, col, evt);

          // Determine tolerance columns based on colName
          const tolerancePlusCol = this.dataSheet.findIndex(
            item => item.colName?.toLowerCase() == `${colName.toLowerCase()}toleranceplus`
          );
          const toleranceMinusCol = this.dataSheet.findIndex(
            item => item.colName?.toLowerCase() == `${colName.toLowerCase()}toleranceminus`
          );

          // If the value is null, clear the corresponding tolerance values
          if (!evt) {
            if (tolerancePlusCol !== -1) {
              this.dataSheet[tolerancePlusCol].colValue![x] = evt;
              this.setValueOnDataSet(x, tolerancePlusCol, evt);
            }
            if (toleranceMinusCol !== -1) {
              this.dataSheet[toleranceMinusCol].colValue![x] = evt;
              this.setValueOnDataSet(x, toleranceMinusCol, evt);
            }

            // for wt should be cleaned also tubeexecution and typeoftolerance
            if (colName.toLowerCase() == 'wt') {
              const tubexecutionCol = this.dataSheet.findIndex(
                item => item.colName?.toLowerCase() == 'tubeexecution'
              );
              const typeoftoleranceCol = this.dataSheet.findIndex(
                item => item.colName?.toLowerCase() == 'typeoftolerance'
              );


              if (tubexecutionCol !== -1) {
                this.dataSheet[tubexecutionCol].colValue![x] = evt;
                this.setValueOnDataSet(x, tubexecutionCol, evt);
              }
              if (typeoftoleranceCol !== -1) {
                this.dataSheet[typeoftoleranceCol].colValue![x] = evt;
                this.setValueOnDataSet(x, typeoftoleranceCol, evt);
              }
            }
          }
          else {
            // while setting wt, set default toltype if needed
            if (colName.toLowerCase() == 'wt') {
              const tubexecutionCol = this.dataSheet.findIndex(item => item.colName?.toLowerCase() == 'tubeexecution');
              const typeoftoleranceCol = this.dataSheet.findIndex(item => item.colName?.toLowerCase() == 'typeoftolerance');

              const actualTypeOfTolerance = this.dataSheet[typeoftoleranceCol].colValue![x];

              if (!actualTypeOfTolerance) {
                const defaultTolType = this.typeOfToleranceOptionList.find(tot => tot.isDefault)?.value;
                this.onSelected(defaultTolType, x, typeoftoleranceCol, 'select', 'typeoftolerance');
                // this.setValueOnDataSheetAndDataSet(typeoftoleranceCol, this.mapSelected.findIndex(s => s.row == x), defaultTolType);

              }
            }

          }

          if (colName.toLowerCase() == 'od') {
            const selectedMill = this.resolveDefaultMillForSelectedRow(selectedMapIndex);
            this.setValueOnDataSheetAndDataSetByColumnName('mill', selectedMapIndex, selectedMill || null);
            this.applyDefaultSurfaceTypeForSelectedRow(selectedMapIndex);
            this.applyCtsHydroTestDefaultRule(selectedMapIndex);
          }

        }
      }
      this.closeEditLight();
      return;
    }
    if (colName.toLowerCase() != 'npsschedule') {
      // if (this.mapSelected.length > 1) return; // MQF-252 / Se ho pi\ di una riga selezionata al focusout non faccio niente
      if (colName.toLowerCase() == 'customeritemno') {
        evt = this.utils.normalizeCustomerItemNo(evt);
      }
      for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
        if (this.mapSelected.findIndex(k => k.row == x) != -1) {

          this.dataSheet[col].colValue![x] = evt;
          /* EDIT ALSO DATASET */
          this.setValueOnDataSet(x, col, evt);

          if (colName.toLowerCase() == 'lengthmin' || colName.toLowerCase() == 'lengthmax' || colName.toLowerCase() == 'lengthnominal') {
            this.invalidateMaterialCode(this.mapSelected.findIndex(s => s.row == x), x);
          }
        }
      }
      this.closeEditLight();
      return;
    }
    if (colName.toLowerCase() == 'npsschedule') {
      for (var x = 0; x < this.mapSelected.length; x++) {
        this.dataSheet[this.mapSelected[x].col!].colValue![this.mapSelected[x].row!] = null;
        let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
        this.dataSheet[_i].colValue![this.mapSelected[x].row!] = '';
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
        this.dataSheet[_i].colValue![this.mapSelected[x].row!] = '';
        this.closeEdit();
        this.invalidateMaterialCode(x);
      }
    }
  }

  /**
   * MOUSE DOWN EVENT FOR NPS
   * @param evt 
   * @param col 
   * @param colName 
   */
  onMouseDown(evt: any, col: number, colName: string) {
    //if (evt.target.value == ''){
    // this.getNpsAndSchedules();
    //}
  }

  /**
   * SELECT EVENT
   * @param evt 
   * @param col 
   * @param colType 
   * @param colName 
   */
  onSelected(_value: any, row: number, col: number, colType: string, colName: string) {

    if (!this.valueChanged) {
      return; // no changes made
    }

    colName = colName.toLowerCase(); // normalize
    // if (evt.target.selectedOptions[0].text == '') {
    //   return;
    // }
    if (_value == 'null') _value = null; // the value emitted by the confirmable input is always a string so we need to handle null this way

    // let _value: any = evt.target.selectedOptions[0].value;
    for (var x = 0; x < this.mapSelected.length; x++) {
      //if (this.mapSelected.findIndex(k => k.row == x) != -1){
      if (colType == 'boolean') {
        this.dataSheet[col].colValue![this.mapSelected[x].row!] = (_value === true || _value === 'true') ? true : (_value === false || _value === 'false') ? false : null;
        if (colName == 'cts') {
          if (this.dataSheet[col].colValue![this.mapSelected[x].row!] === true)  // if cts is true
            this.onCtsSelect(x);
          this.applyCtsHydroTestDefaultRule(x);
        }
      }
      if (colType == 'select') {
        if (colName == 'sms') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = this.itemParameterValues.sms?.find(p => p.smsId == parseInt(_value)) ?? null;
          _value = parseInt(_value); // MQF-142
          this.checkMillRule();
          this.checkSmsHollowBarsRule(x, this.dataSheet[col].colValue![this.mapSelected[x].row!]);
          this.applyCtsHydroTestDefaultRule(x);
          this.setDefaultQuantityUom(x);
          this.setUbent(x, this.dataSheet[col].colValue![this.mapSelected[x].row!]);
        } else if (colName == 'marketfamily') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = this.itemParameterValues.marketFamily?.find(p => p.marketFamilyId == parseInt(_value)) ?? null;
        } else if (colName == 'endscondition') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = this.itemParameterValues.endsCondition?.find(p => p.value == _value)?.value ?? null;
        } else if (colName == 'surfacetype') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = this.itemParameterValues.surfaceTypes?.find(p => p.surfaceTypeId == _value) ?? null;
        } else if (colName == 'sql') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = this.itemParameterValues.sqls?.find(p => p.sqlId == parseInt(_value)) ?? null;
          this.handleSqlSelectionChange(x);
        } else if (colName == 'offerscheme') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = this.itemParameterValues.offerSchemes?.find(p => p.offerSchemeCode == _value) ?? null;
        } else if (colName == 'gradecustomeranalysislimitation') {
          let _isNotCustom: boolean = this.analysisLimitationOptionList.some(x => x.value == _value);
          this.dataSheet[col].colValue![this.mapSelected[x].row!]["limitation"] = _value;
          this.dataSheet[col].colValue![this.mapSelected[x].row!]["isCustom"] = !_isNotCustom;
          let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'normgrades');
          let _ids: number[] = new Array();
          for (var t = 0; t < this.dataSheet[_i].colValue![this.mapSelected[x].row!].length; t++) {
            _ids.push(this.dataSheet[_i].colValue![this.mapSelected[x].row!][t]["normGradeId"])
          }
          _i = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'gradecustomerotherlimitation');
          //this.getRawMaterialGradesFromNormGradesAndLimitations('', _ids, _value, this.dataSheet[_i].colValue![this.mapSelected[x].row!]);
          this.getRawMaterialGradesFromNormGradesAndLimitationsForAll(_ids, _value, this.dataSheet[_i].colValue![this.mapSelected[x].row!], this.mapSelected[x].row!);
        } else if (colName == 'gradecustomerotherlimitation') {
          let _isNotCustom: boolean = this.otherLimitationOptionList.some(x => x.value == _value);
          this.dataSheet[col].colValue![this.mapSelected[x].row!]["limitation"] = _value;
          this.dataSheet[col].colValue![this.mapSelected[x].row!]["isCustom"] = !_isNotCustom;
          let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'normgrades');
          let _ids: number[] = new Array();
          for (var t = 0; t < this.dataSheet[_i].colValue![this.mapSelected[x].row!].length; t++) {
            _ids.push(this.dataSheet[_i].colValue![this.mapSelected[x].row!][t]["normGradeId"])
          }
          _i = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
          this.getRawMaterialGradesFromNormGradesAndLimitationsForAll(_ids, this.dataSheet[_i].colValue![this.mapSelected[x].row!], _value, this.mapSelected[x].row!);
          //this.getRawMaterialGradesFromNormGradesAndLimitations('', _ids, this.dataSheet[_i].colValue![this.mapSelected[x].row!], _value);
        } else if (colName == 'typeoftolerance') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = _value;

          let _i = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'tubeexecution');
          const currentTubeExecution = this.dataSheet[_i].colValue![this.mapSelected[x].row!];
          if (currentTubeExecution) {
            let _obj: TubeExecution = new TubeExecution();
            _obj = this.itemParameterValues.tubeExecution!.filter(t => t.tubeExecutionId == currentTubeExecution['tubeExecutionId'])[0];
            this.updateTolerancePlusMinus(_value, _obj, x);
          }

          this.handleTypeOfToleranceSelectionChange(x);

        } else if (colName == 'tubeexecution') {
          if (_value == null || _value === '') {
            this.dataSheet[col].colValue![this.mapSelected[x].row!] = null;
            let _iTolMinus: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wttoleranceminus');
            let _iTolPlus: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wttoleranceplus');
            let _iTolUom: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wttoleranceuom');
            this.setValueOnDataSheetAndDataSet(_iTolMinus, x, null);
            this.setValueOnDataSheetAndDataSet(_iTolPlus, x, null);
            this.setValueOnDataSheetAndDataSet(_iTolUom, x, null);
          } else {
            let _obj: TubeExecution = new TubeExecution();
            _obj = this.itemParameterValues.tubeExecution!.filter(t => t.tubeExecutionId == parseInt(_value))[0];
            this.dataSheet[col].colValue![this.mapSelected[x].row!] = _obj;

            let _i: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'typeoftolerance');
            let _typeOfTolerance: string = this.dataSheet[_i].colValue![this.mapSelected[x].row!]
            this.updateTolerancePlusMinus(_typeOfTolerance, _obj, x);
          }
        } else if (colName == 'unitsystem') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = _value;
          this.changeAllUoms(_value);
          this.updateNpsOdWt(row, col, _value);
          //this.setRoundDigits();
          /*  // Change all Uoms
           let _i: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'oduom');
           this.dataSheet[_i].colValue![this.mapSelected[x].row!] = _value == 'Metric' ? this.itemParameterValues.odUoms!.metricUoms?.filter(u => u.isDefault == true)[0].uomCode : this.itemParameterValues.odUoms!.imperialUoms?.filter(u => u.isDefault == true)[0].uomCode ;
           _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'iduom');
           this.dataSheet[_i].colValue![this.mapSelected[x].row!] = _value == 'Metric' ? this.itemParameterValues.idUoms!.metricUoms?.filter(u => u.isDefault == true)[0].uomCode : this.itemParameterValues.idUoms!.imperialUoms?.filter(u => u.isDefault == true)[0].uomCode ;
           _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wtuom');
           this.dataSheet[_i].colValue![this.mapSelected[x].row!] = _value == 'Metric' ? this.itemParameterValues.wtUoms!.metricUoms?.filter(u => u.isDefault == true)[0].uomCode : this.itemParameterValues.wtUoms!.imperialUoms?.filter(u => u.isDefault == true)[0].uomCode ;
           _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'lengthuom');
           this.dataSheet[_i].colValue![this.mapSelected[x].row!] = _value == 'Metric' ? this.itemParameterValues.lengthUoms!.metricUoms?.filter(u => u.isDefault == true)[0].uomCode : this.itemParameterValues.lengthUoms!.imperialUoms?.filter(u => u.isDefault == true)[0].uomCode ;
           _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'totalweightuom');
           this.dataSheet[_i].colValue![this.mapSelected[x].row!] = _value == 'Metric' ? this.itemParameterValues.totalWeightUoms!.metricUoms?.filter(u => u.isDefault == true)[0].uomCode : this.itemParameterValues.totalWeightUoms!.imperialUoms?.filter(u => u.isDefault == true)[0].uomCode ; */
        } else if (colName == 'lengthtype') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = _value;
          if (_value == 'RL') {
            // when switch to RL, set multiple length to false and null the length nominal value
            let _i: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'multiplelength');
            let _j: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'lengthnominal');

            this.dataSheet[_i].colValue![this.mapSelected[x].row!] = false;
            this.dataSheet[_j].colValue![this.mapSelected[x].row!] = null;
          }
          if (_value == 'FL') {
            // when switch to FL, set multiple length to false and null the min and max value
            let _i: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'multiplelength');
            let _j: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'lengthmin');
            let _k: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'lengthmax');

            this.dataSheet[_i].colValue![this.mapSelected[x].row!] = false;
            this.dataSheet[_j].colValue![this.mapSelected[x].row!] = null;
            this.dataSheet[_k].colValue![this.mapSelected[x].row!] = null;
          }
          this.setDefaultQuantityUom(x);
        } else if (colName == 'multiplelength') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = _value;
          if (!_value) {
            let _j: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'lengthmin');
            let _k: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'lengthmax');
            this.dataSheet[_j].colValue![this.mapSelected[x].row!] = null;
            this.dataSheet[_k].colValue![this.mapSelected[x].row!] = null;
          }
        }

        else if (colName == 'marketingroute') {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = _value;
          let _j: number = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'sms');
          let currentSmsId = this.dataSheet[_j].colValue![this.mapSelected[x].row!]?.smsId;
          let currentSmsDesc = this.itemParameterValues.sms?.find(s => s.smsId === currentSmsId)?.description;
          this.smsOptionList = this.getSmsOptionList(_value);
          // check if the current sms is valid for the new marketing route and update it

          if (this.itemParameterValues.sms!.filter(x => x.marketingRoute === _value).map(s => s.description).includes(currentSmsDesc)) {
            let newSms = this.itemParameterValues.sms!.find(sms => sms.description === currentSmsDesc && sms.marketingRoute === _value);
            if (newSms) this.setValueOnDataSheetAndDataSet(_j, x, newSms);
          }
          else {
            this.setValueOnDataSheetAndDataSet(_j, x, null);
          }

          this.alignTubeExecutionWithMarketingRoute(x, _value);

          this.surfaceTypeOptionList = this.getSurfaceTypeOptionList(_value);
          const selectedMill = this.resolveDefaultMillForSelectedRow(x);
          this.setValueOnDataSheetAndDataSetByColumnName('mill', x, selectedMill || null);
          this.applyDefaultSurfaceTypeForSelectedRow(x);

          this.setDefaultHtValue(_value, x);
          this.applyCtsHydroTestDefaultRule(x);

        }
        else {
          this.dataSheet[col].colValue![this.mapSelected[x].row!] = _value;
        }

        // when changing these columns value, material code gets invalidated
        if (colName == 'mill') {
          const millValue = this.dataSheet[col].colValue![this.mapSelected[x].row!] as Mill | null | undefined;
          this.applyDefaultSurfaceTypeForSelectedRow(x);
          this.handleMillSelectionChange(x, millValue ?? null);
          this.applyCtsHydroTestDefaultRule(x);
        } else if (colName == 'marketingroute' || colName == 'ut' || colName == 'ht' || colName == 'htadditional' || colName == 'ubent' || colName == 'hydrotest' || colName == 'multiplelength' || colName == 'lengthtype' || colName == 'endscondition' || colName == 'testcondition' || colName.includes('limitation')) {
          this.invalidateMaterialCode(x);
        }


      }
      this.setValueOnDataSet(this.mapSelected[x].row!, col, this.dataSheet[col].colValue![this.mapSelected[x].row!]);

      // MQF-243 Se ho l'errore dentro la CellsXlxsInError lo levo
      this.cleanMeXlxsError(row, colName);

    }

    this.checkDataOnSelection();
    //if (!this.imCallingApi) this.closeEditLight();

    // skip clos editlight for limitations cause they should handle click on custom checkbox
    if (colName.toLowerCase() != 'gradecustomeranalysislimitation' && colName.toLowerCase() != 'gradecustomerotherlimitation')
      this.closeEditLight();

    // Devo cambiare anche tutte le uom a cascata
    /* if (colName.toLowerCase() == 'unitsystem'){
      this.changeAllUoms(_value);
    } */
  }

  setDefaultHtValue(marketingRoute: string, selectedRowIndex: number) {

    const htColumnIdx = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'ht');
    if (marketingRoute == 'Cold') {
      this.setValueOnDataSheetAndDataSet(htColumnIdx, selectedRowIndex, true);
    }
    else {
      this.setValueOnDataSheetAndDataSet(htColumnIdx, selectedRowIndex, false);
    }

  }

  private updateTolerancePlusMinus(_typeOfTolerance: string, _obj: TubeExecution, x: number) {
    if (!_obj)
      return;
    let _i: number;
    _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wttoleranceplus');
    let tolPlus = _typeOfTolerance == 'AW' ? _obj.tolerancePlusAw : _obj.tolerancePlusMw;
    this.dataSheet[_i].colValue![this.mapSelected[x].row!] = tolPlus;
    this.setValueOnDataSet(this.mapSelected[x].row!, _i, tolPlus);
    _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wttoleranceminus');
    let tolMinus = _typeOfTolerance == 'AW' ? _obj.toleranceMinusAw : _obj.toleranceMinusMw;
    this.dataSheet[_i].colValue![this.mapSelected[x].row!] = tolMinus;
    this.setValueOnDataSet(this.mapSelected[x].row!, _i, tolMinus);

    // IF TUBE EXECUTION IS NOT CUSTOM, THE TOLERANCE UOM IS PERCENTAGE
    _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'tubeexecution');
    const te = this.dataSheet[_i].colValue![this.mapSelected[x].row!] as TubeExecution;
    if (te && !te.isCustom) {
      _i = this.dataSheet.findIndex(d => d.colName!.toLowerCase() == 'wttoleranceuom');
      this.dataSheet[_i].colValue![this.mapSelected[x].row!] = '%';
      this.setValueOnDataSet(this.mapSelected[x].row!, _i, '%');
    }
  }

  private alignTubeExecutionWithMarketingRoute(selectedRowIndex: number, marketingRoute?: string | null, typeOfTolerance?: string | null): TubeExecution | null {
    const tubeExecutionColumnIndex = this.dataSheet.findIndex(d => d.colName?.toLowerCase() == 'tubeexecution');
    if (tubeExecutionColumnIndex == -1) {
      return null;
    }

    const rowIndex = this.mapSelected[selectedRowIndex].row!;
    const currentTubeExecution = this.dataSheet[tubeExecutionColumnIndex].colValue?.[rowIndex] as TubeExecution | null;
    const alignedTubeExecution = this.resolveTubeExecutionForMarketingRoute(currentTubeExecution, marketingRoute);

    this.setValueOnDataSheetAndDataSet(tubeExecutionColumnIndex, selectedRowIndex, alignedTubeExecution);

    if (alignedTubeExecution) {
      const resolvedTypeOfTolerance = typeOfTolerance ?? this.getTypeOfToleranceForSelectedRow(selectedRowIndex);
      if (resolvedTypeOfTolerance) {
        this.updateTolerancePlusMinus(resolvedTypeOfTolerance, alignedTubeExecution, selectedRowIndex);
      }
    } else if (currentTubeExecution) {
      this.clearWtToleranceForSelectedRow(selectedRowIndex);
    }

    return alignedTubeExecution;
  }

  private resolveTubeExecutionForMarketingRoute(currentTubeExecution?: TubeExecution | null, marketingRoute?: string | null): TubeExecution | null {
    if (!currentTubeExecution) {
      return null;
    }

    const tubeExecutions = this.itemParameterValues.tubeExecution ?? [];
    const currentFromParameters = currentTubeExecution.tubeExecutionId != null
      ? tubeExecutions.find(t => t.tubeExecutionId === currentTubeExecution.tubeExecutionId)
      : undefined;
    const current = currentFromParameters ?? currentTubeExecution;

    if (current.isCustom) {
      return current;
    }

    if (!marketingRoute) {
      return null;
    }

    const availableForRoute = tubeExecutions.filter(t => t.marketingRoute === marketingRoute || t.isCustom);
    const currentIdMatch = current.tubeExecutionId != null
      ? availableForRoute.find(t => t.tubeExecutionId === current.tubeExecutionId)
      : undefined;

    if (currentIdMatch) {
      return currentIdMatch;
    }

    const currentDescription = this.normalizeTubeExecutionMatchValue(current.description);
    const currentName = this.normalizeTubeExecutionMatchValue(current.name);

    return availableForRoute.find(t => !t.isCustom
      && ((currentDescription && this.normalizeTubeExecutionMatchValue(t.description) === currentDescription)
        || (currentName && this.normalizeTubeExecutionMatchValue(t.name) === currentName))) ?? null;
  }

  private normalizeTubeExecutionMatchValue(value?: string | null): string {
    return (value ?? '').toString().trim().toLowerCase();
  }

  private getTypeOfToleranceForSelectedRow(selectedRowIndex: number): string | null {
    const typeOfToleranceColumnIndex = this.dataSheet.findIndex(d => d.colName?.toLowerCase() == 'typeoftolerance');
    if (typeOfToleranceColumnIndex == -1) {
      return null;
    }

    return this.dataSheet[typeOfToleranceColumnIndex].colValue?.[this.mapSelected[selectedRowIndex].row!] ?? null;
  }

  private clearWtToleranceForSelectedRow(selectedRowIndex: number): void {
    this.setValueOnDataSheetAndDataSetByColumnName('wttoleranceminus', selectedRowIndex, null);
    this.setValueOnDataSheetAndDataSetByColumnName('wttoleranceplus', selectedRowIndex, null);
    this.setValueOnDataSheetAndDataSetByColumnName('wttoleranceuom', selectedRowIndex, null);
  }

  getColumnHeaderName(colName?: string) {
    const uomColumnsMapping: any = {
      Od: "odUom",
      Id: "idUom",
      Wt: "wtUom",
      LengthNominal: "lengthUom",
      LengthMin: "lengthUom",
      LengthMax: "lengthUom"
    };

    if (colName && uomColumnsMapping[colName]) {
      const uomColumn = uomColumnsMapping[colName];
      const baseLabel = this.translate.instant('grid.' + colName);
      const uomValue = this.getHeaderUomValue(uomColumn);

      return uomValue ? `${baseLabel} (${uomValue})` : baseLabel;

    }

    return this.translate.instant('grid.' + colName);
  }

  private getHeaderUomValue(uomColumn: string): string {
    const primaryUom = this.findFirstPopulatedUom([uomColumn]);
    if (primaryUom) return primaryUom;

    const dimensionUomColumns = ['odUom', 'idUom', 'wtUom'];
    if (dimensionUomColumns.includes(uomColumn)) {
      return this.findFirstPopulatedUom(dimensionUomColumns) || "";
    }

    return "";
  }

  private findFirstPopulatedUom(uomColumns: string[]): string {
    for (const item of this.dataSet || []) {
      for (const col of uomColumns) {
        const value = item?.[col];
        if (value != null && value.toString().trim() != '') {
          return value.toString().trim();
        }
      }
    }

    return "";
  }
  /**
   * WTODIS/NPS TOOLBAR CLICK
   * @param evt 
   */
  onBtnToolbarClick(evt: TTButton) {
    let _action: string = "";
    if (evt["action"]) _action = evt["action"];

    if (_action.endsWith("nps")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      this.getNpsAndSchedules();
    }

    if (_action.endsWith("wtOdIt")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      this.closeEdit();
    }
  }

  /**
   * ON CHANGE OPTION DATE
   * @param evt 
   * @param row 
   * @param col 
   * @param colName 
   */
  onChangeOptionDate(evt: any, row: number, col: number, colName: string) {
    if (!this.valueChanged) {
      this.originalValue = this.dataSheet[col].colValue![row];
    }
    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);

    const normalizedValue = evt === undefined || evt === null || evt === '' ? null : Number(evt);
    this.dataSheet[col].colValue![row] = normalizedValue === null || Number.isNaN(normalizedValue) ? null : normalizedValue;
    this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
  }

  /**
   * ON CHANGE CUSTOM DELIVERY DATE
   * @param evt 
   * @param row 
   * @param col 
   * @param colName 
   */
  onChangeCustomDeliveryDate(evt: any, row: number, col: number, colName: string) {
    if (!this.valueChanged) {
      this.originalValue = this.dataSheet[col].colValue![row];
    }
    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);

    const normalizedValue = evt === undefined || evt === null || evt === '' ? null : Number(evt);
    this.dataSheet[col].colValue![row] = normalizedValue === null || Number.isNaN(normalizedValue) ? null : normalizedValue;
    this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
  }

  clearDateValue(evt: Event, row: number, col: number, colName: string) {
    evt.preventDefault();
    evt.stopPropagation();
    this.onChangeCustomDeliveryDate('', row, col, colName);
  }

  /**
   * AUTOCOMPLETE INPUT CHANGE EVENT NORM GRADES / RAW MATERIAL GRADES
   * @param evt 
   */
  onAutocompleteInputChange(evt: Autocomplete, row: number, col: number) {
    if (evt.field == 'normGrades') {
      const materialCodeIndex = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'material');
      const hasMaterial = this.dataSheet[materialCodeIndex].colValue![row] != null;
      this.getNormGrades(evt.object!, hasMaterial);
    }

    if (evt.field == 'rawMaterialGrades') {
      let _i: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'normgrades');
      let _values: NormGrade[] = this.dataSheet[_i].colValue![row];
      let _ids: number[] = _values.map(x => x.normGradeId!);
      _i = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
      let _analysisValue: ItemLimitation = this.dataSheet[_i].colValue![row];
      _i = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomerotherlimitation');
      let _otherValue: ItemLimitation = this.dataSheet[_i].colValue![row];
      this.getRawMaterialGradesFromNormGradesAndLimitations('', _ids, _analysisValue, _otherValue);
    }

    if (evt.field == 'materialCode') {
      const selectedMaterialCode = evt.object || '';
      this.materialDataset = this.getMaterialsDataset(selectedMaterialCode);
    }

    /*     // GBR 23/01/2024 - RULE FOR WT/ID/OD
        if (evt.field == 'id' || evt.field == 'od' || evt.field == 'wt'){
          this.checkWtOdId(false);
        } */
  }

  /**
   * AUTOCOMPLETE SELECT ROWS NORM GRADES
   * @param evt 
   */
  onAutocompleteSelectRows(evt: Autocomplete, row: number, col: number) {
    // this.getNormGrades(''); MP: REMOVED i think it's not really necessary to get all norms on every row selection

    if (!this.valueChanged) {
      this.originalValue = this.dataSheet[col].colValue![row]; // Save original value on the first change
    }
    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);
    this.dataSheet[col].colValue![row] = JSON.parse(evt.object!);
    this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
    // for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
    //   if (this.mapSelected.findIndex(k => k.row == x) != -1) {
    //     this.dataSheet[col].colValue![x] = JSON.parse(evt.object!);
    //     /* EDIT ALSO DATASET */
    //     this.setValueOnDataSet(x, col, this.dataSheet[col].colValue![x]);
    //   }
    // }

    return;
    //if (evt.field == 'normGrades') {
    let _data: any[] = JSON.parse(evt.object!);
    let _ids: number[] = new Array();
    let _codes: string[] = new Array();
    for (var x = 0; x < _data.length; x++) {
      _ids.push(_data[x]["normGradeId"]);
      _codes.push(_data[x]["normGradeCode"]);
    }
    // Se ho selezionato qualcosa abilito le RawMaterialGrade
    if (_ids.length > 0) {

      this.getLimitationsForNormGrades(_ids, false); //, true);

      //this.getRawMaterialGrades('', _ids); // Commentato per Limitation
      // let _i: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
      // let _analysisValue: ItemLimitation = this.dataSheet[_i].colValue![row];
      // _i = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomerotherlimitation');
      // let _otherValue: ItemLimitation = this.dataSheet[_i].colValue![row];
      // this.getRawMaterialGradesFromNormGradesAndLimitations('', _ids, _analysisValue,_otherValue);
    }
    this.checkDataOnSelection(); // MQF-264
    //}
  }

  /**
   * AUTOCOMPLETE REMOVE ROWS NORM GRADES
   * @param evt 
   */
  onAutocompleteRemoveElement(evt: Autocomplete, row: number, col: number) {
    if (!this.valueChanged) {
      this.originalValue = this.dataSheet[col].colValue![row]; // Save original value on the first change
    }
    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);

    if (evt.field == 'materialCode') {
      this.dataSheet[col].colValue![row] = null;
      this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);

      const selectedMapIndex = this.mapSelected.findIndex(ms => ms.row == row);
      this.invalidateMaterialCode(selectedMapIndex, row);
      this.materialDataset = this.materials.slice(0, 100);

      if (this.dataSheet[col].isRequired) {
        this.setCellAsError(row, col, this.mandatoryFieldsError);
        this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
      } else {
        this.removeCellError(row, col, this.mandatoryFieldsError);
      }
      return;
    }

    if (evt.field == 'normGrades') {
      let _values: any[] = this.dataSheet[col].colValue![row];
      _values = this.dataSheet[col].colValue![row].filter((x: { [x: string]: string; }) => x["normGradeCode"] != evt.object!);
      // Check se il campo resta vuoto ed è mandatorio
      if ((!_values || _values.length == 0) && this.dataSheet[col].isRequired) {
        this.writeLog("error", this.translate.instant("errors.fieldMandatory"), this.mandatoryFieldsError);
      }

      this.dataSheet[col].colValue![row] = _values;
      /* EDIT ALSO DATASET */
      this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);

      // for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
      //   if (this.mapSelected.findIndex(k => k.row == x) != -1) {
      //     this.dataSheet[col].colValue![x] = _values;
      //     /* EDIT ALSO DATASET */
      //     this.setValueOnDataSet(x, col, this.dataSheet[col].colValue![x]);
      //   }
      // }

      // let _ids: number[] = new Array();
      // let _codes: string[] = new Array();
      // for (var x = 0; x < _values.length; x++) {
      //   _ids.push(_values[x]["normGradeId"]);
      //   _codes.push(_values[x]["normGradeCode"]);
      // }
      // this.getLimitationsForNormGrades(_ids, false);
      // Se ho selezionato qualcosa abilito le RawMaterialGrade
      /* if (_ids.length > 0) {
        let _i: number = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomeranalysislimitation');
        let _analysisValue: ItemLimitation = this.dataSheet[_i].colValue![0];
        _i = this.dataSheet!.findIndex(x => x.colName!.toLowerCase() == 'gradecustomerotherlimitation');
        let _otherValue: ItemLimitation = this.dataSheet[_i].colValue![0];
        this.getRawMaterialGradesFromNormGradesAndLimitations('', _ids, _analysisValue, _otherValue);
      } */
      // this.checkDataOnSelection(); // MQF-264
    }
  }

  /**
 * AUTOCOMPLETE SELECT MILL/RAW MATERIAL GRADES
 * @param evt 
 */
  onAutocompleteSelect(evt: any, row: number, col: number) {
    let wasSelectionChanged = JSON.stringify(JSON.parse(evt.object! || evt)) != JSON.stringify(this.dataSheet[col].colValue![row]);

    if (!this.valueChanged) {
      this.originalValue = this.dataSheet[col].colValue![row]; // Save original value on the first change
    }
    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);
    this.dataSheet[col].colValue![row] = JSON.parse(evt.object! || evt);
    this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
    // for (var x = 0; x < this.dataSheet[col].colValue!.length; x++) {
    //   if (this.mapSelected.findIndex(k => k.row == x) != -1) {
    //     this.dataSheet[col].colValue![x] = JSON.parse(evt.object!);
    //     /* EDIT ALSO DATASET */
    //     this.setValueOnDataSet(x, col, this.dataSheet[col].colValue![x]);
    //   }
    // }
    // this.closeEditLight();
    // this.checkDataOnSelection();

    // if (evt.field == 'mill') {
    //   this.millChangedByUser = true;
    // }

    if (evt.field == 'rawMaterialGrades' && wasSelectionChanged) {
      // if rm was changed eventually remove material code
      this.invalidateMaterialCode(this.mapSelected.findIndex(ms => ms.row == row), row);
    }


  }

  onMaterialCodeChange(material: Material) {
    let { materialCode } = material;
    //  get material attributes for given materialcode and update selectedItems with new values
    this.subscriptions.add(from(this.getItemAttributesByMaterialCodeCached(materialCode!, this.enquiry.header?.unitSystem!)).subscribe(res => {

      const { marketingRoute, lengthType, lengthMax, lengthMin, millsId, uBent, endsCondition, ht, htAdditional, hydroTest, ut, rawMaterialGrade, testCondition, typeOfTolerance } = res;
      const sqlFromMaterial = (res as any).sqlId != null
        ? this.itemParameterValues.sqls?.find(s => s.sqlId == (res as any).sqlId) ?? null
        : ((res as any).sql?.sqlId != null
          ? this.itemParameterValues.sqls?.find(s => s.sqlId == (res as any).sql.sqlId) ?? null
          : null);
      const offerSchemeFromMaterial = (res as any).offerSchemeCode != null
        ? this.itemParameterValues.offerSchemes?.find(s => s.offerSchemeCode == (res as any).offerSchemeCode) ?? null
        : ((res as any).offerScheme?.offerSchemeCode != null
          ? this.itemParameterValues.offerSchemes?.find(s => s.offerSchemeCode == (res as any).offerScheme.offerSchemeCode) ?? null
          : null);
      const materialDimensions = this.getMaterialDimensionsByType(res);
      const multipleLengthColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'multiplelength');

      this.mapSelected.forEach((ms, idx) => {
        const rowIndex = ms.row!;
        const hadMultipleLength = multipleLengthColumnIndex != -1 && !!this.dataSheet[multipleLengthColumnIndex]?.colValue?.[rowIndex];

        this.materialAttributesByRow.set(ms.row!, res);
        this.setValueOnDataSheetAndDataSetByColumnName('marketingroute', idx, marketingRoute); // TODO: 

        this.clearNpsForSelectedRow(idx);

        // Keep sms coherent with the marketing route (same behavior used in onSelected -> marketingroute).
        const smsColumnIndex = this.dataSheet.findIndex(d => d.colName?.toLowerCase() == 'sms');
        if (smsColumnIndex != -1) {
          const currentSmsId = this.dataSheet[smsColumnIndex].colValue![rowIndex]?.smsId;
          const currentSmsDesc = this.itemParameterValues.sms?.find(s => s.smsId === currentSmsId)?.description;
          const nextSms = currentSmsDesc
            ? this.itemParameterValues.sms?.find(s => s.marketingRoute === marketingRoute && s.description === currentSmsDesc) ?? null
            : null;
          this.setValueOnDataSheetAndDataSet(smsColumnIndex, idx, nextSms);
        }

        this.setValueOnDataSheetAndDataSetByColumnName('od', idx, materialDimensions.od);
        this.setValueOnDataSheetAndDataSetByColumnName('id', idx, materialDimensions.id);
        this.setValueOnDataSheetAndDataSetByColumnName('wt', idx, materialDimensions.wt);
        this.setValueOnDataSheetAndDataSetByColumnName('oduom', idx, materialDimensions.odUom);
        this.setValueOnDataSheetAndDataSetByColumnName('iduom', idx, materialDimensions.idUom);
        this.setValueOnDataSheetAndDataSetByColumnName('wtuom', idx, materialDimensions.wtUom);
        this.clearToleranceFieldsByMissingDimensions(idx, materialDimensions);

        if (this.materialDimTypeHasWt(res)) {
          this.setValueOnDataSheetAndDataSetByColumnName('typeoftolerance', idx, typeOfTolerance ?? null);
          this.alignTubeExecutionWithMarketingRoute(idx, marketingRoute, typeOfTolerance);
        } else {
          this.setValueOnDataSheetAndDataSetByColumnName('typeoftolerance', idx, null);
        }

        this.setValueOnDataSheetAndDataSetByColumnName('lengthType', idx, lengthType);
        this.setValueOnDataSheetAndDataSetByColumnName('ubent', idx, uBent);

        if (hadMultipleLength) {
          this.setValueOnDataSheetAndDataSetByColumnName('multiplelength', idx, false);
        }


        if (lengthType == 'RL') {
          if (hadMultipleLength) {
            this.setValueOnDataSheetAndDataSetByColumnName('lengthMax', idx, null);
            this.setValueOnDataSheetAndDataSetByColumnName('lengthMin', idx, null);
          } else {
            this.setValueOnDataSheetAndDataSetByColumnName('lengthMax', idx, lengthMax);
            this.setValueOnDataSheetAndDataSetByColumnName('lengthMin', idx, lengthMin);
          }
        }
        else {
          this.setValueOnDataSheetAndDataSetByColumnName('lengthnominal', idx, lengthMax);
          this.setValueOnDataSheetAndDataSetByColumnName('lengthMax', idx, null);
          this.setValueOnDataSheetAndDataSetByColumnName('lengthMin', idx, null);
        }

        const selectedMill = this.resolveMillForMaterialSelection(idx, millsId || []);
        this.setValueOnDataSheetAndDataSetByColumnName('mill', idx, selectedMill || null);
        this.applyDefaultSurfaceTypeForSelectedRow(idx);

        this.setValueOnDataSheetAndDataSetByColumnName('cts', idx, false); // cts field should be false on material code change
        this.setValueOnDataSheetAndDataSetByColumnName('endsCondition', idx, endsCondition);
        this.setValueOnDataSheetAndDataSetByColumnName('testCondition', idx, testCondition);
        const hasSqlRestriction = this.applySqlRulesForSelectedRow(idx, res);
        if (!hasSqlRestriction && sqlFromMaterial) {
          this.setValueOnDataSheetAndDataSetByColumnName('sql', idx, sqlFromMaterial);
        }
        if (offerSchemeFromMaterial) {
          this.setValueOnDataSheetAndDataSetByColumnName('offerScheme', idx, offerSchemeFromMaterial);
        }
        this.setValueOnDataSheetAndDataSetByColumnName('ht', idx, ht);
        this.setValueOnDataSheetAndDataSetByColumnName('htAdditional', idx, htAdditional);
        this.setValueOnDataSheetAndDataSetByColumnName('hydroTest', idx, hydroTest);
        this.setValueOnDataSheetAndDataSetByColumnName('ut', idx, ut);

        this.setValueOnDataSheetAndDataSetByColumnName('normGrades', idx, []);
        this.setValueOnDataSheetAndDataSetByColumnName('gradecustomeranalysislimitation', idx, new ItemLimitation());
        this.setValueOnDataSheetAndDataSetByColumnName('gradecustomerotherlimitation', idx, new ItemLimitation());
        this.setValueOnDataSheetAndDataSetByColumnName('rawmaterialgrade', idx, rawMaterialGrade?.isDummy === true ? null : rawMaterialGrade);
        this.rawMaterialGradeDataset = rawMaterialGrade ? [rawMaterialGrade] : [];

      })

      // update possible norm grades dataset based on material code
      this.normGradesMaterialDataset = res.normGrades;
      this.normGradesDataset = res.normGrades?.sort((a: any, b: any) => {
        let nameA: string = a["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
        let nameB: string = b["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }) || [];

      // ensure material code was not removed by any previous change
      this.mapSelected.forEach((ms, idx) => {
        this.setValueOnDataSheetAndDataSetByColumnName('material', idx, material);

      });

      // Material code updates are async: force validation now so mandatory errors
      // on cleared fields (norm grades/limitations) are shown immediately.
      this.removeLog(this.npsError);
      this.checkDataOnSelection();
      this.isFormValid();
    }))
  }

  private clearNpsForSelectedRow(selectedRowIndex: number): void {
    this.setValueOnDataSheetAndDataSetByColumnName('npsschedule', selectedRowIndex, null);
  }

  private resetSqlOptionList(): void {
    this.sqlOptionList = this.defaultSqlOptionList.map(opt => ({ ...opt } as SelectOption));
  }

  private resolveSqlFromApiValue(value: unknown): Sql | undefined {
    if (value == null) {
      return undefined;
    }

    const normalizedValue = value.toString().trim().toLowerCase();
    if (!normalizedValue) {
      return undefined;
    }

    const byId = this.itemParameterValues.sqls?.find(sql => sql.sqlId != null && sql.sqlId.toString() == normalizedValue);
    if (byId) {
      return byId;
    }

    return this.itemParameterValues.sqls?.find(sql => (sql.name || '').toLowerCase() == normalizedValue);
  }

  private getSqlsForMaterialAndMill(attrs: ItemAttributesByMaterialCode, millId: number): Sql[] {
    const sqlValues = attrs.sqlsPerMill?.[millId.toString()] || attrs.sqlsPerMill?.[millId as any];
    if (!Array.isArray(sqlValues) || sqlValues.length == 0) {
      return [];
    }

    const uniqueSqls = new Map<number, Sql>();
    for (const value of sqlValues) {
      const sql = this.resolveSqlFromApiValue(value);
      if (sql?.sqlId == null) {
        continue;
      }
      uniqueSqls.set(sql.sqlId, sql);
    }

    return Array.from(uniqueSqls.values());
  }

  private buildSqlOptionsFromSqls(sqls: Sql[]): SelectOption[] {
    const emptyOption = new SelectOption();
    emptyOption.text = '';
    emptyOption.value = null;

    const options: SelectOption[] = [emptyOption];
    for (const sql of sqls) {
      const option = new SelectOption();
      option.text = sql.name;
      option.value = sql.sqlId;
      options.push(option);
    }

    return options;
  }

  private getSqlOptionsForRow(rowIndex: number): SelectOption[] {
    const millColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');
    const mill = millColumnIndex != -1 ? this.dataSheet[millColumnIndex].colValue?.[rowIndex] as Mill | null : null;
    if (!mill?.millId) {
      return this.defaultSqlOptionList.map(opt => ({ ...opt } as SelectOption));
    }

    const attrs = this.materialAttributesByRow.get(rowIndex);
    if (!attrs?.sqlsPerMill || !Object.prototype.hasOwnProperty.call(attrs.sqlsPerMill, mill.millId.toString())) {
      return this.defaultSqlOptionList.map(opt => ({ ...opt } as SelectOption));
    }

    const sqls = this.getSqlsForMaterialAndMill(attrs, mill.millId);
    return this.buildSqlOptionsFromSqls(sqls);
  }

  private buildEmptySqlOptions(): SelectOption[] {
    const emptyOption = new SelectOption();
    emptyOption.text = '';
    emptyOption.value = null;
    return [emptyOption];
  }

  private ensureSqlOptionsForRow(rowIndex: number): void {
    const materialColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
    const millColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');

    const material = materialColumnIndex != -1 ? this.dataSheet[materialColumnIndex].colValue?.[rowIndex] as Material | null : null;
    const mill = millColumnIndex != -1 ? this.dataSheet[millColumnIndex].colValue?.[rowIndex] as Mill | null : null;

    if (!material?.materialCode || !mill?.millId) {
      this.sqlOptionList = this.defaultSqlOptionList.map(opt => ({ ...opt } as SelectOption));
      return;
    }

    const cachedAttributes = this.materialAttributesByRow.get(rowIndex);
    if (cachedAttributes) {
      this.sqlOptionList = this.getSqlOptionsForRow(rowIndex);
      return;
    }

    // Avoid showing all SQLs while waiting for compatibility rules.
    this.sqlOptionList = this.buildEmptySqlOptions();

    const requestedMaterialCode = material.materialCode;
    this.subscriptions.add(
      from(this.getItemAttributesByMaterialCodeCached(requestedMaterialCode, this.enquiry.header?.unitSystem!))
        .subscribe({
          next: res => {
            const currentMaterial = materialColumnIndex != -1 ? this.dataSheet[materialColumnIndex].colValue?.[rowIndex] as Material | null : null;
            if (!currentMaterial?.materialCode || currentMaterial.materialCode != requestedMaterialCode) {
              return;
            }

            this.materialAttributesByRow.set(rowIndex, res);
            this.sqlOptionList = this.getSqlOptionsForRow(rowIndex);
          },
          error: () => {
            this.sqlOptionList = this.defaultSqlOptionList.map(opt => ({ ...opt } as SelectOption));
          }
        })
    );
  }

  private applySqlRulesForSelectedRow(selectedIndex: number, attrs?: ItemAttributesByMaterialCode): boolean {
    const mapEntry = selectedIndex >= 0 && selectedIndex < this.mapSelected.length ? this.mapSelected[selectedIndex] : undefined;
    const rowIndex = mapEntry?.row;
    if (rowIndex == null) {
      return false;
    }

    const millColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');
    const mill = millColumnIndex != -1 ? this.dataSheet[millColumnIndex].colValue?.[rowIndex] as Mill | null : null;
    if (!mill?.millId || !attrs?.sqlsPerMill || !Object.prototype.hasOwnProperty.call(attrs.sqlsPerMill, mill.millId.toString())) {
      return false;
    }

    const sqlColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'sql');
    if (sqlColumnIndex == -1) {
      return false;
    }

    const sqls = this.getSqlsForMaterialAndMill(attrs, mill.millId);
    const nextSqlValue = sqls.length == 1 ? sqls[0] : null;
    this.dataSheet[sqlColumnIndex].colValue![rowIndex] = nextSqlValue;
    this.setValueOnDataSet(rowIndex, sqlColumnIndex, nextSqlValue);

    if (mapEntry?.col != null && this.dataSheet[mapEntry.col].colName?.toLowerCase() == 'sql') {
      this.sqlOptionList = this.buildSqlOptionsFromSqls(sqls);
    }

    return true;
  }

  private applySqlRulesForImportedItem(item: any, attrs?: ItemAttributesByMaterialCode, mill?: Mill | null): boolean {
    if (!mill?.millId || !attrs?.sqlsPerMill || !Object.prototype.hasOwnProperty.call(attrs.sqlsPerMill, mill.millId.toString())) {
      return false;
    }

    const sqls = this.getSqlsForMaterialAndMill(attrs, mill.millId);
    if (sqls.length == 1) {
      this.upsertImportFieldValue(item, 'sql', sqls[0], true);
      return true;
    }

    this.upsertImportFieldValue(item, 'sql', null, false);
    if (item?.sqlField) {
      item.sqlField.isValid = false;
    }

    return true;
  }

  private resolveDefaultMillForSelectedRow(selectedIndex: number): Mill | undefined {
    if (this.enquiry.header?.salesOffice == 'DUS' || this.enquiry.header?.salesOffice == 'EU1') {
      return this.itemParameterValues.mills?.find(m => m.shortName == 'HO');
    }

    const rowIndex = this.mapSelected[selectedIndex]?.row;
    if (rowIndex == null) {
      return undefined;
    }

    const marketingRouteIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'marketingroute');
    const marketingRoute = marketingRouteIndex != -1 ? this.dataSheet[marketingRouteIndex].colValue?.[rowIndex] : null;
    if (marketingRoute == 'Hot') {
      return this.itemParameterValues.mills?.find(m => m.shortName == 'MB');
    }

    if (marketingRoute == 'Cold') {
      const odMm = this.getOdInMmForSelectedRow(selectedIndex);
      if (odMm !== null && odMm >= 6 && odMm <= 88.99) {
        return this.itemParameterValues.mills?.find(m => m.shortName == 'CV');
      }
      if (odMm !== null && odMm > 88.99) {
        return this.itemParameterValues.mills?.find(m => m.shortName == 'RS');
      }
    }

    return undefined;
  }

  private resolveMillForMaterialSelection(selectedIndex: number, millsId: number[]): Mill | undefined {
    const compatibleMills = millsId
      .map(id => this.itemParameterValues.mills?.find(m => m.millId == id))
      .filter((mill): mill is Mill => !!mill);

    if (compatibleMills.length == 0) {
      return undefined;
    }

    if (compatibleMills.length == 1) {
      return compatibleMills[0];
    }

    const defaultMill = this.resolveDefaultMillForSelectedRow(selectedIndex);
    return compatibleMills.find(m => m.millId == defaultMill?.millId) || compatibleMills[0];
  }

  private getMaterialDimensionsByType(attrs: ItemAttributesByMaterialCode): {
    od: number | null;
    odUom: string | null;
    id: number | null;
    idUom: string | null;
    wt: number | null;
    wtUom: string | null;
  } {
    const dimType = this.resolveMaterialDimType(attrs);
    const dims = {
      od: null as number | null,
      odUom: null as string | null,
      id: null as number | null,
      idUom: null as string | null,
      wt: null as number | null,
      wtUom: null as string | null
    };

    if (dimType == 'IdWt') {
      dims.id = attrs.id ?? null;
      dims.idUom = attrs.idUom ?? null;
      dims.wt = attrs.wt ?? null;
      dims.wtUom = attrs.wtUom ?? null;
      return dims;
    }

    if (dimType == 'OdId') {
      dims.od = attrs.od ?? null;
      dims.odUom = attrs.odUom ?? null;
      dims.id = attrs.id ?? null;
      dims.idUom = attrs.idUom ?? null;
      return dims;
    }

    dims.od = attrs.od ?? null;
    dims.odUom = attrs.odUom ?? null;
    dims.wt = attrs.wt ?? null;
    dims.wtUom = attrs.wtUom ?? null;
    return dims;
  }

  private materialDimTypeHasWt(attrs?: ItemAttributesByMaterialCode): boolean {
    const dimType = (attrs?.dimType || '').toString().toLowerCase();
    return dimType.includes('wt');
  }

  private resolveMaterialDimType(attrs: ItemAttributesByMaterialCode): DimType {
    if (attrs.dimType == 'IdWt' || attrs.dimType == 'OdId' || attrs.dimType == 'OdWt') {
      return attrs.dimType;
    }

    const hasOd = attrs.od != null;
    const hasId = attrs.id != null;
    const hasWt = attrs.wt != null;

    if (hasId && hasWt && !hasOd) return 'IdWt';
    if (hasOd && hasId && !hasWt) return 'OdId';
    return 'OdWt';
  }

  private clearToleranceFieldsByMissingDimensions(selectedRowIndex: number, dimensions: {
    od: number | null;
    id: number | null;
    wt: number | null;
  }): void {
    if (dimensions.od == null) {
      this.setValueOnDataSheetAndDataSetByColumnName('odtoleranceminus', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('odtoleranceplus', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('odtoleranceuom', selectedRowIndex, null);
    }

    if (dimensions.id == null) {
      this.setValueOnDataSheetAndDataSetByColumnName('idtoleranceminus', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('idtoleranceplus', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('idtoleranceuom', selectedRowIndex, null);
    }

    if (dimensions.wt == null) {
      this.setValueOnDataSheetAndDataSetByColumnName('wttoleranceminus', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('wttoleranceplus', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('wttoleranceuom', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('tubeexecution', selectedRowIndex, null);
      this.setValueOnDataSheetAndDataSetByColumnName('typeoftolerance', selectedRowIndex, null);
    }
  }

  setNormsByMaterial(material: Material) {
    this.subscriptions.add(from(this.getItemAttributesByMaterialCodeCached(material.materialCode!, this.enquiry.header?.unitSystem!)).subscribe(res => {
      // update possible norm grades dataset based on material code
      this.normGradesMaterialDataset = res.normGrades;
      this.normGradesDataset = res.normGrades?.sort((a: any, b: any) => {
        let nameA: string = a["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
        let nameB: string = b["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }) || [];

    }))
  }

  private handleMillSelectionChange(selectedIndex: number, mill: Mill | null | undefined) {
    const mapEntry = selectedIndex >= 0 && selectedIndex < this.mapSelected.length ? this.mapSelected[selectedIndex] : undefined;
    const rowIndex = mapEntry?.row;

    if (rowIndex == null) {
      if (!mill) {
        this.invalidateMaterialCode(selectedIndex);
      }
      this.resetSqlOptionList();
      return;
    }

    if (!mill || !mill.millId) {
      this.invalidateMaterialCode(selectedIndex, rowIndex);
      this.resetSqlOptionList();
      return;
    }

    const materialColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
    if (materialColumnIndex == -1) {
      this.resetSqlOptionList();
      return;
    }

    const material = this.dataSheet[materialColumnIndex].colValue?.[rowIndex] as (Material & { millsId?: number[] }) | undefined;
    if (!material) {
      this.resetSqlOptionList();
      return;
    }

    const materialMills = (material as any)?.millsId as number[] | undefined;
    if (Array.isArray(materialMills) && materialMills.length > 0 && !materialMills.includes(mill.millId!)) {
      this.invalidateMaterialCode(selectedIndex, rowIndex);
      this.resetSqlOptionList();
      return;
    }

    const applyMaterialRules = (attrs?: ItemAttributesByMaterialCode) => {
      if (!attrs) {
        this.resetSqlOptionList();
        return;
      }

      this.materialAttributesByRow.set(rowIndex, attrs);
      if (Array.isArray(attrs.millsId) && attrs.millsId.length > 0 && !attrs.millsId.includes(mill.millId!)) {
        this.invalidateMaterialCode(selectedIndex, rowIndex);
        this.resetSqlOptionList();
        return;
      }

      this.applySqlRulesForSelectedRow(selectedIndex, attrs);
    }

    const cachedAttributes = this.materialAttributesByRow.get(rowIndex);
    if (cachedAttributes) {
      applyMaterialRules(cachedAttributes);
      return;
    }

    if (!material.materialCode) {
      this.resetSqlOptionList();
      return;
    }

    this.subscriptions.add(
      from(this.getItemAttributesByMaterialCodeCached(material.materialCode!, this.enquiry.header?.unitSystem!))
        .subscribe({
          next: res => {
            applyMaterialRules(res);
          },
          error: () => {
            this.resetSqlOptionList();
          }
        })
    );
  }

  private handleSqlSelectionChange(selectedIndex: number): void {
    const mapEntry = selectedIndex >= 0 && selectedIndex < this.mapSelected.length ? this.mapSelected[selectedIndex] : undefined;
    const rowIndex = mapEntry?.row;
    if (rowIndex == null) {
      return;
    }

    const sqlColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'sql');
    const selectedSql = sqlColumnIndex != -1 ? this.dataSheet[sqlColumnIndex].colValue?.[rowIndex] as Sql | null : null;
    if (!selectedSql?.sqlId) {
      return;
    }

    const millColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'mill');
    const mill = millColumnIndex != -1 ? this.dataSheet[millColumnIndex].colValue?.[rowIndex] as Mill | null : null;
    if (!mill?.millId) {
      return;
    }

    const materialColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
    const material = materialColumnIndex != -1 ? this.dataSheet[materialColumnIndex].colValue?.[rowIndex] as Material | null : null;
    if (!material?.materialCode) {
      return;
    }

    const ensureCompliance = (attrs?: ItemAttributesByMaterialCode) => {
      if (!attrs?.sqlsPerMill || !Object.prototype.hasOwnProperty.call(attrs.sqlsPerMill, mill.millId!.toString())) {
        return;
      }

      const compatibleSqlIds = new Set(this.getSqlsForMaterialAndMill(attrs, mill.millId!).map(sql => sql.sqlId));
      if (!compatibleSqlIds.has(selectedSql.sqlId!)) {
        this.invalidateMaterialCode(-1, rowIndex);
      }
    };

    const cachedAttributes = this.materialAttributesByRow.get(rowIndex);
    if (cachedAttributes) {
      ensureCompliance(cachedAttributes);
      return;
    }

    const requestedMaterialCode = material.materialCode;
    this.subscriptions.add(
      from(this.getItemAttributesByMaterialCodeCached(requestedMaterialCode, this.enquiry.header?.unitSystem!))
        .subscribe({
          next: res => {
            const currentMaterial = materialColumnIndex != -1 ? this.dataSheet[materialColumnIndex].colValue?.[rowIndex] as Material | null : null;
            if (currentMaterial?.materialCode != requestedMaterialCode) {
              return;
            }

            this.materialAttributesByRow.set(rowIndex, res);
            ensureCompliance(res);
          },
          error: () => { }
        })
    );
  }

  private handleTypeOfToleranceSelectionChange(selectedIndex: number): void {
    const mapEntry = selectedIndex >= 0 && selectedIndex < this.mapSelected.length ? this.mapSelected[selectedIndex] : undefined;
    const rowIndex = mapEntry?.row;
    if (rowIndex == null) {
      return;
    }

    const typeOfToleranceColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'typeoftolerance');
    if (typeOfToleranceColumnIndex == -1) {
      return;
    }
    const selectedType = this.dataSheet[typeOfToleranceColumnIndex].colValue?.[rowIndex];
    const selectedTypeValue = selectedType != null ? selectedType.toString() : '';

    const materialColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
    if (materialColumnIndex == -1) {
      return;
    }

    const material = this.dataSheet[materialColumnIndex].colValue?.[rowIndex] as Material | null | undefined;
    if (!material?.materialCode) {
      return;
    }

    const ensureCompliance = (attrs?: ItemAttributesByMaterialCode) => {
      if (!this.materialDimTypeHasWt(attrs)) {
        return;
      }

      const expectedType = attrs?.typeOfTolerance;
      if (!expectedType) {
        return;
      }

      if (selectedTypeValue !== expectedType) {
        this.invalidateMaterialCode(-1, rowIndex);
      }
    };

    const cachedAttributes = this.materialAttributesByRow.get(rowIndex);
    if (cachedAttributes) {
      ensureCompliance(cachedAttributes);
      return;
    }

    this.subscriptions.add(
      from(this.getItemAttributesByMaterialCodeCached(material.materialCode!, this.enquiry.header?.unitSystem!))
        .subscribe({
          next: res => {
            this.materialAttributesByRow.set(rowIndex, res);
            ensureCompliance(res);
          },
          error: () => { }
        })
    );
  }

  invalidateMaterialCode(selectedRowIndex: number, rowIndexOverride?: number) {
    const hasMapEntry = selectedRowIndex >= 0 && selectedRowIndex < this.mapSelected.length;
    let rowIndex = rowIndexOverride;

    if (hasMapEntry) {
      rowIndex = rowIndex ?? this.mapSelected[selectedRowIndex].row!;
      this.setValueOnDataSheetAndDataSetByColumnName('material', selectedRowIndex, null);
    } else if (rowIndex != null) {
      const materialColumnIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'material');
      if (materialColumnIndex != -1) {
        if (this.dataSheet[materialColumnIndex].colValue && this.dataSheet[materialColumnIndex].colValue!.length > rowIndex) {
          this.dataSheet[materialColumnIndex].colValue![rowIndex] = null;
        }
        if (rowIndex >= 0 && rowIndex < this.dataSet.length) {
          this.setValueOnDataSet(rowIndex, materialColumnIndex, null);
        }
      }
    }

    if (rowIndex != null) {
      this.materialAttributesByRow.delete(rowIndex);
    }
    this.resetSqlOptionList();

    if (this.normGradesDataset_Cache.length > 0)
      this.normGradesDataset = this.normGradesDataset_Cache;
    else
      this.getNormGrades('');
  }

  onLimitationsUndo(row: number, col: number): () => void {
    return () => {
      this.undoChange(row, col);
    };
  }

  undoChange(row: number, col: number, skipClose: boolean = false) {
    // Revert changes by setting the value back to the original value
    if (this.valueChanged) {
      this.dataSheet[col].colValue![row] = this.originalValue !== undefined ? JSON.parse(JSON.stringify(this.originalValue)) : undefined; // Deep copy of original value
      this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);
    }
    this.valueChanged = false;
    if (!skipClose)
      this.closeEditLight();
  }

  undoChangeNps(evt: Event | null, row: number, col: number) {

    if (evt != null) {
      evt.stopPropagation();
      evt.preventDefault();
    }

    // Revert changes by setting the value back to the original value
    //if (this.originalValue !== undefined) {
    this.dataSheet[col].colValue![row] = this.originalValue !== undefined ? JSON.parse(JSON.stringify(this.originalValue)) : null; // Deep copy of original value
    this.setValueOnDataSet(row, col, this.dataSheet[col].colValue![row]);

    // restore original values
    let _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
    this.dataSheet[_i].colValue![row!] = this.orignalOdValue;
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'oduom');
    this.dataSheet[_i].colValue![row!] = this.orignalOdUom;
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'id');
    this.dataSheet[_i].colValue![row!] = this.orignalIdValue;
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'iduom');
    this.dataSheet[_i].colValue![row!] = this.orignalIdUom;
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
    this.dataSheet[_i].colValue![row!] = this.orignalWtValue;
    _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wtuom');
    this.dataSheet[_i].colValue![row!] = this.orignalWtUom;
    //}

    this.valueChanged = false;

    this.closeEditLight();
  }

  onConfirmAutocompleteChangeClick(evt: Event | null, row: number, col: number, colName: string) {
    if (evt != null) {
      evt.stopPropagation();
      evt.preventDefault(); // this prevent further calls to makemeeditable
    }

    this.originalValue = undefined; // Clear the original value
    this.valueChanged = false;

    const value = this.dataSheet[col].colValue![row];
    const htIndex = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'ht');


    for (var x = 0; x < this.mapSelected.length; x++) {
      this.dataSheet[col].colValue![this.mapSelected[x].row!] = value;
      this.setValueOnDataSet(this.mapSelected[x].row!, col, this.dataSheet[col].colValue![this.mapSelected[x].row!]);

      if (colName.toLowerCase() == 'mill') {
        this.applyDefaultSurfaceTypeForSelectedRow(x);
        this.handleMillSelectionChange(x, value as Mill | null | undefined);
      } else if (colName.toLowerCase() == 'rawmaterialgradevalue') {
        this.invalidateMaterialCode(x);
      }

      // if (colName.toLowerCase() == 'mill') {
      //   if (value.shortName == 'CV') {
      //     // when mill is CV ht should be false
      //     this.setValueOnDataSheetAndDataSet(htIndex, x, false);
      //   }
      // }
    }




    if (colName.toLowerCase() == 'material') {
      let newValue: Material = this.dataSheet[col].colValue![row];
      this.onMaterialCodeChange(newValue);
    }


    this.checkDataOnSelection();
    this.closeEditLight();
  }

  onConfirmNormGradesChangeClick(row: number, col: number) {
    // Confirm changes by resetting the original value to the current value
    this.originalValue = undefined; // Clear the original value
    this.valueChanged = false;

    const value = this.dataSheet[col].colValue![row];

    for (var x = 0; x < this.mapSelected.length; x++) {
      this.dataSheet[col].colValue![this.mapSelected[x].row!] = value;
      this.setValueOnDataSet(this.mapSelected[x].row!, col, this.dataSheet[col].colValue![this.mapSelected[x].row!]);
    }
    this.setIsInEdit.emit(this.valueChanged);

    let _data: any[] = value;
    let _ids: number[] = new Array();
    let _codes: string[] = new Array();
    for (var x = 0; x < _data.length; x++) {
      _ids.push(_data[x]["normGradeId"]);
      _codes.push(_data[x]["normGradeCode"]);
    }
    this.closeEditLight(); // MQF-362
    // Se ho selezionato qualcosa abilito le RawMaterialGrade
    // if (_ids.length > 0) {
    this.getLimitationsForNormGrades(_ids, false, undefined, true); //, true);
    this.subscriptions.add(this.retCallApi.subscribe(ret => {
      if (ret == 1) {
        this.checkDataOnSelection();
        /*           this.closeEditLight(); */
      }
    }));
    // }
  }

  /**
  * NPS MODAL
  * @param evt 
  */
  onConfirmModalNps(evt: any, applyAll: boolean = false) {
    this.selectedNpsRow = new NpsAndSchedule();
    this.selectedNpsRow = evt;
    this.removeLog(this.npsError);
    this.showSelectNps = false;

    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);
    let rowInEditIndex = this.mapSelected.findIndex(slc => slc.inEdit == true);
    // NPS DESCRIPTION
    this.dataSheet[this.mapSelected[rowInEditIndex].col!].colValue![this.mapSelected[rowInEditIndex].row!] = this.dataSetNps.filter(x => x.npsScheduleId == evt["npsScheduleId"])[0]; //["npsDescription"];
    this.selectedNps = new NpsAndSchedule();
    this.selectedNps = evt;

    let _iNps: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'npsschedule');


    if (!applyAll) {
      // recover the focus and then exit

      setTimeout(() => {
        const cell = document.querySelector(
          `.tds-cell[tabindex="${this.mapSelected[rowInEditIndex].row!}"][data-row="${this.mapSelected[rowInEditIndex].row!}"][data-col="${this.mapSelected[rowInEditIndex].col!}"] .confirm-container`
        ) as HTMLElement;
        cell.focus();
      }, 0);

      return;
    }

    // Check which unit system is selected
    let _i: number = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'unitsystem');
    let _unitSystem: string = this.dataSheet[_i].colValue![this.mapSelected[0].row!];

    let _toBeEditRows: MapSelected[] = new Array();
    _toBeEditRows = JSON.parse(JSON.stringify(this.mapSelected))

    for (var x = 0; x < _toBeEditRows.length; x++) {

      this.dataSheet[_iNps].colValue![_toBeEditRows[x].row!] = this.dataSetNps.filter(x => x.npsScheduleId == evt["npsScheduleId"])[0]; //["npsDescription"];

      // OD/WT/ID VALUES
      if (_unitSystem.toLowerCase() == 'metric') {
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
        this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = evt["odMetric"];
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
        this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = evt["wtMetric"];
      } else {
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'od');
        this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = evt["odImperial"];
        _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'wt');
        this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = evt["wtImperial"];
      }

      // Pulisco ID e ID Uom
      _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'id');
      this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = '';

      // _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'iduom');
      // this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = '';

      // Pulisco tolerance ID e tolerance ID Uom
      _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceuom');
      this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = '';
      _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceplus');
      this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = null;
      _i = this.dataSheet.findIndex(x => x.colName?.toLowerCase() == 'idtoleranceminus');
      this.dataSheet[_i].colValue![_toBeEditRows[x].row!] = null;

      this.setValueOnDataSet(_toBeEditRows[x].row!, _toBeEditRows[x].col!, evt);

      this.invalidateMaterialCode(x, _toBeEditRows[x].row!);

      this.valueChanged = !applyAll; // reset the valueChanged on confirmAll
    }

    this.closeEditLight();
  }

  onConfirmApplyAllNpsClick(evt: Event | null, selectedNps: NpsAndSchedule) {
    if (evt != null) {
      evt.stopPropagation();
      evt.preventDefault();
    }

    // MQF-301 - Confirm on delete NPS
    if (selectedNps.npsDescription == undefined) {
      // Clear all data 

      let rowInEditIndex = this.mapSelected.findIndex(slc => slc.inEdit == true);
      let _iOd: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'od');
      let _iWt: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'wt');
      let _iNps: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'npsschedule');

      let _iTol: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'typeoftolerance');
      let _iTube: number = this.dataSheet.findIndex(x => x.colName!.toLowerCase() == 'tubeexecution');


      for (var x = 0; x < this.mapSelected.length; x++) {
        this.setValueOnDataSheetAndDataSet(_iNps, x, null);
        this.setValueOnDataSheetAndDataSet(_iOd, x, null);
        this.setValueOnDataSheetAndDataSet(_iWt, x, null);
        this.setValueOnDataSheetAndDataSet(_iTol, x, null);
        this.setValueOnDataSheetAndDataSet(_iTube, x, null);
        this.invalidateMaterialCode(x);
        // clean dataset
        this.dataSet[this.mapSelected[x].row!]["npsSchedule"] = null;
      }
      this.valueChanged = false;
      this.removeLog(this.npsError);
      this.closeEditLight();
    } else {
      this.onConfirmModalNps(selectedNps, true);
    }

  }

  onCloseModalNps(evt: any) {
    this.dataSetNps = new Array();
    this.columnsToHide = new Array();
    this.columnsNotEditable = new Array();
    this.columnsRequired = new Array();
    this.columnsSelect = new Array();
    //this.itemParameterValues = new ItemParametersValues(); MQF-301 Punto 2 (perchè si cancellavano gli ItemParamaterValues??)
    this.showSelectNps = false;
    this.closeEditLight();

    // const col = this.dataSheet.findIndex(col => col.colName?.toLowerCase() === 'npsschedule');
    // const nextCell = this.getNextCell(this.showSelectNpsSourceRow!, col);
    // nextCell.focus();
    // keep the focus tab order

  }

  onDeleteNpsSelection() {
    this.selectedNpsRow = new NpsAndSchedule();
    this.selectedNps = new NpsAndSchedule();

    // let rowInEditIndex = this.mapSelected.findIndex(slc => slc.col == this.selectedCol && slc.row == this.selectedRow);
    let rowInEditIndex = this.mapSelected.findIndex(slc => slc.inEdit == true);
    this.originalValue = JSON.parse(JSON.stringify(this.dataSheet[this.mapSelected[rowInEditIndex].col!].colValue![this.mapSelected[rowInEditIndex].row!]));

    this.dataSheet[this.mapSelected[rowInEditIndex].col!].colValue![this.mapSelected[rowInEditIndex].row!] = null;
    this.dataSet[this.mapSelected[rowInEditIndex].row!]["npsSchedule"] = null;

    this.valueChanged = true;
    this.setIsInEdit.emit(this.valueChanged);
    this.writeLog("error", this.translate.instant('errors.fieldMandatory'), this.mandatoryFieldsError);
    this.removeLog(this.npsError);
    this.showSelectNps = false;

    const cell = document.querySelector(
      `.tds-cell[tabindex="${this.mapSelected[rowInEditIndex].row!}"][data-row="${this.mapSelected[rowInEditIndex].row!}"][data-col="${this.mapSelected[rowInEditIndex].col!}"] .confirm-container`
    ) as HTMLElement;
    cell.focus();
  }

  onValueChanged(evt: boolean) {
    this.valueChanged = evt;
    this.setIsInEdit.emit((true && this.valueChanged));
  }

  isBooleanColumn(colName: string): boolean {
    const column = colName.toLowerCase();
    const booleanColumns = this.deliveryExtraProperties;
    return booleanColumns.map(bc => bc.toLowerCase()).includes(column);
  }

  /* TOOLBAR */
  buildButtonsList() {
    this.buttonsList = new Array();
    /* ALL */
    let _item: TTButton = new TTButton();

    /* SEPARATOR */
    /*    _item = new TTButton();
       _item.disabled = false;
       _item.icon = '';
       _item.id = 3;
       _item.size = "";
       _item.text = "";
       _item.tooltip = "";
       _item.action = "";
       _item.type = "separator";
       _item.state = '';
       this.buttonsList.push(_item); */



    /* ADD ENQUIRY */
    _item = new TTButton();
    _item.disabled = true;
    _item.icon = 'fal fa-clone';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "duplicateItem";
    _item.action = "duplicateItem";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = true;
    _item.icon = 'fal fa-trash-alt';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "deleteItems";
    _item.action = "deleteItem";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    // /* EDIT GRID */
    // _item = new TTButton();
    // _item.disabled = false;
    // _item.icon = 'fal fa-wrench';
    // _item.id = 7;
    // _item.size = "";
    // _item.text = "";
    // _item.tooltip = "editGrid";
    // _item.action = "showSettingsGrid";
    // _item.type = "";
    // _item.state = '';
    // this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = "";
    _item.state = Object.keys(this.activeFilters).length > 0 ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    this.syncSelectionButtonsState();
  }

  private syncSelectionButtonsState(): void {
    if (!this.buttonsList || this.buttonsList.length < 2) return;

    this.buttonsList[1].icon = 'fal fa-trash-alt';
    this.buttonsList[1].action = 'deleteItem';
    this.buttonsList[1].tooltip = "deleteItems";
    this.buttonsList[1].active = false;

    if (!this.mapSelected || this.mapSelected.length == 0) {
      this.buttonsList[0].disabled = true;
      this.buttonsList[1].disabled = true;
      return;
    }

    if (this.mapSelected.length == 1) {
      const selectedRow = this.mapSelected[0].row;
      const rowHasErrors = selectedRow == null
        || this.cellsInError.findIndex(x => x.row == selectedRow) != -1
        || this.cellsXlxsInError.findIndex(x => x.row == selectedRow) != -1;

      this.buttonsList[0].disabled = rowHasErrors;
      this.buttonsList[1].disabled = !this.canApplyDeleteSelection();
    } else {
      this.buttonsList[0].disabled = true;
      this.buttonsList[1].disabled = this.isSelectionEditAndDeleteMix() || !this.canApplyDeleteSelection();
    }
    const itemNoColumnIndex = this.dataSheet.findIndex(x => x.colName!.toLowerCase() === 'itemno');
    let enableUndo = itemNoColumnIndex != -1 && this.mapSelected.length > 0;
    for (let x = 0; x < this.mapSelected.length; x++) {
      const row = this.mapSelected[x].row;
      if (row == null || this.itemsNoToDelete.findIndex(k => k === this.dataSheet[itemNoColumnIndex].colValue![row]) === -1) {
        enableUndo = false;
        break;
      }
    }

    if (enableUndo) {
      this.buttonsList[1].icon = 'fal fa-undo';
      this.buttonsList[1].disabled = false;
      this.buttonsList[1].action = 'undoDelete';
      this.buttonsList[1].tooltip = 'undoDeleteItems';
    }
  }

  private canApplyDeleteSelection(): boolean {
    if (!this.mapSelected || this.mapSelected.length == 0) return false;

    const itemNoColumnIndex = this.dataSheet.findIndex(x => x.colName!.toLowerCase() === 'itemno');
    if (itemNoColumnIndex == -1) return false;

    const itemsMarkedForDeletion = new Set<string>(this.itemsNoToDelete);
    for (const selection of this.mapSelected) {
      const row = selection.row;
      if (row == null) continue;

      const itemNo = this.dataSheet[itemNoColumnIndex].colValue![row];
      if (!itemNo) continue;

      if (itemsMarkedForDeletion.has(itemNo)) {
        itemsMarkedForDeletion.delete(itemNo);
      } else {
        itemsMarkedForDeletion.add(itemNo);
      }
    }

    return (this.dataSet.length - itemsMarkedForDeletion.size) > 0;
  }

  private ensureItemNumbers(): void {
    if (!this.dataSet || this.dataSet.length === 0) {
      return;
    }

    const placeholderRegex = /^New\((\d+)\)$/i;
    let maxPlaceholder = 0;

    this.dataSet.forEach(item => {
      const currentItemNo = item['itemNo'];
      if (typeof currentItemNo === 'string') {
        const trimmedItemNo = currentItemNo.trim();
        const match = placeholderRegex.exec(trimmedItemNo);
        if (match) {
          const placeholderValue = parseInt(match[1], 10);
          if (!isNaN(placeholderValue) && placeholderValue > maxPlaceholder) {
            maxPlaceholder = placeholderValue;
          }
        }
      }
    });

    if (maxPlaceholder >= this.newItemNoPlaceholder) {
      this.newItemNoPlaceholder = maxPlaceholder + 1;
    }

    this.dataSet.forEach(item => {
      const currentItemNo = item['itemNo'];
      const isMissingItemNo =
        currentItemNo === null ||
        currentItemNo === undefined ||
        (typeof currentItemNo === 'string' && currentItemNo.trim() === '');

      if (isMissingItemNo) {
        item['itemNo'] = `New(${this.newItemNoPlaceholder})`;
        this.newItemNoPlaceholder++;
      }
    });
  }

  calculateNextCustomerItemNo(): string {
    if (this.dataSet.length === 0) {
      return '001';  // First item in the list
    }

    let allNumeric = true;
    let maxCustomerItemNo = 0;
    let maxCustomerItemNoRaw = '';

    for (const item of this.dataSet) {
      const parsedCustomerItemNo = this.utils.toCustomerItemNoNumber(item.customerItemNo);
      if (parsedCustomerItemNo === null) {
        allNumeric = false;
      } else {
        if (parsedCustomerItemNo > maxCustomerItemNo) {
          maxCustomerItemNo = parsedCustomerItemNo;
          maxCustomerItemNoRaw = this.utils.normalizeCustomerItemNo(item.customerItemNo);
        }
      }
    }

    if (allNumeric) {
      // Determine next number based on previous format
      const nextCustomerItemNo = (maxCustomerItemNo + 1).toString();
      const paddingLength = maxCustomerItemNoRaw.length;

      // Add padding only if it was present
      return nextCustomerItemNo.padStart(paddingLength, '0');
    } else {
      // Fallback to itemNo + 1
      const nextItemNo = parseInt(this.dataSet[this.dataSet.length - 1].itemNo!, 10) + 1;
      if (isNaN(nextItemNo)) {
        return '';
      }
      return nextItemNo.toString();
    }
  }

  onMenuBtnToolbarClick(btn: TTButton) {
    if (btn.action === 'showSettingsGrid') {
      this.showSettings();
      return;
    }

    if (btn.action == 'duplicateItem') {
      // Ricavo l'ItemNo dalla riga selezionata
      let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'itemno');
      const sourceItem = this.dataSet.filter(x => x["itemNo"] == this.dataSheet[_i].colValue![this.mapSelected[0].row!])[0];
      let _temp: any = JSON.parse(JSON.stringify(sourceItem));
      _temp["itemNo"] = "New(" + this.newItemNoPlaceholder + ")";
      _temp['customerItemNo'] = this.calculateNextCustomerItemNo();
      _temp["sourceItemNo"] = sourceItem.itemNo.includes('New') ? sourceItem.sourceItemNo : sourceItem.itemNo;
      _temp["attachments"] = [];
      this.newItemNoPlaceholder++;
      this.dataSet.push(_temp);
      this.processData();
      setTimeout(() => {
        this.writeLog("info", "Duplicazione item: " + this.dataSheet[_i].colValue![this.mapSelected[0].row!], 998);

      }, 0);
      // Selezione l'item nuovo
      this.mapSelected = new Array();
      let _newMapSelected: MapSelected = new MapSelected();
      _newMapSelected.row = this.dataSet.length - 1;
      _newMapSelected.inEdit = false;
      _newMapSelected.col = null;
      this.mapSelected.push(_newMapSelected);
      // this.buttonsList[0].active = true;
      this.buttonsList[1].active = false;
      this.buttonsList[1].disabled = true;
      this.changedDataset.emit(this.dataSet); // Emitto il nuovo dataset perchè potrei volerlo salvare subito
    }

    if (btn.action == "deleteItem") {
      if (!this.canApplyDeleteSelection()) {
        return;
      }

      // Ricavo gli ItemoNo di ogni riga selezionata 
      // this.itemsNoToDelete = new Array();
      let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'itemno');
      for (var x = 0; x < this.mapSelected.length; x++) {
        const idx = this.itemsNoToDelete.indexOf(this.dataSheet[_i].colValue![this.mapSelected[x].row!]);
        if (idx == -1) {
          this.itemsNoToDelete.push(this.dataSheet[_i].colValue![this.mapSelected[x].row!]);
          this.cellsXlxsInError = this.cellsXlxsInError.filter(c => c.row != this.mapSelected[x].row!); // remove xls error for this row
        }
        else {
          // remove
          this.itemsNoToDelete = this.itemsNoToDelete.filter(item => item !== this.dataSheet[_i].colValue![this.mapSelected[x].row!]);
        }
      }
      this.writeLog("info", "Item da eliminare: " + this.itemsNoToDelete.join(", "), 999);
      this.itemsToDelete.emit(this.itemsNoToDelete);
      this.changedDataset.emit(this.dataSet); // Emitto il nuovo dataset perchè potrei volerlo salvare subito

      // marked as remove, leave the selection
      this.mapSelected = new Array();

      this.isFormValid();
    }

    if (btn.action == 'undoDelete') {
      // Ricavo gli ItemoNo di ogni riga selezionata 
      // this.itemsNoToDelete = new Array();
      let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'itemno');
      for (var x = 0; x < this.mapSelected.length; x++) {
        this.itemsNoToDelete = this.itemsNoToDelete.filter(item => item !== this.dataSheet[_i].colValue![this.mapSelected[x].row!]);
      }
      if (this.itemsNoToDelete.length == 0)
        this.removeLog(999);
      else
        this.writeLog("info", "Item da eliminare: " + this.itemsNoToDelete.join(", "), 999);

      this.itemsToDelete.emit(this.itemsNoToDelete);
      // leave the selection and recover the trash button
      this.mapSelected = new Array();
      this.buttonsList[1].icon = 'fal fa-trash-alt';
      this.buttonsList[1].action = 'deleteItem';
      this.buttonsList[1].tooltip = "deleteItems";

      this.isFormValid();
    }

    if (btn.action == 'showFilter') {
      this.gridFilterable = true;
      this.buildButtonsList();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.gridFilterable = false;
      this.buildButtonsList();
    }

    if (btn.action == 'clearFilter') {
      this.activeFilters = { ...{} };
      this.applyFilters();
    }
  }

  isInDelete(col: number): boolean {
    if (!this.itemsNoToDelete || this.itemsNoToDelete.length == 0) return false;
    let _i: number = this.dataSheet.findIndex(c => c.colName!.toLowerCase() == 'itemno');
    if (this.itemsNoToDelete.findIndex(i => i == this.dataSheet[_i].colValue![col]) == -1)
      return false;
    else
      return true;
  }

  getTooltipText(row: number, col: number, colName: string): string {
    let _ret: string = "";

    // If is in Import Excel Error list
    let _iXlxs: number = this.findXlsxErrorIndex(row, colName);
    if (_iXlxs != -1) {
      _ret = this.cellsXlxsInError[_iXlxs].message!;
    } else {
      let _cellInError: CellInError = new CellInError();
      _cellInError = this.cellsInError.filter(x => x.row == row && x.col == col)[0];
      if (_cellInError) {
        if (_cellInError.errorCode == this.unitSystemError) _ret = this.translate.instant("errors.unitSystemIncompatible");
        if (_cellInError.errorCode == this.odWtIdError) _ret = this.translate.instant("errors.odMajorWt");
        if (_cellInError.errorCode == this.odWtIdNotConsistenError) _ret = this.translate.instant("errors.odIdWtNotConsistent");
        if (_cellInError.errorCode == this.odIdWtOnlyTwoError) _ret = this.translate.instant("errors.odIdWtOnlyTwo");
        if (_cellInError.errorCode == this.uomsDifferentUnitSystemError) _ret = this.translate.instant("errors.npsWithDifferentUnitSystem");
        if (_cellInError.errorCode == this.npsError) _ret = this.translate.instant("errors.idWithNps");
        if (_cellInError.errorCode == this.mandatoryFieldsError) _ret = this.translate.instant("errors.fieldMandatory");
        if (_cellInError.errorCode == this.noRawMaterialError) _ret = this.translate.instant("errors.noRawMaterials");
        if (_cellInError.errorCode == this.differentNormGradesError) _ret = this.translate.instant("errors.differentNormGrades");
        if (_cellInError.errorCode == this.millRuleActiveError) _ret = this.translate.instant("errors.millRuleActive");
        if (_cellInError.errorCode == this.greaterThanZeroError) _ret = this.translate.instant("errors.greaterZero");
        if (_cellInError.errorCode == this.decimalValuesError) _ret = this.translate.instant("errors.formatNotValid");
        if (_cellInError.errorCode == this.tolerancesError) _ret = this.translate.instant("errors.tolerancesNotValid");
        if (_cellInError.errorCode == this.lengthMinMaxError) _ret = this.translate.instant("errors.lengthMinMax");
        if (_cellInError.errorCode == this.lengthMinMaxFixedError) _ret = this.translate.instant("errors.lengthMinMaxFixed");
        if (_cellInError.errorCode == this.lengthShouldBeFixedError) _ret = this.translate.instant("errors.lengthShouldBeFixed");
        if (_cellInError.errorCode == this.itemNoError) _ret = this.translate.instant("errors.itemNoError");
        if (_cellInError.errorCode == this.uBentShouldBeFixedLengthError) _ret = this.translate.instant("errors.uBentShouldBeFixedLength");
        if (_cellInError.errorCode == this.multipleLengthNotAllowedError) _ret = this.translate.instant("errors.multipleLengthNotAllowed");
        if (_cellInError.errorCode == this.uBentCtsError) _ret = this.translate.instant("errors.uBentCtsCheck");
        if (_cellInError.errorCode == this.testConditionCtsError) _ret = this.translate.instant("errors.testConditionCtsCheck");
        if (_cellInError.errorCode == this.htError) _ret = this.translate.instant("errors.htNotValid");
        if (_cellInError.errorCode == this.differentMaterialCodesError) _ret = this.translate.instant("errors.differentMaterialCodes");
        if (_cellInError.errorCode == this.customerItemNoFormatError) _ret = this.translate.instant("errors.formatNotValid");
        if (_cellInError.errorCode == this.customerItemNoDuplicateError) _ret = this.translate.instant("errors.customerItemNoDuplicate");

      }
    }
    return _ret;
  }

  getNumCellInError(errorCode: number): number {
    //if (errorCode != this.fromXlsxError) {
    return this.cellsInError.filter(x => x.errorCode == errorCode).length;
    //} else {
    // return 9999;
    // }
  }

  isToLock(row: number, col: number, colName: string): boolean {
    if (this.mapSelected.findIndex(x => x.row == row) == -1) return false;
    let _ret: boolean = false;
    // MQF-364 - Se ho un unitSystemError tutte le misure e le relative uom devono essere lucchettate
    /* if (colName.toLowerCase().indexOf("uom") != -1 && this.logOperations.findIndex(x => x.code == this.unitSystemError) != -1) {
      _ret = true;
    } */

    if ((colName.toLowerCase().indexOf("uom") != -1 || colName.toLowerCase().indexOf("lengthmin") != -1 || colName.toLowerCase().indexOf("lengthmax") != -1 || colName.toLowerCase() == "quantity"
      || colName.toLowerCase() == "od" || colName.toLowerCase() == "wt" || colName.toLowerCase() == "id"
      || colName.toLowerCase() == "oduom" || colName.toLowerCase() == "wtuom" || colName.toLowerCase() == "iduom")
      && this.logOperations.findIndex(x => x.code == this.unitSystemError) != -1) {
      _ret = true;
    }
    // END MQF-364

    if (colName.toLowerCase().indexOf("limitation") != -1 && this.logOperations.findIndex(x => x.code == this.differentNormGradesError) != -1) {
      _ret = true;
    }

    if (colName.toLowerCase().indexOf("rawmaterial") != -1 && (this.logOperations.findIndex(x => x.code == this.differentNormGradesError) != -1 ||
      this.logOperations.findIndex(x => x.code == this.differentLimitationsError) != -1)) {
      _ret = true;
    }

    if ((colName.toLowerCase().indexOf("wttoleranceplus") != -1 || colName.toLowerCase().indexOf("wttoleranceminus") != -1) && (this.logOperations.findIndex(x => x.code == this.differentTubeExecution) != -1)) {
      _ret = true;
    }

    if (this.isOdDependentSelectionColumn(colName) && this.logOperations.findIndex(x => x.code == this.differentOdDependentEditabilityError) != -1) {
      _ret = true;
    }

    if (this.isIdDependentSelectionColumn(colName) && this.logOperations.findIndex(x => x.code == this.differentIdDependentEditabilityError) != -1) {
      _ret = true;
    }

    if (this.isWtDependentSelectionColumn(colName) && this.logOperations.findIndex(x => x.code == this.differentWtDependentEditabilityError) != -1) {
      _ret = true;
    }

    if ((colName.toLowerCase().indexOf("lengthmin") != -1 || colName.toLowerCase().indexOf("lengthmax") != -1) && (this.logOperations.findIndex(x => x.code == this.differentLengthUom) != -1)) {
      _ret = true;
    }

    if (colName.toLowerCase() == "quantity" && this.logOperations.findIndex(x => x.code == this.differentUomsQty) != -1) {
      _ret = true;
    }

    if (colName.toLowerCase() == "od" && (this.logOperations.findIndex(x => x.code == this.differentUomsOd) != -1 || this.logOperations.findIndex(x => x.code == this.npsError) != -1)) {
      _ret = true;
    }

    if (colName.toLowerCase() == "wt" && (this.logOperations.findIndex(x => x.code == this.differentUomsWt) != -1 || this.logOperations.findIndex(x => x.code == this.npsError) != -1)) {
      _ret = true;
    }

    if (colName.toLowerCase() == "id" && (this.logOperations.findIndex(x => x.code == this.differentUomsId) != -1 || this.logOperations.findIndex(x => x.code == this.npsError) != -1)) {
      _ret = true;
    }

    if (colName.toLowerCase() == "oduom" && this.logOperations.findIndex(x => x.code == this.npsError) != -1) {
      _ret = true;
    }

    if (colName.toLowerCase() == "wtuom" && this.logOperations.findIndex(x => x.code == this.npsError) != -1) {
      _ret = true;
    }

    if (colName.toLowerCase() == "iduom" && this.logOperations.findIndex(x => x.code == this.npsError) != -1) {
      _ret = true;
    }

    if (colName.toLowerCase() == 'npsschedule' && (this.logOperations.findIndex(x => x.code == this.differentUomsOd) != -1)) {
      _ret = true;
    }

    if ((colName.toLowerCase() == 'tubeexecution' || colName.toLowerCase() == 'sms' || colName.toLowerCase() == 'surfacetype') && (this.logOperations.findIndex(x => x.code == this.differentMarketingRoute) != -1)) {
      _ret = true;
    }

    if (colName.toLowerCase() == 'hydrotest' && this.logOperations.findIndex(x => x.code == this.differentHydroTestEditabilityError) != -1) {
      _ret = true;
    }

    // disable delivery extra when cts true 
    if (this.deliveryExtraProperties.map(ep => ep.toLowerCase()).filter(ep => ep != 'hydrotest').includes(colName.toLowerCase()) && this.logOperations.findIndex(x => x.code == this.differentCts) != -1) {
      _ret = true;
    }

    if ((colName.toLowerCase() == "normgrades") && (this.logOperations.findIndex(x => x.code == this.differentMaterialCodesError) != -1)) {
      _ret = true;
    }

    return _ret;
  }

  getLockTooltip(row: number, col: number, colName: string): string {
    let _ret: string = this.translate.instant("errors.fieldNotEditable");
    let _i: number = -1;
    _i = this.logOperations.findIndex(x => x.code == this.unitSystemError);
    // MQF-364 - Se ho un unitSystemError tutte le misure e le relative uom devono essere lucchettate
    /* if (colName.toLowerCase().indexOf("uom") != -1 && _i != -1){
      _ret = this.logOperations[_i].message!;
    } */
    if ((colName.toLowerCase().indexOf("uom") != -1 || colName.toLowerCase().indexOf("lengthmin") != -1 || colName.toLowerCase().indexOf("lengthmax") != -1 || colName.toLowerCase() == "quantity"
      || colName.toLowerCase() == "od" || colName.toLowerCase() == "wt" || colName.toLowerCase() == "id"
      || colName.toLowerCase() == "oduom" || colName.toLowerCase() == "wtuom" || colName.toLowerCase() == "iduom")
      && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }
    // END MQF-364


    _i = this.logOperations.findIndex(x => x.code == this.differentNormGradesError);
    if (colName.toLowerCase().indexOf("limitation") != -1 && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentNormGradesError);
    if (colName.toLowerCase().indexOf("rawmaterial") != -1 && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentTubeExecution);
    if ((colName.toLowerCase().indexOf("wttoleranceplus") != -1 || colName.toLowerCase().indexOf("wttoleranceminus") != -1) && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentOdDependentEditabilityError);
    if (this.isOdDependentSelectionColumn(colName) && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentIdDependentEditabilityError);
    if (this.isIdDependentSelectionColumn(colName) && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentWtDependentEditabilityError);
    if (this.isWtDependentSelectionColumn(colName) && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentUomsOd);
    if (colName.toLowerCase() == "od" && (this.logOperations.findIndex(x => x.code == this.differentUomsOd) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentUomsWt);
    if (colName.toLowerCase() == "wt" && (this.logOperations.findIndex(x => x.code == this.differentUomsWt) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentUomsId);
    if (colName.toLowerCase() == "id" && (this.logOperations.findIndex(x => x.code == this.differentUomsId) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentUomsQty);
    if (colName.toLowerCase() == "quantity" && (this.logOperations.findIndex(x => x.code == this.differentUomsQty) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentLengthUom);
    if ((colName.toLowerCase() == "lengthmin" || colName.toLowerCase() == "lengthmax") && (this.logOperations.findIndex(x => x.code == this.differentLengthUom) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentUomsOd);
    if (colName.toLowerCase() == "npsschedule" && (this.logOperations.findIndex(x => x.code == this.differentUomsOd) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentMarketingRoute);
    if ((colName.toLowerCase() == 'tubeexecution' || colName.toLowerCase() == 'sms' || colName.toLowerCase() == 'surfacetype') && (this.logOperations.findIndex(x => x.code == this.differentMarketingRoute) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentHydroTestEditabilityError);
    if (colName.toLowerCase() == 'hydrotest' && _i != -1) {
      _ret = this.logOperations[_i].message!;
    }

    _i = this.logOperations.findIndex(x => x.code == this.differentMaterialCodesError);
    if (colName.toLowerCase() == "normgrades" && (this.logOperations.findIndex(x => x.code == this.differentMaterialCodesError) != -1)) {
      _ret = this.logOperations[_i].message!;
    }

    return _ret;
  }

  isToDisable(row: number, col: number, colName: string): boolean {
    let _ret: boolean = false;
    let _i: number = -1;
    let _j: number = -1;
    // if (colName.toLowerCase() == 'itemno') _ret = true; //MQF-277 itemno is disabled but we don't show the icon 

    if (colName.toLowerCase() == 'unitsystem') _ret = true; //MQF-472 
    if (colName.toLowerCase() == 'ubent') _ret = true;

    if ((colName.toLowerCase() == 'od' || colName.toLowerCase() == 'id' || colName.toLowerCase() == 'wt') && !colName.toLowerCase().includes('tolerance')) {
      _i = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'npsschedule');
      if (this.dataSheet[_i].colValue![row] && this.dataSheet[_i].colValue![row] != null && this.dataSheet[_i].colValue![row] != '') {
        _ret = true;
      }
    }

    if (colName.toLowerCase().indexOf('wttoleranceminus') != -1 || colName.toLowerCase().indexOf('wttoleranceplus') != -1) {
      _i = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'tubeexecution');
      if (this.dataSheet[_i].colValue![row] && this.dataSheet[_i].colValue![row]['isCustom'] == false) {
        _ret = true;
      }
    }

    if (colName.toLowerCase().indexOf('lengthmin') != -1 || colName.toLowerCase().indexOf('lengthmax') != -1) {
      _i = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'multiplelength');
      _j = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'lengthtype');

      if (!this.dataSheet[_i].colValue![row] && this.dataSheet[_j].colValue![row] == 'FL') {
        _ret = true;
      }
    }

    if (colName.toLowerCase().indexOf('multiplelength') != -1 || colName.toLowerCase().indexOf('lengthnominal') != -1) {
      _i = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'lengthtype');

      if (this.dataSheet[_i].colValue![row] == 'RL') {
        _ret = true;
      }
    }

    if (this.isOdDependentSelectionColumn(colName) && this.isOdDependentFieldDisabledForRow(row)) {
      _ret = true;
    }

    if (this.isIdDependentSelectionColumn(colName) && this.isIdDependentFieldDisabledForRow(row)) {
      _ret = true;
    }

    if (this.isWtDependentSelectionColumn(colName) && this.isWtDependentFieldDisabledForRow(row)) {
      _ret = true;
    }

    // removed: MQF-762
    // if (colName.toLowerCase().indexOf('testcondition') != -1) {
    //   if (this.enquiry.header?.orderReason == 'Project') {
    //     _ret = true;
    //   }
    // }

    // disable delivery extra when cts true 
    if ([...this.deliveryExtraProperties.filter(ep => ep.toLowerCase() != 'hydrotest'), 'endscondition'].map(ep => ep.toLowerCase()).includes(colName.toLowerCase())) {
      _i = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'cts');
      if (this.dataSheet[_i].colValue![row]) {
        _ret = true;
      }
    }

    if (colName.toLowerCase() == 'hydrotest' && this.isHydroTestDisabledForRow(row)) {
      _ret = true;
    }

    return _ret;
  }

  getInputValue(columnName: string | undefined, colValue: any): any {
    if (!columnName || colValue === null || colValue === undefined || colValue === '')
      return colValue;
    return colValue;
  }

  getInputIcon(columnName: string | undefined): string {
    if (!columnName) {
      return '';
    }

    if (columnName.endsWith('toleranceplus')) {
      return 'fal fa-arrow-up';
    }

    if (columnName.endsWith('toleranceminus')) {
      return 'fal fa-arrow-down';
    }

    return '';
  }

  isNegativeNumberAllowed(columnName: string | undefined): boolean {
    if (!columnName) {
      return false;
    }

    return columnName.includes('toleranceplus') || columnName.includes('toleranceminus');
  }

  private isOdDependentSelectionColumn(columnName: string | undefined): boolean {
    return !!columnName && columnName.toLowerCase().includes('odtolerance');
  }

  private isIdDependentSelectionColumn(columnName: string | undefined): boolean {
    return !!columnName && columnName.toLowerCase().includes('idtolerance');
  }

  private isOdDependentFieldDisabledForRow(rowIndex: number): boolean {
    const odColumnIndex = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'od');
    if (odColumnIndex == -1) {
      return false;
    }

    return !this.dataSheet[odColumnIndex].colValue?.[rowIndex];
  }

  private isIdDependentFieldDisabledForRow(rowIndex: number): boolean {
    const idColumnIndex = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'id');
    if (idColumnIndex == -1) {
      return false;
    }

    return !this.dataSheet[idColumnIndex].colValue?.[rowIndex];
  }

  private isWtDependentSelectionColumn(columnName: string | undefined): boolean {
    if (!columnName) {
      return false;
    }

    const normalizedColumnName = columnName.toLowerCase();
    return normalizedColumnName.includes('wttolerance')
      || normalizedColumnName == 'tubeexecution'
      || normalizedColumnName == 'typeoftolerance';
  }

  private isWtDependentFieldDisabledForRow(rowIndex: number): boolean {
    const wtColumnIndex = this.dataSheet.findIndex(ds => ds.colName?.toLowerCase() == 'wt');
    if (wtColumnIndex == -1) {
      return false;
    }

    return !this.dataSheet[wtColumnIndex].colValue?.[rowIndex];
  }

  /**
   * If user is editing a cell and adding a row to the selected rows check if the cell of the new row can be edited
   * @param newRowNum
   * @returns 
   */
  isValidRowSelection(newRowNum: number): boolean {
    const editIndex = this.mapSelected.findIndex(x => x.inEdit == true);
    if (editIndex == -1)
      return true; // nothing in edit 
    else {
      const column = this.mapSelected[editIndex].col!;
      const columnName = this.dataSheet[column].colName!.toLowerCase();

      if (this.isToLock(newRowNum, column, columnName) || this.isToDisable(newRowNum, column, columnName))
        return false; // the new row will be locked , do not proceed with the selection
    }
    return true;
  }

  countErrors(): number {
    let _xlsErrors: number = 0;
    let _tempListX: string[] = new Array();
    if (this.cellsXlxsInError && this.cellsXlxsInError.length > 0) {
      _tempListX = this.cellsXlxsInError.map(x => {
        const normalized = this.normalizeXlsxErrorColName(x.colName).replace(/field$/i, '');
        const colIndex = this.dataSheet.findIndex(d => this.normalizeXlsxErrorColName(d.colName) == normalized);
        return x.row!.toString() + colIndex;
      }); //.filter((value, index, self) => self.indexOf(value) === index);
    }

    let _feErrors: number = 0;
    let _tempListCE: string[] = new Array();
    if (this.cellsInError && this.cellsInError.length > 0) {
      _tempListCE = this.cellsInError.map(x => x.row!.toString() + x.col!.toString()); //.filter((value, index, self) => self.indexOf(value) === index);
    }

    return _tempListCE.concat(_tempListX).filter((value, index, self) => self.indexOf(value) === index).length;
  }

  /*   getJsonError():string{
      return JSON.stringify(this.cellsInError) + " / / " + JSON.stringify(this.cellsXlxsInError);
    } */

  /* MQF-436 MODAL DISCARD */
  onModalButtonsClick(action: string) {
    // DEVO RECUPERARE L'OGGETTO IN EDIT PER CAPIRNE IL TIPO
    let _i: number = this.mapSelected.findIndex(f => f.inEdit == true);
    let _colName: string = this.dataSheet[this.mapSelected[_i].col!].colName!;
    if (_i != -1) {
      if (action == 'apply') {
        if (_colName.toLowerCase() == 'normgrades') {
          this.onConfirmNormGradesChangeClick(this.mapSelected[_i].row!, this.mapSelected[_i].col!);
        } else if (_colName.toLowerCase() == 'rawmaterialgrade' || _colName.toLowerCase() == 'mill') {
          this.onConfirmAutocompleteChangeClick(null, this.mapSelected[_i].row!, this.mapSelected[_i].col!, _colName);
        } else if (_colName.toLowerCase() == 'npsschedule') {
          this.onConfirmApplyAllNpsClick(null, this.selectedNps);
        } else {
          this.applyChange = true;
          setTimeout(() => this.applyChange = false, 250);
        }
      }
      if (action == 'discard') {
        if (_colName.toLowerCase() == 'npsschedule') {
          this.undoChangeNps(null, this.mapSelected[_i].row!, this.mapSelected[_i].col!);
        } else {
          this.globals.discardEditInPlace?.next(1);
        }
      }
    }
    this.showModalDiscardApply = false;
  }

  onConfirmKeyDown($event: KeyboardEvent, row: number, col: number, colName: string) {
    if ($event.key == 'Enter' || $event.key == 'Tab') {
      this.handleConfirmForNotConfirmableInputs(colName, row, col, $event);
    }
  }

  onConfirmFocusOut($event: any, row: number, col: number, colName: string) {
    const currentTarget = $event.currentTarget as HTMLElement | null;
    const relatedTarget = $event.relatedTarget as Node | null;
    if (currentTarget && relatedTarget && currentTarget.contains(relatedTarget)) {
      return;
    }

    setTimeout(() => {
      if (this.valueChanged) {
        this.handleConfirmForNotConfirmableInputs(colName, row, col, $event);
      }
    }, 400);
    // this is wa due to the nature of the focus out what happens:
    // the user select an item from the dropdownmenu => this is a focus out so this method is triggered
    // but the value is still not applied to the dropdown so you will wind keep the previous selection
  }

  handleConfirmForNotConfirmableInputs(colName: string, row: number, col: number, $event: KeyboardEvent) {
    if (!this.valueChanged) return;

    if (colName.toLowerCase() == 'normgrades') {
      this.onConfirmNormGradesChangeClick(row, col);
    }
    if (colName.toLowerCase() == 'rawmaterialgrade' || colName.toLowerCase() == 'mill' || colName.toLowerCase() == 'material' || colName.toLowerCase() == 'customerdeliverydate') {
      this.onConfirmAutocompleteChangeClick($event, row, col, colName);
    }
    if (colName.toLowerCase() == 'npsschedule') {
      this.onConfirmApplyAllNpsClick($event, this.selectedNps);
    }

    // recover the focus so user can keep tab
    const { nextCell } = this.getNextCell(row, col);
    nextCell.focus();
  }

  /**
* GRID SETTINGS EVENTS
* @param evt 
*/
  showSettings() {
    this.showSettingsDialog = true;
  }

  onCloseSettings(evt: any) {
    this.showSettingsDialog = false;
  }

  onApplySettings(gridConfiguration: GridConfiguration) {
    this.gridConfiguration = new GridConfiguration()
    this.gridConfiguration = gridConfiguration;
    this.applyGridConfiguration();
    this.syncHiddenColumnsFromConfiguration();
    this.onUpdateConfiguration(this.gridConfiguration);
    this.setDimensions();
    this.refreshColumnsWidth();
    this.showSettingsDialog = false;
  }

  applyGridConfiguration() {
    const sortedDatsheet = this.dataSheet.sort((item1, item2) => {
      const index1 = this.gridConfiguration.gridColumns!.map(gc => gc.name).indexOf(item1.colName!);
      const index2 = this.gridConfiguration.gridColumns!.map(gc => gc.name).indexOf(item2.colName!);

      // Handle items not in columnNames by moving them to the end
      return (index1 === -1 ? Number.MAX_VALUE : index1) -
        (index2 === -1 ? Number.MAX_VALUE : index2);
    });
    this.dataSheet = sortedDatsheet;
    this.syncHiddenColumnsFromConfiguration();
  }

  private isSystemHiddenColumn(colName?: string): boolean {
    if (!colName) return false;
    const normalized = colName.toLowerCase();
    return normalized === 'itemno' || normalized === 'isimportedfromai' || normalized === 'alloysurcharge';
  }

  private findGridColumn(colName: string): GridColumn | undefined {
    return this.gridConfiguration.gridColumns?.find(gc => gc.name?.toLowerCase() === colName.toLowerCase());
  }

  private normalizeColumnName(colName?: string): string {
    return (colName ?? '').toLowerCase();
  }

  private getFrozenColumnsBoundary(): number {
    const configuredFrozen = this.gridConfiguration.frozenColumns ?? 0;
    if (configuredFrozen > 0) return configuredFrozen;
    return this.gridConfiguration.activeFrozenColumns ?? 0;
  }

  private getOrderedConfiguredColumns(): { column: GridColumn; order: number }[] {
    return (this.gridConfiguration.gridColumns ?? [])
      .map((column, index) => ({ column, order: column.position ?? (index + 1) }))
      .sort((a, b) => a.order - b.order);
  }

  private getFrozenVisibleColumns(): GridColumn[] {
    const frozenBoundary = this.getFrozenColumnsBoundary();
    if (frozenBoundary <= 0) return [];

    return this.getOrderedConfiguredColumns()
      .filter(item => item.order <= frozenBoundary && item.column.visible !== false)
      .map(item => item.column);
  }

  private syncHiddenColumnsFromConfiguration() {
    if (!this.dataSheet || this.dataSheet.length === 0) return;

    this.dataSheet.forEach(col => {
      if (!col.colName) return;

      if (this.isSystemHiddenColumn(col.colName)) {
        col.isHidden = true;
        const cfgCol = this.findGridColumn(col.colName);
        if (cfgCol) cfgCol.visible = false;
        return;
      }

      const cfgCol = this.findGridColumn(col.colName);
      col.isHidden = false;
      if (cfgCol) cfgCol.visible = true;
    });
  }

  isFrozenColumn(index: number): boolean {
    const colName = this.dataSheet[index]?.colName;
    if (!colName) return false;

    const normalizedColumnName = this.normalizeColumnName(colName);
    return this.getFrozenVisibleColumns()
      .some(gc => this.normalizeColumnName(gc.name) === normalizedColumnName);
  }

  canQuickHideColumn(index: number): boolean {
    const col = this.dataSheet[index];
    if (!col || !col.colName) return false;
    if (this.isSystemHiddenColumn(col.colName)) return false;
    if (col.isHidden) return false;

    const visibleColumns = this.dataSheet.filter(c => !c.isHidden && !this.isSystemHiddenColumn(c.colName));
    return visibleColumns.length > 1;
  }

  onQuickHideColumn(index: number, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.canQuickHideColumn(index)) return;
    const col = this.dataSheet[index];
    if (!col?.colName) return;

    col.isHidden = true;
    const cfgCol = this.findGridColumn(col.colName);
    if (cfgCol) cfgCol.visible = false;

    this.setDimensions();
    this.refreshColumnsWidth();

    // Enable this to persist quick hide/show in user configuration.
    // this.onUpdateConfiguration(this.gridConfiguration);
  }

  hasQuickShowColumnsBetweenVisible(index: number): boolean {
    return this.getHiddenColumnsBetweenVisible(index).length > 0;
  }

  getQuickShowColumnsCountBetweenVisible(index: number): number {
    return this.getHiddenColumnsBetweenVisible(index).length;
  }

  hasQuickShowColumnsAfterVisible(index: number): boolean {
    return this.getHiddenColumnsAfterVisible(index).length > 0;
  }

  getQuickShowColumnsCountAfterVisible(index: number): number {
    return this.getHiddenColumnsAfterVisible(index).length;
  }

  hasQuickShowColumnsBeforeVisible(index: number): boolean {
    return this.getHiddenColumnsBeforeVisible(index).length > 0;
  }

  getQuickShowColumnsCountBeforeVisible(index: number): number {
    return this.getHiddenColumnsBeforeVisible(index).length;
  }

  onQuickShowColumnsBetweenVisible(index: number, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const hiddenIndices = this.getHiddenColumnsBetweenVisible(index);
    if (hiddenIndices.length === 0) return;

    hiddenIndices.forEach(hiddenIndex => {
      const hiddenCol = this.dataSheet[hiddenIndex];
      if (!hiddenCol?.colName) return;

      hiddenCol.isHidden = false;
      const cfgCol = this.findGridColumn(hiddenCol.colName);
      if (cfgCol) cfgCol.visible = true;
    });

    this.setDimensions();
    this.refreshColumnsWidth();

    // Enable this to persist quick hide/show in user configuration.
    // this.onUpdateConfiguration(this.gridConfiguration);
  }

  onQuickShowColumnsAfterVisible(index: number, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const hiddenIndices = this.getHiddenColumnsAfterVisible(index);
    if (hiddenIndices.length === 0) return;

    hiddenIndices.forEach(hiddenIndex => {
      const hiddenCol = this.dataSheet[hiddenIndex];
      if (!hiddenCol?.colName) return;

      hiddenCol.isHidden = false;
      const cfgCol = this.findGridColumn(hiddenCol.colName);
      if (cfgCol) cfgCol.visible = true;
    });

    this.setDimensions();
    this.refreshColumnsWidth();

    // Enable this to persist quick hide/show in user configuration.
    // this.onUpdateConfiguration(this.gridConfiguration);
  }

  onQuickShowColumnsBeforeVisible(index: number, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const hiddenIndices = this.getHiddenColumnsBeforeVisible(index);
    if (hiddenIndices.length === 0) return;

    hiddenIndices.forEach(hiddenIndex => {
      const hiddenCol = this.dataSheet[hiddenIndex];
      if (!hiddenCol?.colName) return;

      hiddenCol.isHidden = false;
      const cfgCol = this.findGridColumn(hiddenCol.colName);
      if (cfgCol) cfgCol.visible = true;
    });

    this.setDimensions();
    this.refreshColumnsWidth();

    // Enable this to persist quick hide/show in user configuration.
    // this.onUpdateConfiguration(this.gridConfiguration);
  }

  private getHiddenColumnsBetweenVisible(index: number): number[] {
    const currentCol = this.dataSheet[index];
    if (!currentCol || currentCol.isHidden) return [];

    const hiddenIndices: number[] = [];
    for (let i = index + 1; i < this.dataSheet.length; i++) {
      const col = this.dataSheet[i];
      if (!col) continue;

      if (!col.isHidden) {
        return hiddenIndices;
      }

      if (!this.isSystemHiddenColumn(col.colName)) {
        hiddenIndices.push(i);
      }
    }

    return [];
  }

  private getHiddenColumnsBeforeVisible(index: number): number[] {
    const currentCol = this.dataSheet[index];
    if (!currentCol || currentCol.isHidden) return [];

    const hiddenIndices: number[] = [];
    for (let i = index - 1; i >= 0; i--) {
      const col = this.dataSheet[i];
      if (!col) continue;

      if (!col.isHidden) {
        // There is a visible column on the left side.
        // The gap marker is already handled by that visible column.
        return [];
      }

      if (!this.isSystemHiddenColumn(col.colName)) {
        hiddenIndices.push(i);
      }
    }

    return hiddenIndices;
  }

  private getHiddenColumnsAfterVisible(index: number): number[] {
    const currentCol = this.dataSheet[index];
    if (!currentCol || currentCol.isHidden) return [];

    const hiddenIndices: number[] = [];
    for (let i = index + 1; i < this.dataSheet.length; i++) {
      const col = this.dataSheet[i];
      if (!col) continue;

      if (!col.isHidden) {
        // There is a visible column on the right side.
        // The gap marker is already handled by getHiddenColumnsBetweenVisible.
        return [];
      }

      if (!this.isSystemHiddenColumn(col.colName)) {
        hiddenIndices.push(i);
      }
    }

    return hiddenIndices;
  }

  sortItemProperties(item: EnquiryHeaderItem): any {
    const propertyOrder = this.gridConfiguration.gridColumns!.map(gc => gc.name!);

    const orderedObject: { [key: string]: any } = {};
    propertyOrder.forEach((prop) => {
      if (item[prop] !== undefined) {
        orderedObject[prop] = item[prop];
      }
    });
    return orderedObject;
  }


  refreshColumnsWidth() {
    this.resizableColumnsService.reset();

    this.recalculateColumnsWidth = true;
    setTimeout(() => {
      this.recalculateColumnsWidth = false;
    }, 150);
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.updateUserConfiguration();
  }

  getStickyLeftPosition(index: number): number | undefined {
    const colName = this.dataSheet[index]?.colName;
    if (!colName) {
      return undefined;
    }

    const frozenVisibleColumns = this.getFrozenVisibleColumns();
    const normalizedColumnName = this.normalizeColumnName(colName);
    const visibleFrozenIndex = frozenVisibleColumns
      .findIndex(gc => this.normalizeColumnName(gc.name) === normalizedColumnName);

    if (visibleFrozenIndex === -1) {
      return undefined;
    }

    let leftPosition = this.checkboxColumnContainerWidth; // Start with checkbox column width
    for (let i = 0; i < visibleFrozenIndex; i++) {
      leftPosition += frozenVisibleColumns[i].width ?? this.DEFAULT_COL_WIDTH;
    }

    return leftPosition;
  }

  onFilterInputChange(evt: any, column: DataSheet) {
    if (this.getFilterType(column) === 'number') {
      let _temp: string[] = evt.split("|");

      if (_temp.length === 3) {
        const operator = _temp[0];
        const value = parseFloat(_temp[1]);

        if (!isNaN(value)) {
          this.activeFilters[column.colName!] = { operator, value };
        } else {
          delete this.activeFilters[column.colName!];
        }
      } else if (_temp.length === 4 && _temp[0] === 'ltgt') {
        const min = parseFloat(_temp[1]);
        const max = parseFloat(_temp[2]);

        if (!isNaN(min) && !isNaN(max)) {
          this.activeFilters[column.colName!] = { operator: 'ltgt', min, max };
        } else {
          delete this.activeFilters[column.colName!];
        }
      } else {
        delete this.activeFilters[column.colName!]; // Reset filter if invalid input
      }
    } else {
      // Handle text-based filters
      let value: string = evt;
      if (!!value && value !== '') {
        this.activeFilters[column.colName!] = value;
      } else {
        delete this.activeFilters[column.colName!];
      }
    }
    this.applyFilters();
  }

  onSelectedFilterOptions(evt: any, column: DataSheet) {
    if (Array.isArray(evt) && evt.length > 0) {
      this.activeFilters[column.colName!] = evt;
    }
    else {
      delete this.activeFilters[column.colName!];
    }
    this.applyFilters();
  }

  buildFilters(): void {

    this.filtersValues = {};
    this.filterMaps = new Array();

    this.filterMaps = this.dataSheet.filter(col => col.colType == 'object' || col.colType == 'select').map(col => {

      const colName = col.colName!;
      const colValues = col.colValue?.map(cv => this.getObjectValue(col.colName!, cv));
      this.filtersValues[colName] = [...new Set(colValues)];
      let filter = new ODataGridFilterMap();
      filter.columnName = col.colName!;
      filter.filterName = col.colName!;
      return filter;
    })
  }

  applyFilters() {
    if (!this.dataSheet || this.dataSheet.length === 0) return;

    // Copy dataSheet to keep original values
    this.filteredDataSheet = this.dataSheet.map(col => ({
      ...col,
      colValue: [...col.colValue!] // Ensure colValue is cloned
    }));

    // Determine the number of rows based on the first column
    const numRows = this.dataSheet[0]?.colValue?.length || 0;

    // Get row indices that should be kept after filtering
    this.filteredRowIndices = Array.from({ length: numRows }, (_, rowIndex) => rowIndex).filter(rowIndex => {
      return Object.keys(this.activeFilters).every(key => {
        const filter = this.activeFilters[key];

        // Find the correct column in filteredDataSheet
        const column = this.filteredDataSheet.find(ds => ds.colName === key);
        if (!column || !column.colValue || rowIndex >= column.colValue.length) return false;

        const itemValue = column.colValue[rowIndex]; // Get value for this row in the column

        // String filtering (case-insensitive contains check)
        if (column.colType === 'text' || column.colType === 'string') {
          return itemValue?.toString().toLowerCase().includes(filter);
        }
        if (column.colType === 'boolean' && filter) {
          let value = itemValue ? 'Yes' : 'No';
          return value.includes(filter);
        }
        if (column.colType === 'object' || column.colType === 'select') {
          let value = this.getObjectValue(column.colName!, itemValue);
          return filter.includes(value);
        }
        if (column.colType === 'date') {
          const valueDateKey = getDateOnlyKey(itemValue);
          const filterDateKey = getDateOnlyKey(filter);
          return valueDateKey != '' && valueDateKey === filterDateKey;
        }


        // Number filtering
        if (typeof filter === 'object' && column.colType === 'number') {
          const value = parseFloat('' + itemValue);
          if (isNaN(value)) return false;

          switch (filter.operator) {
            case 'gt': return value > filter.value;
            case 'lt': return value < filter.value;
            case 'eq': return value === filter.value;
            case 'ltgt': return value >= filter.min && value <= filter.max;
            default: return true;
          }
        }

        return true;
      });
    });

    this.clearSelectionForFilteredOutRows();
    this.buildButtonsList(); // update buttons status

  }

  getVisibleRowCount(): number {
    return this.filteredRowIndices?.length || 0;
  }

  getVisibleSelectedCount(): number {
    if (!this.mapSelected || this.mapSelected.length === 0) return 0;
    const visibleRows = new Set(this.filteredRowIndices);
    return this.mapSelected.filter(ms => ms.row != null && visibleRows.has(ms.row)).length;
  }

  clearSelectionForFilteredOutRows(): void {
    if (!this.mapSelected || this.mapSelected.length === 0) return;

    const visibleRows = new Set(this.filteredRowIndices);
    const hadInEditFilteredOut = this.mapSelected.some(ms => ms.inEdit && ms.row != null && !visibleRows.has(ms.row));

    this.mapSelected = this.mapSelected.filter(ms => ms.row != null && visibleRows.has(ms.row));

    if (hadInEditFilteredOut) {
      this.closeEditLight();
    }
    this.checkDataOnSelection();
  }

  getFilterValue(column: string, type: string): any {
    let value;

    if (!this.activeFilters[column])
      return '';

    if (type == 'number') {
      value = this.activeFilters[column].value;
    }
    else {
      value = this.activeFilters[column];
    }

    return value;
  }

  getFilterType(col: DataSheet): string {
    if (col.colType == 'number')
      return 'number';
    else
      return 'text';
  }

  getColumnWidth(column: string) {
    return this.gridConfiguration.gridColumns?.find(gc => gc.name?.toLowerCase() == column.toLowerCase())?.width || this.DEFAULT_COL_WIDTH;
  }

}



